import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Cursor: { input: string; output: string };
  Date: { input: string; output: string };
  Delta: { input: any; output: any };
  EmailAddress: { input: any; output: any };
  JSON: { input: any; output: any };
  UserPropertyName: { input: any; output: any };
};

export enum AbExperimentVariant {
  Control = "control",
  Treatment = "treatment",
}

export type AcknowledgeAllNotificationsInput = {
  priority?: InputMaybe<NotificationPriorityInput>;
};

export type ActiveUsersRecord = {
  __typename: "ActiveUsersRecord";
  activeUsersIds: Array<Scalars["ID"]["output"]>;
  at: Scalars["Date"]["output"];
  count: Scalars["Int"]["output"];
  organizationId: Scalars["ID"]["output"];
};

export type ActivityAknowledgment = {
  acknowledgedAt: Scalars["Date"]["output"];
  entityId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  userId: Scalars["ID"]["output"];
};

export type AddAskHistoryMessagesInput = {
  answer: Scalars["String"]["input"];
  askHistoryId: Scalars["ID"]["input"];
  question: Scalars["String"]["input"];
};

export type AddCommentReactionInput = {
  commentId: Scalars["ID"]["input"];
  type: Scalars["String"]["input"];
};

export type AddCommentReactionOutput = {
  __typename: "AddCommentReactionOutput";
  comment: Comment;
};

export type AddDatabaseLinkInput = {
  databaseId: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
  recordKey: Scalars["ID"]["input"];
};

export type AddNoteReactionInput = {
  id: Scalars["ID"]["input"];
  type: Scalars["String"]["input"];
};

export type AddNoteReactionOutput = {
  __typename: "AddNoteReactionOutput";
  note: Note;
  /** @deprecated Use note.noteReactions instead */
  noteReactions: Array<NoteReaction>;
};

export type AddUserGroupMembersInput = {
  userGroupId: Scalars["ID"]["input"];
  usersToAdd: Array<Scalars["ID"]["input"]>;
};

export type AddUserGroupMembersOutput = {
  __typename: "AddUserGroupMembersOutput";
  userGroup: UserGroup;
};

export type Analytics = {
  browserStats?: InputMaybe<Scalars["JSON"]["input"]>;
  fbclid?: InputMaybe<Scalars["String"]["input"]>;
  firstAttribution?: InputMaybe<Attribution>;
  ga_clientid?: InputMaybe<Scalars["String"]["input"]>;
  gclid?: InputMaybe<Scalars["String"]["input"]>;
  marketingAttribution?: InputMaybe<Scalars["String"]["input"]>;
  orgCreationFlow?: InputMaybe<Scalars["String"]["input"]>;
  referrer?: InputMaybe<Scalars["String"]["input"]>;
  remoteStance?: InputMaybe<Scalars["String"]["input"]>;
  slt_device?: InputMaybe<Scalars["String"]["input"]>;
  utms?: InputMaybe<Utms>;
};

export type AnalyticsForRangeInput = {
  by: GroupByPeriod;
  endDate: Scalars["Date"]["input"];
  startDate: Scalars["Date"]["input"];
  weekStartsOn: Scalars["Int"]["input"];
};

export enum AnalyticsPeriod {
  AllTime = "ALL_TIME",
  Month = "MONTH",
  ThreeMonths = "THREE_MONTHS",
  TwoWeeks = "TWO_WEEKS",
  Week = "WEEK",
}

export type ApiKey = {
  __typename: "ApiKey";
  createdAt: Scalars["Date"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  lastUsedAt?: Maybe<Scalars["Date"]["output"]>;
  name: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type ApiKeyWithToken = {
  __typename: "ApiKeyWithToken";
  createdAt: Scalars["Date"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  lastUsedAt?: Maybe<Scalars["Date"]["output"]>;
  name: Scalars["String"]["output"];
  token: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type Application = Node & {
  __typename: "Application";
  clientId: Scalars["ID"]["output"];
  createdAt: Scalars["Date"]["output"];
  description: Scalars["String"]["output"];
  features: Array<ApplicationFeature>;
  id: Scalars["ID"]["output"];
  installationUrls: ApplicationInstallationUrls;
  integration?: Maybe<Integration>;
  isInstalled: Scalars["Boolean"]["output"];
  labels: ApplicationLabels;
  name: Scalars["String"]["output"];
  photoURL?: Maybe<Scalars["String"]["output"]>;
  unfurlRequiresPerUserAuthentication: Scalars["Boolean"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type ApplicationConnection = Connection & {
  __typename: "ApplicationConnection";
  edges: Array<ApplicationEdge>;
  nodes: Array<Application>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ApplicationEdge = Edge & {
  __typename: "ApplicationEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Application;
};

export enum ApplicationFeature {
  ShareTo = "shareTo",
  Unfurl = "unfurl",
}

export type ApplicationInstallationUrls = {
  __typename: "ApplicationInstallationUrls";
  organization: Scalars["String"]["output"];
};

export type ApplicationLabels = {
  __typename: "ApplicationLabels";
  shareToAction: Scalars["String"]["output"];
  shareToActionVerb: Scalars["String"]["output"];
  shareToSuccess: Scalars["String"]["output"];
  shareToSuccessLinkLabel: Scalars["String"]["output"];
  userConnectIncentive: Scalars["String"]["output"];
};

export type ApplicationShareSettings = {
  __typename: "ApplicationShareSettings";
  needsUserAssociation?: Maybe<UserAssociation>;
  targets?: Maybe<Array<ShareTarget>>;
};

export type ApplicationTarget = {
  label: Scalars["String"]["output"];
  subLabel?: Maybe<Scalars["String"]["output"]>;
};

export type ApplySuggestedTemplateOnNoteOutput = {
  __typename: "ApplySuggestedTemplateOnNoteOutput";
  note: Note;
};

export type ApplySuggestedTemplateOnNotePayload = {
  destinationNoteId: Scalars["ID"]["input"];
  publicShareToken: Scalars["String"]["input"];
};

export type ArchiveCommentInput = {
  commentId: Scalars["ID"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type AsanaIntegration = {
  __typename: "AsanaIntegration";
  id: Scalars["ID"]["output"];
  setupAt: Scalars["Date"]["output"];
  setupBy: User;
};

export type AsanaProject = {
  __typename: "AsanaProject";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  workspace: AsanaWorkspace;
};

export type AsanaWorkspace = {
  __typename: "AsanaWorkspace";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type AskFeedbackInput = {
  answer: Scalars["String"]["input"];
  feedbackExplanation: Scalars["String"]["input"];
  feedbackScore: Scalars["Int"]["input"];
  noteId?: InputMaybe<Scalars["ID"]["input"]>;
  question: Scalars["String"]["input"];
  sources: Array<AskFeedbackSource>;
};

export type AskFeedbackOutput = {
  __typename: "AskFeedbackOutput";
  success: Scalars["Boolean"]["output"];
};

export type AskFeedbackSource = {
  answerSimilarityScore: Scalars["Float"]["input"];
  noteId: Scalars["ID"]["input"];
  score: Scalars["Float"]["input"];
};

export type AskHistory = Node & {
  __typename: "AskHistory";
  createdAt: Scalars["Date"]["output"];
  createdBy: User;
  id: Scalars["ID"]["output"];
  rawState?: Maybe<Scalars["JSON"]["output"]>;
  superAssistant?: Maybe<SuperAssistant>;
  title?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
};

export type AskHistoryMessage = Node & {
  __typename: "AskHistoryMessage";
  answer: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  question: Scalars["String"]["output"];
};

export type AskPublicFeedbackInput = {
  answer: Scalars["String"]["input"];
  feedbackExplanation: Scalars["String"]["input"];
  feedbackScore: Scalars["Int"]["input"];
  noteId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId: Scalars["ID"]["input"];
  question: Scalars["String"]["input"];
  sources: Array<AskFeedbackSource>;
};

export type AskReportedQuestion = Node & {
  __typename: "AskReportedQuestion";
  answer: Scalars["String"]["output"];
  answeredAt?: Maybe<Scalars["Date"]["output"]>;
  answeredBy?: Maybe<User>;
  archivedAt?: Maybe<Scalars["Date"]["output"]>;
  askedBy?: Maybe<User>;
  assignedTo?: Maybe<User>;
  assignedToUserGroup?: Maybe<UserGroup>;
  createdAt: Scalars["Date"]["output"];
  fromPublicNote?: Maybe<Note>;
  fromSuperAssistant?: Maybe<SuperAssistant>;
  id: Scalars["ID"]["output"];
  issueDetected?: Maybe<AskReportedQuestionIssueDetected>;
  question: Scalars["String"]["output"];
  status?: Maybe<AskReportedQuestionStatus>;
  updatedAt: Scalars["Date"]["output"];
  userComment?: Maybe<Scalars["String"]["output"]>;
  userRating?: Maybe<AskReportedQuestionUserRating>;
};

export type AskReportedQuestionEdge = Edge & {
  __typename: "AskReportedQuestionEdge";
  cursor: Scalars["Cursor"]["output"];
  node: AskReportedQuestion;
};

export enum AskReportedQuestionIssueDetected {
  MissingAnswer = "MISSING_ANSWER",
}

export enum AskReportedQuestionSource {
  Internal = "internal",
  Public = "public",
}

export enum AskReportedQuestionStatus {
  Pending = "PENDING",
  Solved = "SOLVED",
}

export enum AskReportedQuestionUserRating {
  Bad = "BAD",
  Good = "GOOD",
}

export type AskReportedQuestionsConnection = Connection & {
  __typename: "AskReportedQuestionsConnection";
  edges: Array<AskReportedQuestionEdge>;
  nodes: Array<AskReportedQuestion>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type AssignAskReportedQuestionsInput = {
  assignedTo?: InputMaybe<Scalars["ID"]["input"]>;
  assignedToUserGroup?: InputMaybe<Scalars["ID"]["input"]>;
  ids: Array<Scalars["ID"]["input"]>;
};

export type AttioList = {
  __typename: "AttioList";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  private: Scalars["Boolean"]["output"];
};

export type AttioListOrObject = {
  __typename: "AttioListOrObject";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  private: Scalars["Boolean"]["output"];
  type: ExternalSourceSubtype;
};

export type AttioTeam = {
  __typename: "AttioTeam";
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  setupBy: User;
  updatedAt: Scalars["Date"]["output"];
  workspaceLogoUrl: Scalars["String"]["output"];
  workspaceName: Scalars["String"]["output"];
  workspaceSlug: Scalars["String"]["output"];
};

export type Attribution = {
  firstLandingUrl?: InputMaybe<Scalars["String"]["input"]>;
  firstReferrer?: InputMaybe<Scalars["String"]["input"]>;
  firstUtms?: InputMaybe<Utms>;
};

export type Audience = {
  __typename: "Audience";
  details: Array<Scalars["String"]["output"]>;
  source: ExternalSourceType;
};

export enum AuditEvent {
  NoteRead = "NOTE_READ",
  NoteWrite = "NOTE_WRITE",
  PublicNoteRead = "PUBLIC_NOTE_READ",
}

export type AuthInformation = {
  __typename: "AuthInformation";
  cookieClaims?: Maybe<CookieClaims>;
  currentStrategyClaims?: Maybe<Scalars["JSON"]["output"]>;
  selectedAuthStrategy: Scalars["String"]["output"];
};

export enum AuthMethod {
  EmailPassword = "emailPassword",
  Google = "google",
  OpenId = "openId",
}

export type AuthProvider = {
  __typename: "AuthProvider";
  clientId: Scalars["String"]["output"];
  clientSecret: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  url: Scalars["String"]["output"];
};

export type AuthProviderPublic = {
  __typename: "AuthProviderPublic";
  name: Scalars["String"]["output"];
};

export type AuthenticateWithNoteSharingCredentialsInput = {
  email: Scalars["EmailAddress"]["input"];
  hash: Scalars["String"]["input"];
};

export type AuthenticateWithNoteSharingCredentialsOutput = {
  __typename: "AuthenticateWithNoteSharingCredentialsOutput";
  jwt: Scalars["String"]["output"];
};

export enum AutomatedBackupSchedule {
  Daily = "daily",
  Monthly = "monthly",
  Weekly = "weekly",
}

export type BaseDiscussionParticipant = {
  addedAt: Scalars["Date"]["output"];
  addedBy: User;
  id: Scalars["ID"]["output"];
};

export type BillingCardUpdateInput = {
  setupIntentId?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use `setupIntentId` instead. */
  token?: InputMaybe<Scalars["String"]["input"]>;
};

export type BillingDetailsUpdateInput = {
  addressCity: Scalars["String"]["input"];
  addressCountry: Scalars["String"]["input"];
  addressLine1: Scalars["String"]["input"];
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  addressName: Scalars["String"]["input"];
  addressPostalCode: Scalars["String"]["input"];
  addressState?: InputMaybe<Scalars["String"]["input"]>;
  billingEmail: Scalars["String"]["input"];
  isCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
  vatId?: InputMaybe<Scalars["String"]["input"]>;
  vatType?: InputMaybe<StripeVatType>;
};

export enum BillingMethods {
  Fair = "fair",
  Manual = "manual",
  StrictSeats = "strictSeats",
}

export type BindSuperAssistantToSlackChannelInput = {
  slackChannelId: Scalars["ID"]["input"];
  superAssistantId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BookmarkNoteInput = {
  index?: InputMaybe<Scalars["Int"]["input"]>;
  noteId: Scalars["ID"]["input"];
};

export type BookmarkNoteOutput = {
  __typename: "BookmarkNoteOutput";
  userPreferences: UserPreferences;
};

export type CancelPlanSubscriptionInput = {
  cancelationReason: Scalars["String"]["input"];
  competitorChoice?: InputMaybe<Scalars["String"]["input"]>;
  feedback?: InputMaybe<Scalars["String"]["input"]>;
};

export type CardPaymentMethod = {
  __typename: "CardPaymentMethod";
  brand: Scalars["String"]["output"];
  expMonth: Scalars["Int"]["output"];
  expYear: Scalars["Int"]["output"];
  last4: Scalars["String"]["output"];
};

export type ChangeNoteDefaultRoleInput = {
  /**
   * Wether this value should cascade down the subtree of docs
   * When false, the default role will be set on the given doc only
   */
  cascading: Scalars["Boolean"]["input"];
  /**
   * This value is nullable so we can set the default role to null back again.
   *
   * If the default role is set to null for a given note, it might still get one
   * from one of its parents (the closest).
   */
  newRole?: InputMaybe<NoteDefaultRole>;
  noteId: Scalars["ID"]["input"];
};

export type ChangeNoteDefaultRoleOutput = {
  __typename: "ChangeNoteDefaultRoleOutput";
  note: Note;
};

export type Channel = Node &
  WithPermissions & {
    __typename: "Channel";
    activityAcknowledgement?: Maybe<ChannelActivityAknowledgment>;
    activityCount?: Maybe<Scalars["Int"]["output"]>;
    createdAt: Scalars["Date"]["output"];
    createdBy?: Maybe<User>;
    currentUserRole: ChannelMemberRole;
    defaultRole?: Maybe<ChannelMemberRole>;
    id: Scalars["ID"]["output"];
    isFavorite: Scalars["Boolean"]["output"];
    lastActivityAt?: Maybe<Scalars["Date"]["output"]>;
    lastActivityBy?: Maybe<Scalars["String"]["output"]>;
    lastActivityByUser?: Maybe<User>;
    memberships: ChannelMembershipConnection;
    name: Scalars["String"]["output"];
    notes: NoteConnection;
    orderByDirection: Scalars["String"]["output"];
    orderByField: Scalars["String"]["output"];
    organizationId: Scalars["ID"]["output"];
    permissions: ChannelPermissions;
    /**
     * Full blown public membership. Use lighter Channel.publicRole unless you need
     * specific details like creation date, role holder or the user who did enable
     * public sharing.
     */
    publicMembership?: Maybe<NoteMembership>;
    /** The channel's doc public role */
    publicRole?: Maybe<NotePublicRole>;
    /** @deprecated Use publicRole instead */
    publicShareToken?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use publicRole or publicMembership instead */
    publiclySharedAt?: Maybe<Scalars["Date"]["output"]>;
    purpose: ChannelPurpose;
    rootNote: Note;
    shareLink?: Maybe<Scalars["String"]["output"]>;
    type: ChannelType;
    updatedAt: Scalars["Date"]["output"];
  };

export type ChannelMembershipsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type ChannelNotesArgs = {
  order?: InputMaybe<NoteOrder>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ChannelActivityAknowledgment = ActivityAknowledgment & {
  __typename: "ChannelActivityAknowledgment";
  acknowledgedAt: Scalars["Date"]["output"];
  /** @deprecated Use acknowledgedAt instead, this one is a typo. */
  aknowledgedAt: Scalars["Date"]["output"];
  entityId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  userId: Scalars["ID"]["output"];
};

export type ChannelConnection = Connection & {
  __typename: "ChannelConnection";
  edges: Array<ChannelEdge>;
  nodes: Array<Channel>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ChannelCreationOutput = {
  __typename: "ChannelCreationOutput";
  channel: Channel;
};

export type ChannelEdge = Edge & {
  __typename: "ChannelEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Channel;
};

export type ChannelInput = {
  defaultRole?: InputMaybe<ChannelMemberRole>;
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  iconShape?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  type: ChannelType;
  userGroupsMemberships?: InputMaybe<Array<ChannelUserGroupMembershipInput>>;
  usersMemberships?: InputMaybe<Array<ChannelUserMembershipInput>>;
};

export type ChannelMember = {
  __typename: "ChannelMember";
  channel: Channel;
  id: Scalars["ID"]["output"];
  role: ChannelMemberRole;
  user: User;
};

export enum ChannelMemberRole {
  Admin = "admin",
  None = "none",
  Reader = "reader",
  Writer = "writer",
}

export type ChannelMembership = Node & {
  __typename: "ChannelMembership";
  cascading: Scalars["Boolean"]["output"];
  channel: Channel;
  id: Scalars["ID"]["output"];
  role: ChannelMemberRole;
  subject: ChannelMembershipSubject;
};

export type ChannelMembershipConnection = Connection & {
  __typename: "ChannelMembershipConnection";
  edges: Array<ChannelMembershipEdge>;
  id: Scalars["ID"]["output"];
  nodes: Array<ChannelMembership>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ChannelMembershipEdge = Edge & {
  __typename: "ChannelMembershipEdge";
  cursor: Scalars["Cursor"]["output"];
  node: ChannelMembership;
};

export type ChannelMembershipSubject = DefaultRole | User | UserGroup;

export type ChannelOrder = {
  direction?: InputMaybe<OrderDirection>;
  field?: InputMaybe<ChannelOrderField>;
};

export enum ChannelOrderField {
  /** Order by channel creation date */
  CreatedAt = "createdAt",
  /** Order by channel last activity date */
  LastActivityAt = "lastActivityAt",
  /** Order by channel name */
  Name = "name",
}

export type ChannelPermissions = Permissions & {
  __typename: "ChannelPermissions";
  /** @deprecated Not used anymore. */
  collaborate: Scalars["Boolean"]["output"];
  delete: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  manage: Scalars["Boolean"]["output"];
  organize: Scalars["Boolean"]["output"];
  read: Scalars["Boolean"]["output"];
  /** @deprecated Not used anymore. */
  sharePublicly: Scalars["Boolean"]["output"];
  /** @deprecated Not used anymore. */
  shareToIntegrations: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export enum ChannelPurpose {
  Categories = "categories",
  /** @deprecated Discussions have been removed */
  Discussions = "discussions",
  ExternalSources = "external_sources",
  Regular = "regular",
  Templates = "templates",
}

export type ChannelRoleChange = ChannelRoleRemoval | ChannelRoleSwitch;

export type ChannelRoleChangeInterface = {
  nextMembership?: Maybe<ChannelMembership>;
  nextRole: ChannelMemberRole;
  previousRole: ChannelMemberRole;
  subject: ChannelMembershipSubject;
};

export type ChannelRoleRemoval = ChannelRoleChangeInterface & {
  __typename: "ChannelRoleRemoval";
  channelId: Scalars["ID"]["output"];
  nextMembership?: Maybe<ChannelMembership>;
  nextRole: ChannelMemberRole;
  previousRole: ChannelMemberRole;
  subject: ChannelMembershipSubject;
};

export type ChannelRoleSwitch = ChannelRoleChangeInterface & {
  __typename: "ChannelRoleSwitch";
  channel?: Maybe<Channel>;
  nextMembership?: Maybe<ChannelMembership>;
  nextRole: ChannelMemberRole;
  previousRole: ChannelMemberRole;
  subject: ChannelMembershipSubject;
};

export enum ChannelTab {
  Recent = "recent",
  Sorted = "sorted",
}

export enum ChannelType {
  Personal = "personal",
  Private = "private",
  Public = "public",
  PublicReadOnly = "public_read_only",
}

export type ChannelUserGroupMembershipInput = {
  role: ChannelMemberRole;
  userGroupId: Scalars["ID"]["input"];
};

export type ChannelUserMembershipInput = {
  role: ChannelMemberRole;
  userId: Scalars["ID"]["input"];
};

export type ChannelWithRoleInfo = {
  __typename: "ChannelWithRoleInfo";
  channel: Channel;
  roleInfo: RoleInfo;
};

export type CheckExternalSourceWebsiteInput = {
  url: Scalars["String"]["input"];
};

export type ChildNoteAutomation = {
  __typename: "ChildNoteAutomation";
  author?: Maybe<User>;
  /** @deprecated Use author instead */
  authorId?: Maybe<Scalars["ID"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  noteId: Scalars["ID"]["output"];
  notify: Array<User>;
  schedule: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type ColdNotesConnection = Connection & {
  __typename: "ColdNotesConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export enum CollectionLayout {
  Board = "board",
  Gallery = "gallery",
  Table = "table",
}

export type CollectionSchema = {
  __typename: "CollectionSchema";
  id: Scalars["ID"]["output"];
};

export type CollectionScope = {
  __typename: "CollectionScope";
  blockId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  creator: User;
  filters: Scalars["JSON"]["output"];
  hiddenColumnKeys: Array<Scalars["String"]["output"]>;
  hiddenSelectOptionKeys: Array<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  layoutColumnKey?: Maybe<Scalars["String"]["output"]>;
  layoutType: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  note: Note;
  position: Scalars["Float"]["output"];
  sorts: Scalars["JSON"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export enum ColorModePreference {
  Dark = "dark",
  Light = "light",
  System = "system",
}

export type Comment = Node & {
  __typename: "Comment";
  archivedAt?: Maybe<Scalars["Date"]["output"]>;
  content: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  createdBy: Scalars["ID"]["output"];
  creator: User;
  decisionMaker?: Maybe<User>;
  entities?: Maybe<Scalars["JSON"]["output"]>;
  /** @deprecated Discussions should no longer be used through comments endpoints */
  highlights: Array<CommentHighlight>;
  id: Scalars["ID"]["output"];
  markedAsDecisionAt?: Maybe<Scalars["Date"]["output"]>;
  reactions: Array<CommentReaction>;
  thread: Thread;
  threadId: Scalars["ID"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type CommentEntitiesArgs = {
  enableRichText?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CommentArchivedSubscriptionOutput = {
  __typename: "CommentArchivedSubscriptionOutput";
  commentId: Scalars["ID"]["output"];
  inline?: Maybe<Scalars["Boolean"]["output"]>;
  thread?: Maybe<Thread>;
  threadId: Scalars["ID"]["output"];
};

export type CommentAskReportedQuestionInput = {
  comment: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type CommentCreationInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  entities?: InputMaybe<Scalars["JSON"]["input"]>;
  isDecision?: InputMaybe<Scalars["Boolean"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  threadId: Scalars["ID"]["input"];
};

export type CommentEditedSubscriptionOutput = {
  __typename: "CommentEditedSubscriptionOutput";
  comment: Comment;
};

export type CommentHighlight = {
  __typename: "CommentHighlight";
  count: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  rangeId: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  users: Array<User>;
};

export type CommentPublicAskReportedQuestionInput = {
  comment: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
};

export type CommentReaction = {
  __typename: "CommentReaction";
  count: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  type: Scalars["String"]["output"];
  users: Array<User>;
};

export type Configuration = {
  __typename: "Configuration";
  changelogUpdatedAt: Scalars["Date"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type ConfluenceApiAuthenticationInput = {
  apiToken: Scalars["String"]["input"];
  domainName: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
};

export type ConfluenceCloud = {
  __typename: "ConfluenceCloud";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type ConfluenceSpace = {
  __typename: "ConfluenceSpace";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type ConfluenceTeam = {
  __typename: "ConfluenceTeam";
  baseUrl: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  serverTitle?: Maybe<Scalars["String"]["output"]>;
  setupBy: User;
  updatedAt: Scalars["Date"]["output"];
};

export type Connection = {
  edges: Array<Edge>;
  nodes: Array<Node>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type Contact = {
  __typename: "Contact";
  displayName: Scalars["String"]["output"];
  email: Scalars["EmailAddress"]["output"];
  id: Scalars["String"]["output"];
  photoURL?: Maybe<Scalars["String"]["output"]>;
  provider?: Maybe<ContactProvider>;
};

export enum ContactProvider {
  Google = "google",
  Slack = "slack",
}

export type ContactUser = IUser & {
  __typename: "ContactUser";
  createdAt: Scalars["Date"]["output"];
  displayName: Scalars["String"]["output"];
  email: Scalars["EmailAddress"]["output"];
  id: Scalars["ID"]["output"];
  organization: Organization;
  photoURL?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  username: Scalars["String"]["output"];
};

export type ConvertNoteToChannelInput = {
  noteId: Scalars["ID"]["input"];
};

export type ConvertNoteToChannelOutput = {
  __typename: "ConvertNoteToChannelOutput";
  channel: Channel;
  note: Note;
};

export type ConvertNoteToCollectionInput = {
  noteId: Scalars["ID"]["input"];
};

export type ConvertNoteToCollectionOutput = {
  __typename: "ConvertNoteToCollectionOutput";
  note: Note;
};

export type CookieClaims = {
  __typename: "CookieClaims";
  claims?: Maybe<Scalars["JSON"]["output"]>;
  error?: Maybe<Scalars["String"]["output"]>;
};

export type Coupon = {
  __typename: "Coupon";
  amountOff?: Maybe<Scalars["Int"]["output"]>;
  duration: CouponDuration;
  durationInMonths?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  percentOff?: Maybe<Scalars["Float"]["output"]>;
  valid: Scalars["Boolean"]["output"];
};

export enum CouponDuration {
  Forever = "forever",
  Once = "once",
  Repeating = "repeating",
}

export type CreateAskHistoryInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  rawState: Scalars["JSON"]["input"];
  superAssistantId?: InputMaybe<Scalars["ID"]["input"]>;
  title: Scalars["String"]["input"];
};

export type CreateCollectionScopeInput = {
  blockId?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Cleaned collection from api */
  collectionSchemaId?: InputMaybe<Scalars["ID"]["input"]>;
  filters?: InputMaybe<Scalars["JSON"]["input"]>;
  hiddenColumnKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  hiddenSelectOptionKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  layoutColumnKey?: InputMaybe<Scalars["String"]["input"]>;
  layoutType?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  noteId: Scalars["ID"]["input"];
  position?: InputMaybe<Scalars["Float"]["input"]>;
  sorts?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type CreateCollectionScopeOutput = {
  __typename: "CreateCollectionScopeOutput";
  collectionScope: CollectionScope;
};

export type CreateEmailVerificationCodeInput = {
  email: Scalars["String"]["input"];
  fromSuper?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CreateEmailVerificationCodeOutput = {
  __typename: "CreateEmailVerificationCodeOutput";
  displayName: Scalars["String"]["output"];
  domain?: Maybe<Scalars["String"]["output"]>;
  isPopularDomain: Scalars["Boolean"]["output"];
  organizationName: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type CreateExternalSourceInput = {
  credentials?: InputMaybe<Scalars["String"]["input"]>;
  defaultRole?: InputMaybe<NoteDefaultRole>;
  externalId: Scalars["String"]["input"];
  externalName: Scalars["String"]["input"];
  externalSubtype?: InputMaybe<ExternalSourceSubtype>;
  externalType: ExternalSourceType;
};

export type CreateExternalSourcesInput = {
  externalSourceAttributes: Array<CreateExternalSourceInput>;
  ignoreExistingExternalSource?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CreateGitlabTeamInput = {
  accessToken: Scalars["String"]["input"];
};

export type CreateGoogleTeamInput = {
  adminEmail: Scalars["String"]["input"];
  domain: Scalars["String"]["input"];
};

export type CreateJoinTokenInput = {
  noteSettings?: InputMaybe<JoinTokenNoteSettings>;
  organizationRole: OrganizationRole;
};

export type CreateJoinTokenOutput = {
  __typename: "CreateJoinTokenOutput";
  joinToken: JoinToken;
};

export type CreateMediaOutput = {
  __typename: "CreateMediaOutput";
  media: Media;
};

export type CreateMicrosoftTeamInput = {
  clientId: Scalars["String"]["input"];
  secret: Scalars["String"]["input"];
  tenantId: Scalars["String"]["input"];
};

export type CreateNoteFromTeamTemplateInput = {
  parentNoteId: Scalars["ID"]["input"];
  templateId: Scalars["ID"]["input"];
};

export type CreateNoteFromTeamTemplateOutput = {
  __typename: "CreateNoteFromTeamTemplateOutput";
  note: Note;
};

export enum CreateNoteTrackingSource {
  Editor = "editor",
  Note = "note",
}

export type CreateNoteVideoInput = {
  noteId: Scalars["ID"]["input"];
  url: Scalars["String"]["input"];
};

export type CreateNoteVideoOutput = {
  __typename: "CreateNoteVideoOutput";
  noteVideo: NoteVideo;
};

export type CreateOrganizationInput = {
  analytics?: InputMaybe<Analytics>;
  /** @deprecated Use superEnabled instead */
  askStandaloneEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  docCacheKey?: InputMaybe<Scalars["String"]["input"]>;
  fromMobileApp?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationData?: InputMaybe<OrganizationData>;
  referralToken?: InputMaybe<Scalars["String"]["input"]>;
  returnTo?: InputMaybe<Scalars["String"]["input"]>;
  structureCacheKey?: InputMaybe<Scalars["String"]["input"]>;
  superEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  superTrialToken?: InputMaybe<Scalars["String"]["input"]>;
  userData: UserData;
};

export type CreateOrganizationOutput = {
  __typename: "CreateOrganizationOutput";
  url: Scalars["String"]["output"];
};

export type CreateOrganizationWithOauthCacheKeyInput = {
  analytics?: InputMaybe<Analytics>;
  /** @deprecated Use superEnabled instead */
  askStandaloneEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  cacheKey: Scalars["String"]["input"];
  fromAskXDesktopApp?: InputMaybe<Scalars["Boolean"]["input"]>;
  fromDesktopApp?: InputMaybe<Scalars["Boolean"]["input"]>;
  fromMobileApp?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationData?: InputMaybe<OrganizationData>;
  referralToken?: InputMaybe<Scalars["String"]["input"]>;
  superEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  superTrialToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateTemplateInput = {
  defaultCollectionLayout?: InputMaybe<CollectionLayout>;
  isCollection?: InputMaybe<Scalars["Boolean"]["input"]>;
  parentTemplateId?: InputMaybe<Scalars["ID"]["input"]>;
  title: Scalars["String"]["input"];
};

export type CssButtonSelector = {
  __typename: "CssButtonSelector";
  css: Scalars["String"]["output"];
};

export enum Currency {
  Eur = "eur",
  Usd = "usd",
}

export type CustomEmojis = {
  __typename: "CustomEmojis";
  id: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type Decision = Node & {
  __typename: "Decision";
  createdAt: Scalars["Date"]["output"];
  creator: User;
  discussion: Discussion;
  id: Scalars["ID"]["output"];
  reply: DiscussionReply;
  updatedAt: Scalars["Date"]["output"];
};

export type DecisionConnection = Connection & {
  __typename: "DecisionConnection";
  edges: Array<DecisionEdge>;
  nodes: Array<Decision>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type DecisionEdge = Edge & {
  __typename: "DecisionEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Decision;
};

export type DefaultChannelsTabInput = {
  channelId: Scalars["ID"]["input"];
  tab: ChannelTab;
};

export type DefaultRole = Node & {
  __typename: "DefaultRole";
  id: Scalars["ID"]["output"];
};

export type DeleteAskHistoryInput = {
  askHistoryId: Scalars["ID"]["input"];
};

export type DeleteAskHistoryOutput = {
  __typename: "DeleteAskHistoryOutput";
  id: Scalars["ID"]["output"];
};

export type DeleteCollectionScopeInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteCollectionScopeOutput = {
  __typename: "DeleteCollectionScopeOutput";
  success: Scalars["Boolean"]["output"];
};

export type DeleteGitlabTeamInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteGoogleTeamInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteJoinTokenInput = {
  joinTokenId: Scalars["ID"]["input"];
};

export type DeleteJoinTokenOutput = {
  __typename: "DeleteJoinTokenOutput";
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteMicrosoftTeamInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteNoteVideoInput = {
  id: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
};

export type DeleteNoteVideoOutput = {
  __typename: "DeleteNoteVideoOutput";
  success: Scalars["Boolean"]["output"];
};

export type DeleteOldAccessibleArchivedNotesOutput = {
  __typename: "DeleteOldAccessibleArchivedNotesOutput";
  success: Scalars["Boolean"]["output"];
};

export type DeleteSuperAssistantInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteSuperAssistantOutput = {
  __typename: "DeleteSuperAssistantOutput";
  id: Scalars["ID"]["output"];
};

export type DeleteSuperAutomationInput = {
  superAutomationId: Scalars["ID"]["input"];
};

export type DeleteSuperAutomationOutput = {
  __typename: "DeleteSuperAutomationOutput";
  id: Scalars["ID"]["output"];
};

export type DeleteSuperExtensionButtonInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteSuperExtensionButtonOutput = {
  __typename: "DeleteSuperExtensionButtonOutput";
  id: Scalars["ID"]["output"];
};

export enum DirectoryType {
  Grid = "grid",
  Hidden = "hidden",
  Simple = "simple",
  Structured = "structured",
}

export type DisableExtensionAssistantPresetInput = {
  id: Scalars["ID"]["input"];
};

export type DisableExtensionAssistantPresetOutput = {
  __typename: "DisableExtensionAssistantPresetOutput";
  preset: PublicExtensionAssistantPreset;
};

export type DisableGroupProvisioningInput = {
  userGroupId: Scalars["ID"]["input"];
};

export type DisableGroupProvisioningOutput = {
  __typename: "DisableGroupProvisioningOutput";
  success: Scalars["Boolean"]["output"];
  userGroup: UserGroup;
};

export type Discussion = Node & {
  __typename: "Discussion";
  /** @deprecated Use note.archivedAt instead */
  archivedAt?: Maybe<Scalars["Date"]["output"]>;
  backlinks: NoteBacklinksConnection;
  /** @deprecated Use note.createdAt instead */
  createdAt: Scalars["Date"]["output"];
  /** @deprecated Use note.author instead */
  creator: User;
  currentUserDiscussionStatus: UserDiscussionStatus;
  decision?: Maybe<Decision>;
  draftReply?: Maybe<DiscussionReply>;
  dueDate?: Maybe<Scalars["Date"]["output"]>;
  followers: Array<User>;
  hasUnread: Scalars["Boolean"]["output"];
  highlight?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isDraft: Scalars["Boolean"]["output"];
  /** @deprecated Use note.lastActivityAt instead */
  lastActivityAt: Scalars["Date"]["output"];
  /**
   * Media access token allow to access all the media linked to this note via the media proxy
   * It's mostly used by mobile editor which don't have access to the cookie
   */
  mediaAccessToken: Scalars["String"]["output"];
  note: Note;
  owner?: Maybe<User>;
  parentNote?: Maybe<Note>;
  /** @deprecated Use userOrGroupParticipants instead */
  participants: Array<User>;
  repliers: Array<User>;
  replies: DiscussionReplyConnection;
  repliesCount: Scalars["Int"]["output"];
  resolution?: Maybe<DiscussionResolution>;
  /** @deprecated Not used by frontend */
  summary?: Maybe<DiscussionSummary>;
  /** @deprecated Use note.title instead */
  title?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use note.updatedAt instead */
  updatedAt: Scalars["Date"]["output"];
  userOrGroupParticipants: Array<DiscussionParticipant>;
  visibility?: Maybe<DiscussionVisibility>;
};

export type DiscussionBacklinksArgs = {
  pagination: PaginationInput;
};

export type DiscussionRepliesArgs = {
  includeActivity?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination: PaginationInput;
};

export type DiscussionActivityAcknowledgment = ActivityAknowledgment & {
  __typename: "DiscussionActivityAcknowledgment";
  acknowledgedAt: Scalars["Date"]["output"];
  entityId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  noteId: Scalars["ID"]["output"];
  userId: Scalars["ID"]["output"];
};

export type DiscussionAddedParticipant = User | UserGroup;

export type DiscussionArchivedMetadata = {
  __typename: "DiscussionArchivedMetadata";
  archivedBy: User;
};

export type DiscussionConnection = Connection & {
  __typename: "DiscussionConnection";
  edges: Array<DiscussionEdge>;
  nodes: Array<Discussion>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type DiscussionDecidedReplyMetadata = {
  __typename: "DiscussionDecidedReplyMetadata";
  decider: User;
  replyOwner: User;
};

export type DiscussionDefaultRoleUpdatedMetadata = {
  __typename: "DiscussionDefaultRoleUpdatedMetadata";
  role?: Maybe<NoteUserRole>;
  updatedBy: User;
};

export type DiscussionDueDateUpdatedMetadata = {
  __typename: "DiscussionDueDateUpdatedMetadata";
  dueDate?: Maybe<Scalars["Date"]["output"]>;
  updatedBy: User;
};

/** Discussion connection */
export type DiscussionEdge = Edge & {
  __typename: "DiscussionEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Discussion;
};

export type DiscussionOwnerUpdatedMetadata = {
  __typename: "DiscussionOwnerUpdatedMetadata";
  owner: User;
  updatedBy: User;
};

export type DiscussionParticipant =
  | DiscussionUserGroupParticipant
  | DiscussionUserParticipant;

export type DiscussionParticipantAddedMetadata = {
  __typename: "DiscussionParticipantAddedMetadata";
  addedBy: User;
  /** @deprecated Use userOrGroupParticipants instead */
  participants: Array<User>;
  userOrGroupParticipants: Array<DiscussionAddedParticipant>;
};

export type DiscussionReopenReplyMetadata = {
  __typename: "DiscussionReopenReplyMetadata";
  opener: User;
};

export type DiscussionReply = Node & {
  __typename: "DiscussionReply";
  archivedAt?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  cursor: Scalars["Cursor"]["output"];
  discussion: Discussion;
  highlights: Array<DiscussionReplyHighlight>;
  id: Scalars["ID"]["output"];
  metadata: DiscussionReplyMetadata;
  reactions: Array<DiscussionReplyReaction>;
  updatedAt: Scalars["Date"]["output"];
};

export type DiscussionReplyConnection = {
  __typename: "DiscussionReplyConnection";
  edges: Array<DiscussionReplyEdge>;
  nodes: Array<DiscussionReply>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type DiscussionReplyEdge = Edge & {
  __typename: "DiscussionReplyEdge";
  cursor: Scalars["Cursor"]["output"];
  node: DiscussionReply;
};

export type DiscussionReplyHighlight = {
  __typename: "DiscussionReplyHighlight";
  count: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  rangeId: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
  users: Array<User>;
};

export type DiscussionReplyMetadata =
  | DiscussionArchivedMetadata
  | DiscussionDecidedReplyMetadata
  | DiscussionDefaultRoleUpdatedMetadata
  | DiscussionDueDateUpdatedMetadata
  | DiscussionOwnerUpdatedMetadata
  | DiscussionParticipantAddedMetadata
  | DiscussionReopenReplyMetadata
  | DiscussionRequestAccessMetadata
  | DiscussionResolveReplyMetadata
  | DiscussionRestoredMetadata
  | DiscussionTextReplyMetadata
  | DiscussionUnsupportedReplyMetadata;

export type DiscussionReplyReaction = {
  __typename: "DiscussionReplyReaction";
  count: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  type: Scalars["String"]["output"];
  users: Array<User>;
};

export type DiscussionRequestAccessMetadata = {
  __typename: "DiscussionRequestAccessMetadata";
  author: User;
  usersToGivePermissionTo: Array<User>;
};

export type DiscussionResolution = {
  __typename: "DiscussionResolution";
  id: Scalars["ID"]["output"];
  resolvedAt: Scalars["Date"]["output"];
  resolver: User;
};

export type DiscussionResolveReplyMetadata = {
  __typename: "DiscussionResolveReplyMetadata";
  resolver: User;
};

export type DiscussionRestoredMetadata = {
  __typename: "DiscussionRestoredMetadata";
  restoredBy: User;
};

export type DiscussionSummary = {
  __typename: "DiscussionSummary";
  content: Scalars["String"]["output"];
  entities?: Maybe<Scalars["JSON"]["output"]>;
};

export type DiscussionSummaryEntitiesArgs = {
  enableRichText?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DiscussionTextReplyMetadata = {
  __typename: "DiscussionTextReplyMetadata";
  author: User;
  content: Scalars["String"]["output"];
  decisionMaker?: Maybe<User>;
  entities?: Maybe<Scalars["JSON"]["output"]>;
  isDraft: Scalars["Boolean"]["output"];
  markedAsDecisionAt?: Maybe<Scalars["Date"]["output"]>;
};

export type DiscussionTextReplyMetadataEntitiesArgs = {
  enableRichText?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DiscussionUnsupportedReplyMetadata = {
  __typename: "DiscussionUnsupportedReplyMetadata";
  author?: Maybe<User>;
};

export type DiscussionUserGroupParticipant = BaseDiscussionParticipant & {
  __typename: "DiscussionUserGroupParticipant";
  addedAt: Scalars["Date"]["output"];
  addedBy: User;
  id: Scalars["ID"]["output"];
  userGroup: UserGroup;
};

export type DiscussionUserParticipant = BaseDiscussionParticipant & {
  __typename: "DiscussionUserParticipant";
  addedAt: Scalars["Date"]["output"];
  addedBy: User;
  id: Scalars["ID"]["output"];
  user: User;
};

export enum DiscussionVisibility {
  Restricted = "RESTRICTED",
  Visible = "VISIBLE",
}

export type DismissAskReportedQuestionsInput = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type DismissBrowserNotificationsHintOutPut = {
  __typename: "DismissBrowserNotificationsHintOutPut";
  userPreferences: UserPreferences;
};

export type DismissContextualTipInput = {
  tipId: Scalars["String"]["input"];
};

export type DismissContextualTipOutput = {
  __typename: "DismissContextualTipOutput";
  userPreferences: UserPreferences;
};

export type DismissNotificationsBannerOutPut = {
  __typename: "DismissNotificationsBannerOutPut";
  userPreferences: UserPreferences;
};

export type DuplicateNoteInput = {
  /** @deprecated Use parentNoteId only */
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  noteId: Scalars["ID"]["input"];
  parentNoteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type Edge = {
  cursor: Scalars["Cursor"]["output"];
  node: Node;
};

export type EditCommentInput = {
  commentId: Scalars["ID"]["input"];
  content: Scalars["String"]["input"];
  entities?: InputMaybe<Scalars["JSON"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmailAndPassword = {
  email: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  password: Scalars["String"]["input"];
};

export enum EmailHandler {
  Google = "google",
  Unknown = "unknown",
}

export type EmailHandlerOutput = {
  __typename: "EmailHandlerOutput";
  handler: EmailHandler;
};

export type EmailUser = Node & {
  __typename: "EmailUser";
  email: Scalars["EmailAddress"]["output"];
  id: Scalars["ID"]["output"];
};

export enum EmbedType {
  Asana = "asana",
  Clickup = "clickup",
  Github = "github",
  Jira = "jira",
  Linear = "linear",
  Trello = "trello",
}

export type EmptyNotesConnection = Connection & {
  __typename: "EmptyNotesConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type EnableExtensionAssistantPresetInput = {
  id: Scalars["ID"]["input"];
};

export type EnableExtensionAssistantPresetOutput = {
  __typename: "EnableExtensionAssistantPresetOutput";
  preset: PublicExtensionAssistantPreset;
};

export type EnableGroupProvisioningInput = {
  userGroupId: Scalars["ID"]["input"];
};

export type EnableGroupProvisioningOutput = {
  __typename: "EnableGroupProvisioningOutput";
  success: Scalars["Boolean"]["output"];
  userGroup: UserGroup;
};

export type ExpirationPeriodTuple = {
  __typename: "ExpirationPeriodTuple";
  period: NoteReviewStateExpirationPeriod;
  unit: Scalars["Int"]["output"];
};

export type ExpirationPeriodTupleInput = {
  period: NoteReviewStateExpirationPeriod;
  unit: Scalars["Int"]["input"];
};

export type ExternalSource = {
  __typename: "ExternalSource";
  createdAt: Scalars["Date"]["output"];
  createdBy: User;
  enabled: Scalars["Boolean"]["output"];
  externalId: Scalars["String"]["output"];
  externalSubtype?: Maybe<ExternalSourceSubtype>;
  externalType: ExternalSourceType;
  frequencyInHours: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  indexedUnitsCount: Scalars["Int"]["output"];
  lastImportCompletedAt?: Maybe<Scalars["Date"]["output"]>;
  lastImportStartedAt?: Maybe<Scalars["Date"]["output"]>;
  mapping?: Maybe<Array<Maybe<GenericMapping>>>;
  message?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  synchronizationDate?: Maybe<Scalars["Date"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  url: Scalars["String"]["output"];
};

export enum ExternalSourceSubtype {
  AttioList = "AttioList",
  AttioObject = "AttioObject",
}

export enum ExternalSourceType {
  Asana = "Asana",
  Attio = "Attio",
  Confluence = "CONFLUENCE",
  Custom = "Custom",
  Files = "FILES",
  GoogleDrive = "GOOGLE_DRIVE",
  Git = "Git",
  GitHub = "GitHub",
  GitLab = "GitLab",
  Hubspot = "Hubspot",
  Intercom = "Intercom",
  Jira = "Jira",
  Linear = "LINEAR",
  Notion = "NOTION",
  Sharepoint = "SHAREPOINT",
  SlackChannel = "SLACK_CHANNEL",
  Slite = "SLITE",
  Website = "WEBSITE",
}

export type ExternalSourceWebsiteCheck = {
  __typename: "ExternalSourceWebsiteCheck";
  id: Scalars["ID"]["output"];
  plugin?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export type FavoriteChannelInput = {
  channelId: Scalars["ID"]["input"];
  index?: InputMaybe<Scalars["Int"]["input"]>;
};

export type FavoriteChannelOutput = {
  __typename: "FavoriteChannelOutput";
  userPreferences: UserPreferences;
};

export type FavoriteSuperAssistantInput = {
  superAssistantId: Scalars["ID"]["input"];
};

export type FavoriteSuperAssistantOutput = {
  __typename: "FavoriteSuperAssistantOutput";
  userPreferences: UserPreferences;
};

export type FetchGoogleDriveFileMetadataInput = {
  url: Scalars["String"]["input"];
};

export type FetchGoogleDriveSharedOutput = {
  __typename: "FetchGoogleDriveSharedOutput";
  sharedDrives: Array<SharedDrive>;
};

export type FileImportFailedOutput = {
  __typename: "FileImportFailedOutput";
  /** @deprecated Use targetNoteName instead. This now contains the targetNoteName anyway. */
  channelName: Scalars["String"]["output"];
  /** @deprecated Unused in the frontend */
  fileName: Scalars["String"]["output"];
  seed: Scalars["String"]["output"];
  targetNoteId?: Maybe<Scalars["String"]["output"]>;
  targetNoteName?: Maybe<Scalars["String"]["output"]>;
};

export type FileImportFinishedOutput = {
  __typename: "FileImportFinishedOutput";
  /** @deprecated Use targetNoteId instead. This now contains the targetNoteId anyway. */
  channelId: Scalars["ID"]["output"];
  /** @deprecated Use targetNoteName instead. This now contains the targetNoteName anyway. */
  channelName: Scalars["String"]["output"];
  importedNoteId?: Maybe<Scalars["String"]["output"]>;
  seed: Scalars["String"]["output"];
  targetNoteId?: Maybe<Scalars["String"]["output"]>;
  targetNoteName?: Maybe<Scalars["String"]["output"]>;
};

export type FileImportProgressOutput = {
  __typename: "FileImportProgressOutput";
  importStartedAt: Scalars["Date"]["output"];
  processedNotes: Scalars["Int"]["output"];
  seed: Scalars["String"]["output"];
  totalNotes: Scalars["Int"]["output"];
};

export enum FileImportSource {
  Confluence = "confluence",
  Evernote = "evernote",
  GoogleDrive = "google_drive",
  Html = "html",
  ManualUpload = "manual_upload",
  Notion = "notion",
  Quip = "quip",
}

export enum FileType {
  Doc = "doc",
  Docx = "docx",
  Html = "html",
  Markdown = "markdown",
  Pdf = "pdf",
  Zip = "zip",
}

export type FileUrlInput = {
  creationSource?: InputMaybe<FileImportSource>;
  importedFrom?: InputMaybe<FileImportSource>;
  name: Scalars["String"]["input"];
  type: FileType;
  url: Scalars["String"]["input"];
};

export type FollowThreadInput = {
  id: Scalars["ID"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type FollowThreadOutput = {
  __typename: "FollowThreadOutput";
  thread: Thread;
};

export type GenerateScopedTokenInput = {
  scope: TokenScope;
};

export type GenerateScopedTokenOutput = {
  __typename: "GenerateScopedTokenOutput";
  token: Scalars["String"]["output"];
};

export type GenerateSearchTokenOutput = {
  __typename: "GenerateSearchTokenOutput";
  organizationId: Scalars["String"]["output"];
  token: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
};

export type GenerateWebAuthNChallengeForLoginInput = {
  organizationId: Scalars["String"]["input"];
};

export type GenerateWebAuthNChallengeForLoginOutput = {
  __typename: "GenerateWebAuthNChallengeForLoginOutput";
  allowCredentials: Array<WebAuthNAllowCredential>;
  challenge: Scalars["String"]["output"];
  encryptedChallenge: Scalars["String"]["output"];
  rpId: Scalars["String"]["output"];
  timeout: Scalars["Int"]["output"];
  userVerification: WebAuthNUserVerification;
};

export type GenerateWebAuthNChallengeForRegistrationOutput = {
  __typename: "GenerateWebAuthNChallengeForRegistrationOutput";
  attestation: WebAuthNAttestation;
  authenticatorSelection: WebAuthNAuthenticatorSelection;
  challenge: Scalars["String"]["output"];
  encryptedChallenge: Scalars["String"]["output"];
  pubKeyCredParams: Array<WebAuthNPubKeyParam>;
  rp: WebAuthNChallengeRp;
  timeout: Scalars["Int"]["output"];
  user: WebAuthNUser;
};

export type GenericMapping = {
  __typename: "GenericMapping";
  description?: Maybe<Scalars["String"]["output"]>;
  disabled?: Maybe<Scalars["Boolean"]["output"]>;
  key: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
};

export type GetApplicationNoteHandlingInput = {
  clientId: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
};

export type GetApplicationNoteHandlingOutput = {
  __typename: "GetApplicationNoteHandlingOutput";
  data?: Maybe<Scalars["JSON"]["output"]>;
};

export type GetApplicationsInput = {
  excludeInstalled?: Scalars["Boolean"]["input"];
  pagination?: InputMaybe<PaginationInput>;
};

export type GetAsanaProjectsOutput = {
  __typename: "GetAsanaProjectsOutput";
  projects: Array<AsanaProject>;
};

export type GetAttioListsAndObjectsOutput = {
  __typename: "GetAttioListsAndObjectsOutput";
  listsAndObjects: Array<AttioListOrObject>;
};

export type GetAttioListsOutput = {
  __typename: "GetAttioListsOutput";
  lists: Array<AttioList>;
};

export type GetAvailableSourceTypeOutput = {
  __typename: "GetAvailableSourceTypeOutput";
  availableSourceTypes: Array<ExternalSourceType>;
};

export type GetCheckoutUrlInput = {
  interval: PlanInterval;
};

export type GetConfluenceSpacesOutput = {
  __typename: "GetConfluenceSpacesOutput";
  spaces: Array<ConfluenceSpace>;
};

export type GetContactsInput = {
  blacklistedEmails?: InputMaybe<Array<Scalars["String"]["input"]>>;
  maxResults?: InputMaybe<Scalars["Int"]["input"]>;
  provider: ContactProvider;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetContactsOutput = {
  __typename: "GetContactsOutput";
  contacts: Array<Contact>;
};

export type GetExternalSourcesInput = {
  sourceType?: InputMaybe<ExternalSourceType>;
};

export type GetFileUploadUrlInput = {
  bucket: UploadBucket;
  folder: UploadDestinationFolder;
  name: Scalars["String"]["input"];
  size?: InputMaybe<Scalars["Float"]["input"]>;
  type: Scalars["String"]["input"];
};

export type GetFileUploadUrlOutput = {
  __typename: "GetFileUploadUrlOutput";
  readUrl: Scalars["String"]["output"];
  uploadUrl: Scalars["String"]["output"];
};

export type GetGithubRepositoriesOutput = {
  __typename: "GetGithubRepositoriesOutput";
  repositories: Array<GithubRepositories>;
};

export type GetGitlabProjectsOutput = {
  __typename: "GetGitlabProjectsOutput";
  projects: Array<GitlabProject>;
};

export type GetGoogleDriveChildrenInput = {
  hitsPerPage?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  nextPageToken?: InputMaybe<Scalars["String"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type GetGoogleDriveChildrenOutput = {
  __typename: "GetGoogleDriveChildrenOutput";
  hits: Array<GoogleDriveChildren>;
  nextPageToken?: Maybe<Scalars["String"]["output"]>;
};

export type GetJiraProjectsOutput = {
  __typename: "GetJiraProjectsOutput";
  projects: Array<JiraProject>;
};

export type GetLinearTeamsInput = {
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetLinearTeamsOutput = {
  __typename: "GetLinearTeamsOutput";
  teams: Array<LinearTeam>;
};

export type GetMuxVideoPlaybackUrlInput = {
  uploadId: Scalars["String"]["input"];
};

export type GetMuxVideoPlaybackUrlOutput = {
  __typename: "GetMuxVideoPlaybackUrlOutput";
  url: Scalars["String"]["output"];
};

export type GetMuxVideoUploadUrlInput = {
  noteId: Scalars["ID"]["input"];
};

export type GetMuxVideoUploadUrlOutput = {
  __typename: "GetMuxVideoUploadUrlOutput";
  id: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type GetNoteCountAndPercentageByReviewStateInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  noteReviewStateList: Array<NoteReviewState>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GetNoteCountAndPercentageByReviewStateOutput = {
  __typename: "GetNoteCountAndPercentageByReviewStateOutput";
  subsetCount?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Too heavy to compute. Now returns 0 */
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GetNotionChildrenInput = {
  depth?: InputMaybe<Scalars["Int"]["input"]>;
  hitsPerPage?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  rootId: Scalars["ID"]["input"];
};

export type GetNotionChildrenOutput = {
  __typename: "GetNotionChildrenOutput";
  hits: Array<NotionChildren>;
  nbPages: Scalars["Int"]["output"];
  page: Scalars["Int"]["output"];
};

export type GetOnboardingTemplatesOutput = {
  __typename: "GetOnboardingTemplatesOutput";
  templateCategories: Array<TemplateCategory>;
};

export type GetPublicExtensionAssistantPresetInput = {
  id: Scalars["ID"]["input"];
};

export type GetPublicExtensionAssistantPresetsInput = {
  integration: SuperExtensionButtonIntegrationType;
};

export type GetSharepointSitesInput = {
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetSharepointSitesOutput = {
  __typename: "GetSharepointSitesOutput";
  sites: Array<SharepointSite>;
};

export type GetSlackConversationsOutput = {
  __typename: "GetSlackConversationsOutput";
  slackConversations: Array<SlackConversations>;
};

export type GetSlackJoinedChannelsOutput = {
  __typename: "GetSlackJoinedChannelsOutput";
  slackChannels: Array<SlackConversations>;
};

export type GetSlackJoinedPublicChannelsOutput = {
  __typename: "GetSlackJoinedPublicChannelsOutput";
  slackPublicChannels: Array<SlackConversations>;
};

export type GetSlackPublicChannelsForBotOutput = {
  __typename: "GetSlackPublicChannelsForBotOutput";
  slackPublicChannels: Array<SlackConversations>;
};

export type GetSuperExtensionButtonsInput = {
  integration?: InputMaybe<SuperExtensionButtonIntegrationType>;
};

export type GetWikiChildrenInput = {
  depth?: InputMaybe<Scalars["Int"]["input"]>;
  hitsPerPage?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  rootId: Scalars["ID"]["input"];
  sourceType: WikiSourceType;
};

export type GetWikiChildrenOutput = {
  __typename: "GetWikiChildrenOutput";
  hits: Array<WikiChildren>;
  nbPages: Scalars["Int"]["output"];
  page: Scalars["Int"]["output"];
};

export type GithubRepositories = {
  __typename: "GithubRepositories";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  owner: Scalars["String"]["output"];
  private: Scalars["Boolean"]["output"];
  url: Scalars["String"]["output"];
};

export type GithubTeam = {
  __typename: "GithubTeam";
  accountHtmlUrl: Scalars["String"]["output"];
  accountLogin: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  setupBy: User;
  updatedAt: Scalars["Date"]["output"];
};

export type GitlabProject = {
  __typename: "GitlabProject";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  namespace: Scalars["String"]["output"];
  private: Scalars["Boolean"]["output"];
  url: Scalars["String"]["output"];
};

export type GoogleDriveChildren = {
  __typename: "GoogleDriveChildren";
  id: Scalars["ID"]["output"];
  lastEditedAt: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type GoogleDriveFileIdInput = {
  creationSource?: InputMaybe<FileImportSource>;
  id: Scalars["ID"]["input"];
  importedFrom?: InputMaybe<FileImportSource>;
};

export type GoogleDriveFileMetadata = {
  __typename: "GoogleDriveFileMetadata";
  createdBy: Scalars["String"]["output"];
  createdDate: Scalars["Date"]["output"];
  embedLink: Scalars["String"]["output"];
  iconLink: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export enum GroupByPeriod {
  Day = "DAY",
  Month = "MONTH",
  None = "NONE",
  Week = "WEEK",
  Year = "YEAR",
}

export type HubspotTeam = {
  __typename: "HubspotTeam";
  createdAt: Scalars["Date"]["output"];
  hubDomain: Scalars["String"]["output"];
  hubId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  setupBy: User;
  updatedAt: Scalars["Date"]["output"];
  user: Scalars["String"]["output"];
  userId: Scalars["String"]["output"];
};

export type INoteReviewState = {
  changedAt?: Maybe<Scalars["Date"]["output"]>;
  changedBy?: Maybe<User>;
  currentState: NoteReviewState;
  id: Scalars["ID"]["output"];
  /** @deprecated Use ownedBy instead */
  managedBy: User;
  ownedBy: UserOrUserGroup;
};

export type IUser = {
  createdAt: Scalars["Date"]["output"];
  displayName: Scalars["String"]["output"];
  email: Scalars["EmailAddress"]["output"];
  id: Scalars["ID"]["output"];
  organization: Organization;
  photoURL?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  username: Scalars["String"]["output"];
};

export type IdentifyGenericUserPropertiesInput = {
  /** payload is a stringified JSON */
  payload: Scalars["String"]["input"];
};

export type IdentifyGenericUserPropertiesOutput = {
  __typename: "IdentifyGenericUserPropertiesOutput";
  success: Scalars["Boolean"]["output"];
};

export type ImportArchiveInput = {
  archiveUrl: Scalars["String"]["input"];
  source: FileImportSource;
  targetParentNoteId: Scalars["ID"]["input"];
};

export type ImportArchiveOutput = {
  __typename: "ImportArchiveOutput";
  seed?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type ImportDocumentsFromConfluenceSpaceInput = {
  channelId: Scalars["ID"]["input"];
  spaceKey: Scalars["String"]["input"];
};

export type ImportFilesFromFileUrlInput = {
  channelId: Scalars["ID"]["input"];
  fileList: Array<FileUrlInput>;
  replaceExistingTarget?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ImportFilesFromFileUrlOutput = {
  __typename: "ImportFilesFromFileUrlOutput";
  seed?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ImportFilesFromGoogleDriveInput = {
  /** @deprecated use targetParentNoteId instead */
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated use fileList instead */
  fileIdList?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  fileList?: InputMaybe<Array<GoogleDriveFileIdInput>>;
  replaceExistingTarget?: InputMaybe<Scalars["Boolean"]["input"]>;
  targetParentNoteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ImportFilesFromTextFileUrlInput = {
  channelId: Scalars["ID"]["input"];
  fileList: Array<FileUrlInput>;
};

export type ImportPublicChannelInput = {
  channelId: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  type: ChannelType;
  userIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ImportPublicChannelOutput = {
  __typename: "ImportPublicChannelOutput";
  channel: Channel;
};

export type ImportPublicNoteFromIdInput = {
  destinationNoteId: Scalars["ID"]["input"];
  from?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["String"]["input"];
};

export type ImportPublicNoteFromIdOutput = {
  __typename: "ImportPublicNoteFromIdOutput";
  rootCreatedNote: Note;
};

export type ImportPublicNoteInput = {
  /** @deprecated Use destinationNoteId only */
  destinationChannelId?: InputMaybe<Scalars["ID"]["input"]>;
  destinationNoteId?: InputMaybe<Scalars["ID"]["input"]>;
  from?: InputMaybe<Scalars["String"]["input"]>;
  publicShareToken: Scalars["String"]["input"];
};

export type ImportPublicNoteOutput = {
  __typename: "ImportPublicNoteOutput";
  rootCreatedNote?: Maybe<Note>;
};

export type ImportSlackExportInput = {
  channelList: Array<Scalars["String"]["input"]>;
  exportUrl: Scalars["String"]["input"];
};

export type ImportSlackExportOutput = {
  __typename: "ImportSlackExportOutput";
  success: Scalars["Boolean"]["output"];
};

export type ImportStatus = {
  __typename: "ImportStatus";
  id: Scalars["String"]["output"];
  processedCount?: Maybe<Scalars["Int"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type InactiveNotesConnection = Connection & {
  __typename: "InactiveNotesConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type IndexAskReportedQuestionAnswerInput = {
  noteId: Scalars["ID"]["input"];
};

export type IndexAskReportedQuestionAnswerOutput = {
  __typename: "IndexAskReportedQuestionAnswerOutput";
  indexed: Scalars["Boolean"]["output"];
};

export type Integration = Node & {
  __typename: "Integration";
  application: Application;
  createdAt: Scalars["Date"]["output"];
  createdBy: User;
  hasAuthenticationForUser: Scalars["Boolean"]["output"];
  hasIntegrationActivitySupport: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  organization: Organization;
  type: Scalars["String"]["output"];
  unfurlPatterns: Array<Scalars["String"]["output"]>;
};

export type IntegrationHasAuthenticationForUserArgs = {
  userId: Scalars["ID"]["input"];
};

export type IntegrationConnection = Connection & {
  __typename: "IntegrationConnection";
  edges: Array<IntegrationEdge>;
  nodes: Array<Integration>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type IntegrationEdge = Edge & {
  __typename: "IntegrationEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Integration;
};

export type InteractionsCount = {
  __typename: "InteractionsCount";
  count: Scalars["Int"]["output"];
  startDate: Scalars["Date"]["output"];
};

export type InteractionsCountInput = {
  byUniqueUser: Scalars["Boolean"]["input"];
  excludeRoles?: InputMaybe<Array<OrganizationRole>>;
  filterByChannelId?: InputMaybe<Scalars["ID"]["input"]>;
  groupByPeriod: GroupByPeriod;
  sinceDate?: InputMaybe<Scalars["Date"]["input"]>;
  toDate?: InputMaybe<Scalars["Date"]["input"]>;
  type: InteractionsCountType;
};

export enum InteractionsCountType {
  AllReaders = "ALL_READERS",
  AllUsers = "ALL_USERS",
  Ask = "ASK",
  CreateDoc = "CREATE_DOC",
  DroppedFromSearchResults = "DROPPED_FROM_SEARCH_RESULTS",
  NavigateFromSearchResults = "NAVIGATE_FROM_SEARCH_RESULTS",
  SuperQuery = "SUPER_QUERY",
}

export type InviteCreationInput = {
  channelMemberships?: InputMaybe<Array<InviteeChannelMembershipInput>>;
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  initialNote?: InputMaybe<Scalars["ID"]["input"]>;
  isContact?: InputMaybe<Scalars["Boolean"]["input"]>;
  noteMemberships?: InputMaybe<Array<InviteeNoteMembershipInput>>;
  organizationRole?: InputMaybe<OrganizationRole>;
};

export enum InviteReminderType {
  First = "first",
  FirstInviterReminder = "firstInviterReminder",
  Second = "second",
  SecondInviterReminder = "secondInviterReminder",
  Third = "third",
}

export type InviteeChannelMembershipInput = {
  channelId: Scalars["ID"]["input"];
  role?: InputMaybe<ChannelMemberRole>;
};

export type InviteeNoteMembershipInput = {
  cascading: Scalars["Boolean"]["input"];
  noteId: Scalars["ID"]["input"];
  role: NoteUserRole;
};

export type Invoice = {
  __typename: "Invoice";
  amount: Scalars["Int"]["output"];
  date: Scalars["Date"]["output"];
  hostedInvoiceUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  number: Scalars["String"]["output"];
  pdfUrl?: Maybe<Scalars["String"]["output"]>;
  status: InvoiceStatus;
};

export enum InvoiceStatus {
  Draft = "draft",
  Due = "due",
  Paid = "paid",
}

export type JiraProject = {
  __typename: "JiraProject";
  id: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type JiraTeam = {
  __typename: "JiraTeam";
  baseUrl: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  serverTitle?: Maybe<Scalars["String"]["output"]>;
  setupBy: User;
  updatedAt: Scalars["Date"]["output"];
};

export type JoinToken = Node & {
  __typename: "JoinToken";
  createdAt: Scalars["Date"]["output"];
  /** Could be null if the creator has been deleted. In that case we still keep the join token alive. */
  createdBy?: Maybe<User>;
  /** The token's value */
  id: Scalars["ID"]["output"];
  note?: Maybe<Note>;
  noteUserRole?: Maybe<NoteUserRole>;
  organizationRole: OrganizationRole;
  /** so clients don't have to generate one */
  url: Scalars["String"]["output"];
};

export type JoinTokenConnection = Connection & {
  __typename: "JoinTokenConnection";
  edges: Array<JoinTokenEdge>;
  nodes: Array<JoinToken>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type JoinTokenEdge = Edge & {
  __typename: "JoinTokenEdge";
  cursor: Scalars["Cursor"]["output"];
  node: JoinToken;
};

export type JoinTokenNoteSettings = {
  noteId: Scalars["ID"]["input"];
  noteUserRole: NoteUserRole;
};

export type LinearIntegration = {
  __typename: "LinearIntegration";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  setupAt: Scalars["Date"]["output"];
  setupBy: User;
};

export type LinearTeam = {
  __typename: "LinearTeam";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  private: Scalars["Boolean"]["output"];
};

export type LinkSlackChannelInput = {
  noteId: Scalars["ID"]["input"];
  slackChannelId: Scalars["String"]["input"];
};

export type LinkedSlackChannel = {
  __typename: "LinkedSlackChannel";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  teamId: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ListAskHistoriesOutput = {
  __typename: "ListAskHistoriesOutput";
  askHistories?: Maybe<Array<AskHistory>>;
};

export type ListChannelsSharedWithGuestInput = {
  guestId: Scalars["ID"]["input"];
};

export type ListSuperSourcesMetaInput = {
  stage?: InputMaybe<SuperSourceStage>;
};

export type MarkAsSolvedAskReportedQuestionsInput = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MarkCommentAsDecisionInput = {
  commentId: Scalars["ID"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarkCommentAsDecisionOutput = {
  __typename: "MarkCommentAsDecisionOutput";
  comment: Comment;
};

export type MarkCommentAsUnreadInput = {
  commentId: Scalars["ID"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarkCommentAsUnreadOutput = {
  __typename: "MarkCommentAsUnreadOutput";
  thread: Thread;
};

export type Media = {
  __typename: "Media";
  createdAt: Scalars["Date"]["output"];
  createdBy: Scalars["ID"]["output"];
  creator: User;
  id: Scalars["ID"]["output"];
  meta?: Maybe<Scalars["JSON"]["output"]>;
  name: Scalars["String"]["output"];
  note: Note;
  noteId?: Maybe<Scalars["ID"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  url: Scalars["String"]["output"];
};

export type MediaCreationInput = {
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  name: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type MessyNotesConnection = Connection & {
  __typename: "MessyNotesConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type MoveChannelToInput = {
  channelId: Scalars["ID"]["input"];
  parentNoteId: Scalars["ID"]["input"];
  position?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MoveChannelToOutput = {
  __typename: "MoveChannelToOutput";
  movedNotes: Array<Maybe<Note>>;
};

export type Mutation = {
  __typename: "Mutation";
  acknowledgeAllNotifications: NotificationsUpdate;
  acknowledgeNotifications: NotificationsUpdate;
  addAskHistoryMessages: AskHistory;
  addCommentReaction: AddCommentReactionOutput;
  /** Adds a new comment to an existing thread */
  addCommentToThread: Thread;
  addMembersToUserGroup: AddUserGroupMembersOutput;
  addNoteReaction: AddNoteReactionOutput;
  aknowledgeChannelActivity?: Maybe<ChannelActivityAknowledgment>;
  aknowledgeNoteActivity?: Maybe<NoteActivityAknowledgment>;
  aknowledgeThreadsActivity?: Maybe<Array<Maybe<ThreadActivityAknowledgment>>>;
  applyPublicNoteOnNote: ApplyPublicNoteOnNoteOutput;
  /** @deprecated Use applyPublicNoteOnNote instead */
  applySuggestedTemplateOnNote: ApplySuggestedTemplateOnNoteOutput;
  applyTemplateOnNote: Note;
  /** Allows to mark a comment as archived so it's no longer listed under a thread */
  archiveComment: Comment;
  archiveNotes: Array<Maybe<Note>>;
  /** Flag a thread as archived */
  archiveThread: Thread;
  archiveUser?: Maybe<User>;
  assignAskReportedQuestions: Array<AskReportedQuestion>;
  assignSuperSeat?: Maybe<User>;
  /**
   * Authenticate with a shared note email,hash tuple obtained through email sharing
   * Upon success this will set a jwt token on the users' cookies to be used for subsequent calls.
   * It will also return the jwt token for now to allow connections to other services (like collab subscriptions)
   */
  authenticateWithNoteSharingCredentials: AuthenticateWithNoteSharingCredentialsOutput;
  backupAndArchiveMe?: Maybe<Scalars["Boolean"]["output"]>;
  bindSuperAssistantToSlackChannel: SuperAssistantSlackChannelBinding;
  bookmarkNote: BookmarkNoteOutput;
  cancelPlanSubscription: PaymentInfos;
  changeNoteDefaultRole: ChangeNoteDefaultRoleOutput;
  commentAskReportedQuestion: AskReportedQuestion;
  commentPublicAskReportedQuestion: AskReportedQuestion;
  convertNoteToChannel: ConvertNoteToChannelOutput;
  convertNoteToNewCollection: ConvertNoteToCollectionOutput;
  createApiKey: ApiKeyWithToken;
  createAskHistory: AskHistory;
  createChannel: ChannelCreationOutput;
  createCollectionScope: CreateCollectionScopeOutput;
  createEmailVerificationCode: CreateEmailVerificationCodeOutput;
  createExternalSources: Array<ExternalSource>;
  createGitlabTeam: OrganizationGitlabTeam;
  createGoogleTeam: OrganizationGoogleTeam;
  createInvites?: Maybe<Array<Maybe<User>>>;
  createJoinToken: CreateJoinTokenOutput;
  createMedia: CreateMediaOutput;
  createMicrosoftTeam: OrganizationMicrosoftTeam;
  createNote?: Maybe<Note>;
  createNoteFromTeamTemplate: CreateNoteFromTeamTemplateOutput;
  createNoteMedia: Media;
  createNoteVideo: CreateNoteVideoOutput;
  createOrganization: CreateOrganizationOutput;
  createOrganizationWithOauthCacheKey: CreateOrganizationOutput;
  createTemplate: Note;
  /** Create a note thread with an initial comment */
  createThread: Thread;
  createUserGroup?: Maybe<UserGroup>;
  createUserMobileToken?: Maybe<Scalars["Boolean"]["output"]>;
  debugSetTrialEndDate: Organization;
  debugStartTrial: Organization;
  deleteApiKey: Scalars["Boolean"]["output"];
  deleteAskHistory: DeleteAskHistoryOutput;
  deleteChannel?: Maybe<Channel>;
  deleteCollectionScope: DeleteCollectionScopeOutput;
  deleteExternalSource?: Maybe<Scalars["Boolean"]["output"]>;
  deleteGitlabTeam: Scalars["Boolean"]["output"];
  deleteGoogleTeam: Scalars["Boolean"]["output"];
  deleteJoinToken: DeleteJoinTokenOutput;
  deleteMicrosoftTeam: Scalars["Boolean"]["output"];
  deleteNoteVideo: DeleteNoteVideoOutput;
  deleteNotes: Array<Maybe<Note>>;
  deleteOldAccessibleArchivedNotes: DeleteOldAccessibleArchivedNotesOutput;
  deleteOrganization: Scalars["Boolean"]["output"];
  deleteSuperAssistant: DeleteSuperAssistantOutput;
  deleteSuperAutomation: DeleteSuperAutomationOutput;
  deleteSuperExtensionButton: DeleteSuperExtensionButtonOutput;
  deleteUserGroup?: Maybe<Scalars["Boolean"]["output"]>;
  deleteWebAuthNPublicKey: UserPreferences;
  disableApiKey: ApiKey;
  disableExtensionAssistantPreset: DisableExtensionAssistantPresetOutput;
  disableGroupProvisioning: DisableGroupProvisioningOutput;
  dismissAskReportedQuestions: Array<AskReportedQuestion>;
  dismissBrowserNotificationsHint: DismissBrowserNotificationsHintOutPut;
  dismissContextualTip: DismissContextualTipOutput;
  dismissNotificationsBanner: DismissNotificationsBannerOutPut;
  dismissOnboardingChecklist: OnboardingChecklist;
  dismissedSlackInstallHint: UserPreferences;
  duplicateNote: Note;
  enableApiKey: ApiKey;
  enableExtensionAssistantPreset: EnableExtensionAssistantPresetOutput;
  enableGroupProvisioning: EnableGroupProvisioningOutput;
  enableSuperSeatAutoAssign?: Maybe<User>;
  extendFreeTrial: Organization;
  favoriteChannel: FavoriteChannelOutput;
  favoriteSuperAssistant: FavoriteSuperAssistantOutput;
  followNote: Scalars["ID"]["output"];
  /** Follow a thread */
  followThread: FollowThreadOutput;
  generateReferralURL: GenerateReferralUrlOutput;
  generateScopedToken: GenerateScopedTokenOutput;
  generateSearchToken: GenerateSearchTokenOutput;
  getFileUploadUrl: GetFileUploadUrlOutput;
  getPaymentAuthorization: PaymentAuthorizationInfos;
  goToUserOnboardingStep: UserPreferences;
  identifyGenericUserProperties: IdentifyGenericUserPropertiesOutput;
  importArchive: ImportArchiveOutput;
  /** @deprecated Use importFilesFromUrlListAndReturnSeed instead */
  importFilesFromUrlList: Scalars["Boolean"]["output"];
  importFilesFromUrlListAndReturnSeed: ImportFilesFromFileUrlOutput;
  /** @deprecated We don't do import this way anymore */
  importGoogleDriveFilesFromIdList: Scalars["Boolean"]["output"];
  importPublicChannel: ImportPublicChannelOutput;
  importPublicNoteFromId: ImportPublicNoteFromIdOutput;
  indexAskReportedQuestionAnswer: IndexAskReportedQuestionAnswerOutput;
  leaveChannel?: Maybe<Channel>;
  linkSlackChannel: Note;
  /**
   * Lock a note for edition.
   * This is only an indicator for the frontend and doesn't prevent edition
   * in the backend at this moment.
   */
  lockNoteForEdition: Note;
  markAsSolvedAskReportedQuestions: Array<AskReportedQuestion>;
  /** Mark existing comment in thread as decision. Only one decision per thread can be made */
  markCommentAsDecision: MarkCommentAsDecisionOutput;
  markCommentAsUnread: MarkCommentAsUnreadOutput;
  markNotificationsAsDisplayed?: Maybe<Array<Maybe<Notification>>>;
  moveChannelTo: MoveChannelToOutput;
  moveNotesTo: Array<Maybe<Note>>;
  nudgeUser?: Maybe<Scalars["Boolean"]["output"]>;
  nudgeUserGroup?: Maybe<Scalars["Boolean"]["output"]>;
  ping?: Maybe<Scalars["String"]["output"]>;
  rateAskReportedQuestion: AskReportedQuestion;
  ratePublicAskReportedQuestion: AskReportedQuestion;
  reIdentifyUserProperties: ReIdentifyUserPropertiesOutput;
  refreshOauth: RefreshOauthOutput;
  refreshOtherUserOauth: RefreshOauthOutput;
  registerWebAuthNPublicKey: UserPreferences;
  removeCommentReaction: RemoveCommentReactionOutput;
  removeFromJoinedOrganizations: Scalars["Boolean"]["output"];
  removeMembersFromUserGroup: RemoveMembersFromUserGroupOutput;
  removeNoteReaction: RemoveNoteReactionOutput;
  removeNoteUserGroupRole: RemoveNoteUserGroupRoleOutput;
  /** Removes decision from a thread by un-marking the relevant comment if it exists */
  removeThreadDecision: RemoveThreadDecisionOutput;
  removeUserMobileToken?: Maybe<Scalars["Boolean"]["output"]>;
  removeUserRoleForNote: RemoveUserRoleForNoteOutput;
  renewUserMobileToken?: Maybe<Scalars["Boolean"]["output"]>;
  reportAskQuestion: AskReportedQuestion;
  reportPublicAskQuestion: AskReportedQuestion;
  requestChannelAccess?: Maybe<Scalars["Boolean"]["output"]>;
  requestManualOrganizationBackup?: Maybe<Organization>;
  requestNoteAccess?: Maybe<Scalars["Boolean"]["output"]>;
  requestPasswordReset: RequestPasswordResetOutput;
  resendInvite: ResendInviteOutput;
  resetChildNoteAutomation: ResetChildNoteAutomationOutput;
  resetPassword: ResetPasswordOutput;
  resetUserOnboarding: UserPreferences;
  /** Flag a thread as resolved */
  resolveThread: Thread;
  restoreOnboardingChecklist: OnboardingChecklist;
  revertCollectionToNote: RevertCollectionToNoteOutput;
  revertNoteToVersion: RevertNoteToVersionOutput;
  reviewAskReportedQuestionAnswer: AskReportedQuestion;
  revokeAsana: Scalars["Boolean"]["output"];
  revokeGithubTeam: Scalars["Boolean"]["output"];
  revokeHubspotTeam: Scalars["Boolean"]["output"];
  revokeLinear: Scalars["Boolean"]["output"];
  revokeOrganizationSSO?: Maybe<Organization>;
  revokeSlackTeam: Scalars["Boolean"]["output"];
  revokeTrello: Scalars["Boolean"]["output"];
  saveNoteAsTemplate: Note;
  savePublicNoteAsTemplate: SavePublicNoteAsTemplateOutput;
  saveSearchedTerm: UserPreferences;
  scaffoldOnboardingChannels: ScaffoldStructureFromIdsOutput;
  scaffoldStructureFromIds: ScaffoldStructureFromIdsOutput;
  scaffoldWikiGeneratorStructure: Scalars["Boolean"]["output"];
  sendMagicLink: Scalars["Boolean"]["output"];
  sendMeActivityFeed?: Maybe<Scalars["String"]["output"]>;
  sendMeInvitation: Scalars["String"]["output"];
  sendMeJoinLink?: Maybe<Scalars["String"]["output"]>;
  sendMeNotificationDigest?: Maybe<Scalars["String"]["output"]>;
  setChildNoteAutomation: SetChildNoteAutomationOutput;
  setCoupon: PaymentInfos;
  setEnabledNotificationsInSlack: SetEnabledNotificationsInSlackOutput;
  setNoteDefaultCollectionScope: SetNoteDefaultCollectionScopeOutput;
  setNoteIcon?: Maybe<Note>;
  setNoteReviewState: SetNoteReviewStateOutput;
  setNoteUserGroupRole: SetNoteUserGroupRoleOutput;
  setNotesReviewState: SetNotesReviewStateOutput;
  setNotificationsReminder: NotificationsUpdate;
  setOauthGroupNamesMapping: SetOauthGroupNamesMappingOutput;
  setOnboardingFlowStep: SetOnboardingFlowStepOutput;
  setOrganizationAuthProvider: SetOrganizationAuthProviderOutput;
  setOrganizationCustomPublicDomain: SetOrganizationCustomPublicDomainOutput;
  setOrganizationDisplayTeamBrandingOnPublicNotes: SetOrganizationDisplayTeamBrandingOnPublicNotesOutput;
  setOrganizationHomePageNote: Organization;
  setOrganizationJoinTokenOrganizationRole: SetOrganizationJoinTokenOrganizationRoleOutput;
  setOrganizationRootPublicNote: SetOrganizationRootPublicNoteOutput;
  setOrganizationWelcomeNote: Organization;
  setPreferredLanguage: PreferredLanguageOutput;
  setPreferredTimezone: PreferredTimezoneOutput;
  setSuperAutomation: SetSuperAutomationOutput;
  setSuperExtensionButton: SetSuperExtensionButtonOutput;
  setTemplateBinding: Note;
  setUserAsOwner: SetUserAsOwnerOutput;
  shareToSlack: Scalars["Boolean"]["output"];
  /**
   * Authenticate user on the API for the given organization.
   *
   * ℹ️ This mutation **will** set cookies on the users' browser. Make sure you are calling this from the proper subdomain
   */
  signInWithCredentials: SignInWithCredentialsOutput;
  signInWithWebAuthNPublicKey: SignInWithWebAuthNPublicKeyOutput;
  skipUserOnboarding: UserPreferences;
  snoozeNotificationsForXMin: SnoozeOutput;
  startsABExperiment: StartsAbExperimentOutput;
  startsABExperiments: StartsAbExperimentsOutput;
  startsAnonymousABExperiment: StartsAnonymousAbExperimentOutput;
  startsBoardingABExperiments: StartsAnonymousAbExperimentOutput;
  submitAskFeedback: AskFeedbackOutput;
  submitAskPublicFeedback: AskFeedbackOutput;
  subscribeToPlan: PaymentInfos;
  switchToPlan: PaymentInfos;
  synchronizeExternalSource?: Maybe<Scalars["Boolean"]["output"]>;
  toggleSuperSeatAutoAssignmentSetting: Organization;
  trackInteraction: TrackInteractionsOuput;
  trashNotes?: Maybe<TrashNotesOutput>;
  unSetNotificationsReminder: NotificationsUpdate;
  unacknowledgeNotifications: NotificationsUpdate;
  unarchiveNotes: Array<Maybe<Note>>;
  unarchiveUser?: Maybe<User>;
  unassignAskReportedQuestions: Array<AskReportedQuestion>;
  unassignSuperSeat?: Maybe<User>;
  unbindSuperAssistantToSlackChannel: Scalars["Boolean"]["output"];
  unbookmarkNote: UnbookmarkNoteOutput;
  unfavoriteChannel: UnfavoriteChannelOutput;
  unfavoriteSuperAssistant: UnfavoriteSuperAssistantOutput;
  unfollowNote: Scalars["ID"]["output"];
  /** Unfollow a thread */
  unfollowThread: UnfollowThreadOutput;
  unlinkSlackChannel: Note;
  unlinkSlackUser: Scalars["Boolean"]["output"];
  /**
   * Unlock a note for edition.
   * This is only an indicator for the frontend and doesn't prevent edition in the backend
   * at this moment.
   */
  unlockNoteForEdition: Note;
  /** Remove the resolved flag from a thread */
  unresolveThread: Thread;
  updateAskHistory: AskHistory;
  updateBillingCard: PaymentInfos;
  updateBillingDetails: PaymentInfos;
  updateChannel?: Maybe<Channel>;
  updateCollectionScope: UpdateCollectionScopeOutput;
  /** Allows to edit the content of a comment */
  updateComment: Comment;
  updateCurrentOrganization?: Maybe<Organization>;
  updateCurrentUser?: Maybe<User>;
  /**
   * Create, update or remove a list of emails role for on a note.
   * This will also send an email with a link to that note
   */
  updateEmailRolesForNote?: Maybe<UpdateNoteEmailRolesForNoteOutput>;
  updateExternalSourceMappingKey?: Maybe<ExternalSource>;
  updateGitlabTeam: OrganizationGitlabTeam;
  updateGoogleTeam: OrganizationGoogleTeam;
  updateMicrosoftTeam: OrganizationMicrosoftTeam;
  updateNote?: Maybe<Note>;
  updateNoteDisplayOptions: NoteDisplayOptions;
  updateNotePublicShareSettings: UpdateNotePublicShareSettingsOutput;
  updateOrganizationDomain: UpdateOrganizationOutput;
  updateOrganizationSuperGeneralContext: UpdateOrganizationSuperGeneralContextOutput;
  updatePublicNoteTitle: UpdatePublicNoteTitleOutput;
  updateSuperAssistantIcon: UpdateSuperAssistantIconOutput;
  /** Update list of thread followers */
  updateThreadFollowers: UpdateThreadFollowersOutput;
  updateUserGroup?: Maybe<UserGroup>;
  updateUserGroupRoleInChannel: ChannelRoleChange;
  updateUserOrganizationRole: UpdateUserOrganizationRoleOutput;
  updateUserPreferences?: Maybe<UserPreferences>;
  updateUserPresence?: Maybe<User>;
  updateUserRoleForNote: UpdateUserRoleForNoteOutput;
  updateUserRoleInChannel: ChannelRoleChange;
  upsertSuperAssistant: UpsertSuperAssistantOutput;
  verifyEmailVerificationCode: Scalars["Boolean"]["output"];
};

export type MutationAcknowledgeAllNotificationsArgs = {
  input?: InputMaybe<AcknowledgeAllNotificationsInput>;
};

export type MutationAcknowledgeNotificationsArgs = {
  notificationIds: Array<Scalars["ID"]["input"]>;
};

export type MutationAddAskHistoryMessagesArgs = {
  input: AddAskHistoryMessagesInput;
};

export type MutationAddCommentReactionArgs = {
  input: AddCommentReactionInput;
};

export type MutationAddCommentToThreadArgs = {
  comment: CommentCreationInput;
};

export type MutationAddMembersToUserGroupArgs = {
  input: AddUserGroupMembersInput;
};

export type MutationAddNoteReactionArgs = {
  input: AddNoteReactionInput;
};

export type MutationAknowledgeChannelActivityArgs = {
  channelId: Scalars["ID"]["input"];
};

export type MutationAknowledgeNoteActivityArgs = {
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  noteId: Scalars["ID"]["input"];
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationAknowledgeThreadsActivityArgs = {
  noteId: Scalars["ID"]["input"];
  threadIds: Array<Scalars["ID"]["input"]>;
};

export type MutationApplyPublicNoteOnNoteArgs = {
  input: ApplyPublicNoteOnNoteInput;
};

export type MutationApplySuggestedTemplateOnNoteArgs = {
  input: ApplySuggestedTemplateOnNotePayload;
};

export type MutationApplyTemplateOnNoteArgs = {
  destinationNoteId: Scalars["ID"]["input"];
  sourceNoteId: Scalars["ID"]["input"];
};

export type MutationArchiveCommentArgs = {
  input: ArchiveCommentInput;
};

export type MutationArchiveNotesArgs = {
  ids: Array<Scalars["ID"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationArchiveThreadArgs = {
  source?: InputMaybe<Scalars["String"]["input"]>;
  threadId: Scalars["ID"]["input"];
};

export type MutationArchiveUserArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationAssignAskReportedQuestionsArgs = {
  input: AssignAskReportedQuestionsInput;
};

export type MutationAssignSuperSeatArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationAuthenticateWithNoteSharingCredentialsArgs = {
  input: AuthenticateWithNoteSharingCredentialsInput;
};

export type MutationBindSuperAssistantToSlackChannelArgs = {
  input: BindSuperAssistantToSlackChannelInput;
};

export type MutationBookmarkNoteArgs = {
  input: BookmarkNoteInput;
};

export type MutationCancelPlanSubscriptionArgs = {
  input?: InputMaybe<CancelPlanSubscriptionInput>;
};

export type MutationChangeNoteDefaultRoleArgs = {
  input: ChangeNoteDefaultRoleInput;
};

export type MutationCommentAskReportedQuestionArgs = {
  input: CommentAskReportedQuestionInput;
};

export type MutationCommentPublicAskReportedQuestionArgs = {
  input: CommentPublicAskReportedQuestionInput;
};

export type MutationConvertNoteToChannelArgs = {
  input: ConvertNoteToChannelInput;
};

export type MutationConvertNoteToNewCollectionArgs = {
  input: ConvertNoteToCollectionInput;
};

export type MutationCreateApiKeyArgs = {
  name: Scalars["String"]["input"];
};

export type MutationCreateAskHistoryArgs = {
  input: CreateAskHistoryInput;
};

export type MutationCreateChannelArgs = {
  input: ChannelInput;
};

export type MutationCreateCollectionScopeArgs = {
  input: CreateCollectionScopeInput;
};

export type MutationCreateEmailVerificationCodeArgs = {
  input: CreateEmailVerificationCodeInput;
};

export type MutationCreateExternalSourcesArgs = {
  input: CreateExternalSourcesInput;
};

export type MutationCreateGitlabTeamArgs = {
  input: CreateGitlabTeamInput;
};

export type MutationCreateGoogleTeamArgs = {
  input: CreateGoogleTeamInput;
};

export type MutationCreateInvitesArgs = {
  invites: Array<InviteCreationInput>;
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationCreateJoinTokenArgs = {
  input: CreateJoinTokenInput;
};

export type MutationCreateMediaArgs = {
  media: MediaCreationInput;
};

export type MutationCreateMicrosoftTeamArgs = {
  input: CreateMicrosoftTeamInput;
};

export type MutationCreateNoteArgs = {
  channelId?: InputMaybe<Scalars["ID"]["input"]>;
  defaultCollectionLayout?: InputMaybe<CollectionLayout>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isCollection?: InputMaybe<Scalars["Boolean"]["input"]>;
  markdown?: InputMaybe<Scalars["String"]["input"]>;
  otType?: InputMaybe<NoteOtType>;
  parentNoteId?: InputMaybe<Scalars["ID"]["input"]>;
  snapshot?: InputMaybe<Scalars["Delta"]["input"]>;
  title: Scalars["String"]["input"];
  trackingSource?: InputMaybe<CreateNoteTrackingSource>;
};

export type MutationCreateNoteFromTeamTemplateArgs = {
  input: CreateNoteFromTeamTemplateInput;
};

export type MutationCreateNoteMediaArgs = {
  media: NoteMediaCreationInput;
};

export type MutationCreateNoteVideoArgs = {
  input: CreateNoteVideoInput;
};

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};

export type MutationCreateOrganizationWithOauthCacheKeyArgs = {
  input: CreateOrganizationWithOauthCacheKeyInput;
};

export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};

export type MutationCreateThreadArgs = {
  thread: ThreadCreationInput;
};

export type MutationCreateUserGroupArgs = {
  input: UserGroupInput;
};

export type MutationCreateUserMobileTokenArgs = {
  token: Scalars["ID"]["input"];
};

export type MutationDebugSetTrialEndDateArgs = {
  endDate: Scalars["Date"]["input"];
};

export type MutationDebugStartTrialArgs = {
  trialMode?: InputMaybe<TrialMode>;
};

export type MutationDeleteApiKeyArgs = {
  keyId: Scalars["ID"]["input"];
};

export type MutationDeleteAskHistoryArgs = {
  input: DeleteAskHistoryInput;
};

export type MutationDeleteChannelArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteCollectionScopeArgs = {
  input: DeleteCollectionScopeInput;
};

export type MutationDeleteExternalSourceArgs = {
  externalSourceId: Scalars["ID"]["input"];
};

export type MutationDeleteGitlabTeamArgs = {
  input: DeleteGitlabTeamInput;
};

export type MutationDeleteGoogleTeamArgs = {
  input: DeleteGoogleTeamInput;
};

export type MutationDeleteJoinTokenArgs = {
  input: DeleteJoinTokenInput;
};

export type MutationDeleteMicrosoftTeamArgs = {
  input: DeleteMicrosoftTeamInput;
};

export type MutationDeleteNoteVideoArgs = {
  input: DeleteNoteVideoInput;
};

export type MutationDeleteNotesArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationDeleteSuperAssistantArgs = {
  input: DeleteSuperAssistantInput;
};

export type MutationDeleteSuperAutomationArgs = {
  input: DeleteSuperAutomationInput;
};

export type MutationDeleteSuperExtensionButtonArgs = {
  input: DeleteSuperExtensionButtonInput;
};

export type MutationDeleteUserGroupArgs = {
  userGroupId: Scalars["ID"]["input"];
};

export type MutationDeleteWebAuthNPublicKeyArgs = {
  webAuthNPublicKeyId: Scalars["String"]["input"];
};

export type MutationDisableApiKeyArgs = {
  keyId: Scalars["ID"]["input"];
};

export type MutationDisableExtensionAssistantPresetArgs = {
  input: DisableExtensionAssistantPresetInput;
};

export type MutationDisableGroupProvisioningArgs = {
  input: DisableGroupProvisioningInput;
};

export type MutationDismissAskReportedQuestionsArgs = {
  input: DismissAskReportedQuestionsInput;
};

export type MutationDismissContextualTipArgs = {
  input: DismissContextualTipInput;
};

export type MutationDuplicateNoteArgs = {
  input: DuplicateNoteInput;
};

export type MutationEnableApiKeyArgs = {
  keyId: Scalars["ID"]["input"];
};

export type MutationEnableExtensionAssistantPresetArgs = {
  input: EnableExtensionAssistantPresetInput;
};

export type MutationEnableGroupProvisioningArgs = {
  input: EnableGroupProvisioningInput;
};

export type MutationEnableSuperSeatAutoAssignArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationFavoriteChannelArgs = {
  input: FavoriteChannelInput;
};

export type MutationFavoriteSuperAssistantArgs = {
  input: FavoriteSuperAssistantInput;
};

export type MutationFollowNoteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationFollowThreadArgs = {
  input: FollowThreadInput;
};

export type MutationGenerateScopedTokenArgs = {
  input: GenerateScopedTokenInput;
};

export type MutationGetFileUploadUrlArgs = {
  input: GetFileUploadUrlInput;
};

export type MutationGoToUserOnboardingStepArgs = {
  step?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationIdentifyGenericUserPropertiesArgs = {
  input: IdentifyGenericUserPropertiesInput;
};

export type MutationImportArchiveArgs = {
  input: ImportArchiveInput;
};

export type MutationImportFilesFromUrlListArgs = {
  input: ImportFilesFromFileUrlInput;
};

export type MutationImportFilesFromUrlListAndReturnSeedArgs = {
  input: ImportFilesFromFileUrlInput;
};

export type MutationImportGoogleDriveFilesFromIdListArgs = {
  input: ImportFilesFromGoogleDriveInput;
};

export type MutationImportPublicChannelArgs = {
  input: ImportPublicChannelInput;
};

export type MutationImportPublicNoteFromIdArgs = {
  input: ImportPublicNoteFromIdInput;
};

export type MutationIndexAskReportedQuestionAnswerArgs = {
  input: IndexAskReportedQuestionAnswerInput;
};

export type MutationLeaveChannelArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationLinkSlackChannelArgs = {
  input: LinkSlackChannelInput;
};

export type MutationLockNoteForEditionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationMarkAsSolvedAskReportedQuestionsArgs = {
  input: MarkAsSolvedAskReportedQuestionsInput;
};

export type MutationMarkCommentAsDecisionArgs = {
  input: MarkCommentAsDecisionInput;
};

export type MutationMarkCommentAsUnreadArgs = {
  input: MarkCommentAsUnreadInput;
};

export type MutationMarkNotificationsAsDisplayedArgs = {
  notificationIds: Array<Scalars["ID"]["input"]>;
};

export type MutationMoveChannelToArgs = {
  input: MoveChannelToInput;
};

export type MutationMoveNotesToArgs = {
  channelId: Scalars["ID"]["input"];
  ids: Array<Scalars["ID"]["input"]>;
  parentNoteId?: InputMaybe<Scalars["ID"]["input"]>;
  position?: InputMaybe<Scalars["Float"]["input"]>;
};

export type MutationNudgeUserArgs = {
  message?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationNudgeUserGroupArgs = {
  input: NudgeUserGroupInput;
};

export type MutationRateAskReportedQuestionArgs = {
  input: RateAskReportedQuestionInput;
};

export type MutationRatePublicAskReportedQuestionArgs = {
  input: RatePublicAskReportedQuestionInput;
};

export type MutationReIdentifyUserPropertiesArgs = {
  input: ReIdentifyUserPropertiesInput;
};

export type MutationRefreshOtherUserOauthArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationRegisterWebAuthNPublicKeyArgs = {
  input: RegisterWebAuthNPublicKeyInput;
};

export type MutationRemoveCommentReactionArgs = {
  input: RemoveCommentReactionInput;
};

export type MutationRemoveFromJoinedOrganizationsArgs = {
  input: RemoveFromJoinedOrganizationsInput;
};

export type MutationRemoveMembersFromUserGroupArgs = {
  input: RemoveMembersFromUserGroupInput;
};

export type MutationRemoveNoteReactionArgs = {
  input: RemoveNoteReactionInput;
};

export type MutationRemoveNoteUserGroupRoleArgs = {
  input: RemoveNoteUserGroupRoleInput;
};

export type MutationRemoveThreadDecisionArgs = {
  input: RemoveThreadDecisionInput;
};

export type MutationRemoveUserMobileTokenArgs = {
  token: Scalars["ID"]["input"];
};

export type MutationRemoveUserRoleForNoteArgs = {
  input: RemoveUserRoleForNoteInput;
};

export type MutationRenewUserMobileTokenArgs = {
  newToken: Scalars["ID"]["input"];
  oldToken: Scalars["ID"]["input"];
};

export type MutationReportAskQuestionArgs = {
  input: ReportAskQuestionInput;
};

export type MutationReportPublicAskQuestionArgs = {
  input: ReportPublicAskQuestionInput;
};

export type MutationRequestChannelAccessArgs = {
  channelId: Scalars["ID"]["input"];
};

export type MutationRequestManualOrganizationBackupArgs = {
  input?: InputMaybe<OrganizationManualBackupInput>;
};

export type MutationRequestNoteAccessArgs = {
  noteId: Scalars["ID"]["input"];
};

export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};

export type MutationResendInviteArgs = {
  input: ResendInviteInput;
};

export type MutationResetChildNoteAutomationArgs = {
  input: ResetChildNoteAutomationInput;
};

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type MutationResolveThreadArgs = {
  isDecision?: InputMaybe<Scalars["Boolean"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  threadId: Scalars["ID"]["input"];
};

export type MutationRevertCollectionToNoteArgs = {
  input: RevertCollectionToNoteInput;
};

export type MutationRevertNoteToVersionArgs = {
  input: RevertNoteToVersionInput;
};

export type MutationReviewAskReportedQuestionAnswerArgs = {
  input: ReviewAskReportedQuestionAnswerInput;
};

export type MutationRevokeGithubTeamArgs = {
  input: RevokeGithubTeamInput;
};

export type MutationRevokeHubspotTeamArgs = {
  input: RevokeHubspotTeam;
};

export type MutationRevokeSlackTeamArgs = {
  input: RevokeSlackTeamInput;
};

export type MutationSaveNoteAsTemplateArgs = {
  includeChildren?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourceNoteId: Scalars["ID"]["input"];
};

export type MutationSavePublicNoteAsTemplateArgs = {
  input: SavePublicNoteAsTemplateInput;
};

export type MutationSaveSearchedTermArgs = {
  input: SearchTermInput;
};

export type MutationScaffoldStructureFromIdsArgs = {
  input: ScaffoldStructureFromIdsInput;
};

export type MutationScaffoldWikiGeneratorStructureArgs = {
  input: ScaffoldWikiGeneratorStructureInput;
};

export type MutationSendMagicLinkArgs = {
  input: SendMagicLinkInput;
};

export type MutationSendMeInvitationArgs = {
  input: SendMeInvitationInput;
};

export type MutationSetChildNoteAutomationArgs = {
  input: SetChildNoteAutomationInput;
};

export type MutationSetCouponArgs = {
  input: SetCouponInput;
};

export type MutationSetEnabledNotificationsInSlackArgs = {
  input: SetEnabledNotificationsInSlackInput;
};

export type MutationSetNoteDefaultCollectionScopeArgs = {
  input: SetNoteDefaultCollectionScopeInput;
};

export type MutationSetNoteIconArgs = {
  id: Scalars["ID"]["input"];
  input: NoteIconInput;
};

export type MutationSetNoteReviewStateArgs = {
  input: SetNoteReviewStateInput;
};

export type MutationSetNoteUserGroupRoleArgs = {
  input: SetNoteUserGroupRoleInput;
};

export type MutationSetNotesReviewStateArgs = {
  input: SetNotesReviewStateInput;
};

export type MutationSetNotificationsReminderArgs = {
  input?: InputMaybe<SetNotificationsReminderInput>;
};

export type MutationSetOauthGroupNamesMappingArgs = {
  input: SetOauthGroupNamesMappingInput;
};

export type MutationSetOnboardingFlowStepArgs = {
  input: SetOnboardingFlowStepInput;
};

export type MutationSetOrganizationAuthProviderArgs = {
  input: SetOrganizationAuthProviderInput;
};

export type MutationSetOrganizationCustomPublicDomainArgs = {
  input: SetOrganizationCustomPublicDomainInput;
};

export type MutationSetOrganizationDisplayTeamBrandingOnPublicNotesArgs = {
  input: SetOrganizationDisplayTeamBrandingOnPublicNotesInput;
};

export type MutationSetOrganizationHomePageNoteArgs = {
  noteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationSetOrganizationJoinTokenOrganizationRoleArgs = {
  input: SetOrganizationJoinTokenOrganizationRoleInput;
};

export type MutationSetOrganizationRootPublicNoteArgs = {
  input: SetOrganizationRootPublicNoteInput;
};

export type MutationSetOrganizationWelcomeNoteArgs = {
  noteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationSetPreferredLanguageArgs = {
  input: PreferredLanguageInput;
};

export type MutationSetPreferredTimezoneArgs = {
  input: PreferredTimezoneInput;
};

export type MutationSetSuperAutomationArgs = {
  input: SetSuperAutomationInput;
};

export type MutationSetSuperExtensionButtonArgs = {
  input: SetSuperExtensionButtonInput;
};

export type MutationSetTemplateBindingArgs = {
  noteId: Scalars["ID"]["input"];
  templateId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationSetUserAsOwnerArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationShareToSlackArgs = {
  input: ShareToSlackInput;
};

export type MutationSignInWithCredentialsArgs = {
  input: SignInWithCredentialsInput;
};

export type MutationSignInWithWebAuthNPublicKeyArgs = {
  input: SignInWithWebAuthNPublicKeyInput;
};

export type MutationSnoozeNotificationsForXMinArgs = {
  input?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationStartsAbExperimentArgs = {
  input: StartsAbExperimentInput;
};

export type MutationStartsAnonymousAbExperimentArgs = {
  input: StartsAnonymousAbExperimentInput;
};

export type MutationStartsBoardingAbExperimentsArgs = {
  input?: InputMaybe<StartsBoardingAbExperimentsInput>;
};

export type MutationSubmitAskFeedbackArgs = {
  input: AskFeedbackInput;
};

export type MutationSubmitAskPublicFeedbackArgs = {
  input: AskPublicFeedbackInput;
};

export type MutationSubscribeToPlanArgs = {
  input: PlanSubscriptionInput;
};

export type MutationSwitchToPlanArgs = {
  input: PlanSwitchInput;
};

export type MutationSynchronizeExternalSourceArgs = {
  externalSourceId: Scalars["ID"]["input"];
};

export type MutationTrackInteractionArgs = {
  input: TrackInteractionsInput;
};

export type MutationTrashNotesArgs = {
  input: TrashNotesInput;
};

export type MutationUnSetNotificationsReminderArgs = {
  input?: InputMaybe<UnSetNotificationsReminderInput>;
};

export type MutationUnacknowledgeNotificationsArgs = {
  notificationIds: Array<Scalars["ID"]["input"]>;
};

export type MutationUnarchiveNotesArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationUnarchiveUserArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationUnassignAskReportedQuestionsArgs = {
  input: UnassignAskReportedQuestionsInput;
};

export type MutationUnassignSuperSeatArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationUnbindSuperAssistantToSlackChannelArgs = {
  input: UnbindSuperAssistantToSlackChannelInput;
};

export type MutationUnbookmarkNoteArgs = {
  input: UnbookmarkNoteInput;
};

export type MutationUnfavoriteChannelArgs = {
  input: UnfavoriteChannelInput;
};

export type MutationUnfavoriteSuperAssistantArgs = {
  input: UnfavoriteSuperAssistantInput;
};

export type MutationUnfollowNoteArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationUnfollowThreadArgs = {
  input: UnfollowThreadInput;
};

export type MutationUnlinkSlackChannelArgs = {
  input: UnlinkSlackChannelInput;
};

export type MutationUnlinkSlackUserArgs = {
  input: UnlinkSlackUserInput;
};

export type MutationUnlockNoteForEditionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationUnresolveThreadArgs = {
  source?: InputMaybe<Scalars["String"]["input"]>;
  threadId: Scalars["ID"]["input"];
};

export type MutationUpdateAskHistoryArgs = {
  input: UpdateAskHistoryInput;
};

export type MutationUpdateBillingCardArgs = {
  input: BillingCardUpdateInput;
};

export type MutationUpdateBillingDetailsArgs = {
  input: BillingDetailsUpdateInput;
};

export type MutationUpdateChannelArgs = {
  defaultRole?: InputMaybe<ChannelMemberRole>;
  id: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<ChannelType>;
};

export type MutationUpdateCollectionScopeArgs = {
  input: UpdateCollectionScopeInput;
};

export type MutationUpdateCommentArgs = {
  input: EditCommentInput;
};

export type MutationUpdateCurrentOrganizationArgs = {
  organization?: InputMaybe<OrganizationUpdateInput>;
};

export type MutationUpdateCurrentUserArgs = {
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  level?: InputMaybe<Scalars["String"]["input"]>;
  photoURL?: InputMaybe<Scalars["String"]["input"]>;
  position?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateEmailRolesForNoteArgs = {
  input: UpdateNoteEmailRolesForNoteInput;
};

export type MutationUpdateExternalSourceMappingKeyArgs = {
  input: UpdateExternalSourceMappingKeyInput;
};

export type MutationUpdateGitlabTeamArgs = {
  input: UpdateGitlabTeamInput;
};

export type MutationUpdateGoogleTeamArgs = {
  input: UpdateGoogleTeamInput;
};

export type MutationUpdateMicrosoftTeamArgs = {
  input: UpdateMicrosoftTeamInput;
};

export type MutationUpdateNoteArgs = {
  id: Scalars["ID"]["input"];
  title: Scalars["String"]["input"];
};

export type MutationUpdateNoteDisplayOptionsArgs = {
  input: UpdateNoteDisplayOptionsInput;
};

export type MutationUpdateNotePublicShareSettingsArgs = {
  input: UpdateNotePublicShareSettingsInput;
};

export type MutationUpdateOrganizationDomainArgs = {
  domain: Scalars["String"]["input"];
};

export type MutationUpdateOrganizationSuperGeneralContextArgs = {
  input: UpdateOrganizationSuperGeneralContextInput;
};

export type MutationUpdatePublicNoteTitleArgs = {
  input: UpdatePublicNoteTitleInput;
};

export type MutationUpdateSuperAssistantIconArgs = {
  input: UpdateSuperAssistantIconInput;
};

export type MutationUpdateThreadFollowersArgs = {
  input: UpdateThreadFollowersInput;
};

export type MutationUpdateUserGroupArgs = {
  input: UserGroupInput;
  userGroupId: Scalars["ID"]["input"];
};

export type MutationUpdateUserGroupRoleInChannelArgs = {
  channelId: Scalars["ID"]["input"];
  role: ChannelMemberRole;
  userGroupId: Scalars["ID"]["input"];
};

export type MutationUpdateUserOrganizationRoleArgs = {
  role: OrganizationRole;
  userId: Scalars["ID"]["input"];
};

export type MutationUpdateUserPreferencesArgs = {
  acceptedPrivacyPolicyAt?: InputMaybe<Scalars["Date"]["input"]>;
  bookmarkedNoteIdList?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  calendarType?: InputMaybe<Scalars["String"]["input"]>;
  changelogSeenAt?: InputMaybe<Scalars["Date"]["input"]>;
  closedImportContentCallToActionAt?: InputMaybe<Scalars["Date"]["input"]>;
  closedInviteTeammatesCallToActionAt?: InputMaybe<Scalars["Date"]["input"]>;
  colorMode?: InputMaybe<ColorModePreference>;
  confluenceApiAuthentication?: InputMaybe<ConfluenceApiAuthenticationInput>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  disableSlackAutoAsk?: InputMaybe<Scalars["Boolean"]["input"]>;
  dismissedEducationCenterSidebarHintAt?: InputMaybe<Scalars["Date"]["input"]>;
  dismissedHighlightedUpdatesHintAt?: InputMaybe<Scalars["Date"]["input"]>;
  dismissedSidebarInviteLinkAt?: InputMaybe<Scalars["Date"]["input"]>;
  displayArchivedNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  displayColdNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabledNotificationsInSlack?: InputMaybe<Scalars["Boolean"]["input"]>;
  favouriteNoteId?: InputMaybe<Scalars["String"]["input"]>;
  featureFlags?: InputMaybe<Scalars["String"]["input"]>;
  hideInViewersList?: InputMaybe<Scalars["Boolean"]["input"]>;
  inviteBannerAcknowledgementState?: InputMaybe<InviteBannerAcknowledgementStateInput>;
  isAskXDesktopUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDesktopUser?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastActivityFeedViewedAt?: InputMaybe<Scalars["Date"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  notificationOnEditNote?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationOnFirstNoteView?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationsDigestFrequency?: InputMaybe<NotificationsDigestFrequency>;
  onboardingStep?: InputMaybe<Scalars["String"]["input"]>;
  seenBannerDownloadDesktopApp?: InputMaybe<Scalars["Boolean"]["input"]>;
  seenNearNoteLimitIncentiveAt?: InputMaybe<Scalars["Date"]["input"]>;
  subscribedToOYOT?: InputMaybe<Scalars["Boolean"]["input"]>;
  subscribedToProductUpdates?: InputMaybe<Scalars["Boolean"]["input"]>;
  superChangelogSeenAt?: InputMaybe<Scalars["Date"]["input"]>;
  suppressedConnectApp?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  suppressedEnableApp?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MutationUpdateUserPresenceArgs = {
  blockId?: InputMaybe<Scalars["ID"]["input"]>;
  isWriting?: InputMaybe<Scalars["Boolean"]["input"]>;
  noteId?: InputMaybe<Scalars["ID"]["input"]>;
  wroteAt?: InputMaybe<Scalars["Date"]["input"]>;
};

export type MutationUpdateUserRoleForNoteArgs = {
  input: UpdateUserRoleForNoteInput;
};

export type MutationUpdateUserRoleInChannelArgs = {
  channelId: Scalars["ID"]["input"];
  role: ChannelMemberRole;
  userId: Scalars["ID"]["input"];
};

export type MutationUpsertSuperAssistantArgs = {
  input: UpsertSuperAssistantInput;
};

export type MutationVerifyEmailVerificationCodeArgs = {
  email: Scalars["String"]["input"];
  emailVerificationCode: Scalars["String"]["input"];
  fromOrganizationCreation?: InputMaybe<Scalars["Boolean"]["input"]>;
  fromSuper?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NewNotePosition = NewPosition & {
  __typename: "NewNotePosition";
  after?: Maybe<Scalars["ID"]["output"]>;
  before?: Maybe<Scalars["ID"]["output"]>;
  edge: NoteEdge;
};

export type NewNotificationPosition = NewPosition & {
  __typename: "NewNotificationPosition";
  after?: Maybe<Scalars["ID"]["output"]>;
  before?: Maybe<Scalars["ID"]["output"]>;
  edge: NotificationEdge;
};

export type NewPosition = {
  after?: Maybe<Scalars["ID"]["output"]>;
  before?: Maybe<Scalars["ID"]["output"]>;
  edge: Edge;
};

export type Node = {
  id: Scalars["ID"]["output"];
};

export type Note = Node & {
  __typename: "Note";
  activities: Array<NoteActivity>;
  activityAcknowledgement?: Maybe<NoteActivityAknowledgment>;
  activityCount?: Maybe<Scalars["Int"]["output"]>;
  /** The notes ancestors, from top level to parent. */
  ancestors: Array<Note>;
  archivedAt?: Maybe<Scalars["Date"]["output"]>;
  archivedBy?: Maybe<Scalars["ID"]["output"]>;
  author?: Maybe<User>;
  automation?: Maybe<ChildNoteAutomation>;
  backlinksInfo: NoteBacklinksInfo;
  boundTemplate?: Maybe<Note>;
  channel?: Maybe<Channel>;
  /** @deprecated Use channel field instead */
  channelId: Scalars["ID"]["output"];
  childrenCount: Scalars["Int"]["output"];
  collectionSchema?: Maybe<CollectionSchema>;
  collectionScopes: Array<CollectionScope>;
  commenterIds: Array<Scalars["ID"]["output"]>;
  contentAsJSON: Scalars["JSON"]["output"];
  contentAsMarkdown: Scalars["String"]["output"];
  contentAsText: Scalars["String"]["output"];
  /** @deprecated No longer used, use displayOptions instead */
  coverImageUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  /** @deprecated Use author instead */
  createdBy?: Maybe<Scalars["ID"]["output"]>;
  creationSource?: Maybe<Scalars["String"]["output"]>;
  currentUserNoteStatus?: Maybe<UserNoteStatus>;
  decayedHeat: Scalars["Float"]["output"];
  defaultRole?: Maybe<NoteDefaultRole>;
  /**
   * Keeping this here while we remove discussions
   * @deprecated Discussions have been removed
   */
  discussion?: Maybe<Discussion>;
  displayOptions?: Maybe<NoteDisplayOptions>;
  /** @deprecated No longer used since only one type of doc exists */
  docType: NoteDocType;
  followers: Array<User>;
  fragmentWordsCountMedian: Scalars["Int"]["output"];
  hasChildren: Scalars["Boolean"]["output"];
  heat: Scalars["Int"]["output"];
  history: Array<Maybe<NoteHistory>>;
  iconColor?: Maybe<Scalars["String"]["output"]>;
  iconShape?: Maybe<Scalars["String"]["output"]>;
  iconVariant?: Maybe<NoteIconVariant>;
  id: Scalars["ID"]["output"];
  isCollection?: Maybe<Scalars["Boolean"]["output"]>;
  isImporting: Scalars["Boolean"]["output"];
  /** Wether this note is locked for edition */
  isLocked: Scalars["Boolean"]["output"];
  isOrganizationOnboardingNote: Scalars["Boolean"]["output"];
  isTemplate: Scalars["Boolean"]["output"];
  isWelcomeNote: Scalars["Boolean"]["output"];
  joinToken?: Maybe<JoinToken>;
  lastActivityAt?: Maybe<Scalars["Date"]["output"]>;
  lastActivityBy?: Maybe<Scalars["ID"]["output"]>;
  lastActivityByUser?: Maybe<User>;
  lastActivityType: NoteActivityType;
  lastHeatTick?: Maybe<Scalars["Date"]["output"]>;
  lastHistoryVersion?: Maybe<Scalars["Int"]["output"]>;
  linkedSlackChannel?: Maybe<LinkedSlackChannel>;
  listPosition: Scalars["Float"]["output"];
  /**
   * Media access token allow to access all the media linked to this note via the media proxy
   * It's mostly used by mobile editor which don't have access to the cookie
   */
  mediaAccessToken: Scalars["String"]["output"];
  memberships: NoteMembershipConnection;
  mentionedIds: Array<Scalars["ID"]["output"]>;
  noteExternalSource?: Maybe<NoteExternalSource>;
  noteReactions: Array<NoteReaction>;
  notes: NoteConnection;
  organizationId: Scalars["ID"]["output"];
  otType: NoteOtType;
  parentNote?: Maybe<Note>;
  permissions: NotePermissions;
  popularity: Scalars["Float"]["output"];
  /**
   * The doc public "Ask" URL.
   * Does not require authentication but might 403 if does isn't public
   */
  publicAskUrl: Scalars["String"]["output"];
  /**
   * Full blown public membership. Use lighter Note.publicRole unless you need
   * specific details like creation date, role holder or the user who did enable
   * public sharing.
   */
  publicMembership?: Maybe<NoteMembership>;
  publicReadCount?: Maybe<Scalars["Int"]["output"]>;
  /** The doc public role */
  publicRole?: Maybe<NotePublicRole>;
  /** @deprecated Use note.publicRole instead, or memberships */
  publicShareToken?: Maybe<Scalars["String"]["output"]>;
  /**
   * The doc public URL.
   * Does not require authentication but might 403 if does isn't public
   */
  publicUrl: Scalars["String"]["output"];
  readCount?: Maybe<Scalars["Int"]["output"]>;
  reviewState: NoteReviewCurrentState;
  /** @deprecated Use url or publicUrl explicitly */
  shareLink: Scalars["String"]["output"];
  stats: Array<Maybe<NoteStatsEvent>>;
  threadInfo?: Maybe<NoteThreadInfo>;
  /** @deprecated use listNoteThreadInfo query instead */
  threads: Array<Thread>;
  title: Scalars["String"]["output"];
  totalVerifiedSubNoteCount: Scalars["Int"]["output"];
  updatedAt: Scalars["Date"]["output"];
  /**
   * In-App doc URL
   * Will required authentication to access
   */
  url: Scalars["String"]["output"];
  userGroupPopularity: Scalars["Float"]["output"];
  /** @deprecated Use readCount */
  viewCount?: Maybe<Scalars["Int"]["output"]>;
  viewers: NoteViewersConnection;
  writerIds: Array<Scalars["ID"]["output"]>;
};

export type NoteChildrenCountArgs = {
  includeArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NoteHasChildrenArgs = {
  includeArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDiscussions?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NoteMembershipsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  useLegacyConnection?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NoteNotesArgs = {
  includeArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeDiscussions?: InputMaybe<Scalars["Boolean"]["input"]>;
  order?: InputMaybe<NoteOrder>;
  pagination?: InputMaybe<PaginationInput>;
  restrictToDirectSubnotes?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NotePublicReadCountArgs = {
  sinceDaysAgo?: InputMaybe<Scalars["Int"]["input"]>;
};

export type NoteReadCountArgs = {
  sinceDaysAgo?: InputMaybe<Scalars["Int"]["input"]>;
};

export type NoteStatsArgs = {
  period?: InputMaybe<AnalyticsPeriod>;
  type?: InputMaybe<AuditEvent>;
};

export type NoteThreadsArgs = {
  resolutionType?: InputMaybe<ThreadResolutionType>;
};

export type NoteUserGroupPopularityArgs = {
  userGroupId: Scalars["ID"]["input"];
};

export type NoteViewersArgs = {
  pagination: PaginationInput;
};

export type NoteActivity = Node & {
  __typename: "NoteActivity";
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  metadata: Scalars["JSON"]["output"];
  note: Note;
  noteId: Scalars["ID"]["output"];
  thread?: Maybe<Thread>;
  type: NoteActivityType;
  userIds: Array<Scalars["ID"]["output"]>;
};

export type NoteActivityAknowledgment = ActivityAknowledgment & {
  __typename: "NoteActivityAknowledgment";
  acknowledgedAt: Scalars["Date"]["output"];
  /** @deprecated Use acknowledgedAt instead, this one is a typo. */
  aknowledgedAt: Scalars["Date"]["output"];
  /** @deprecated This is not being used anymore. */
  channelId?: Maybe<Scalars["ID"]["output"]>;
  entityId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  userId: Scalars["ID"]["output"];
  version: Scalars["Int"]["output"];
};

export type NoteActivityConnection = Connection & {
  __typename: "NoteActivityConnection";
  edges: Array<NoteActivityEdge>;
  nodes: Array<NoteActivity>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NoteActivityEdge = Edge & {
  __typename: "NoteActivityEdge";
  cursor: Scalars["Cursor"]["output"];
  node: NoteActivity;
};

export enum NoteActivityType {
  Archive = "archive",
  Content = "content",
  Create = "create",
  NewComment = "newComment",
  /** @deprecated Discussions have been removed */
  NewDiscussionReply = "newDiscussionReply",
  NewThread = "newThread",
  NoteReaction = "noteReaction",
  RequestChannelAccess = "requestChannelAccess",
  ReviewStateUpdate = "reviewStateUpdate",
  Unarchive = "unarchive",
  Update = "update",
}

export type NoteAnalytics = {
  __typename: "NoteAnalytics";
  id: Scalars["ID"]["output"];
  totalViews: Scalars["Int"]["output"];
  uniqueViews: Scalars["Int"]["output"];
};

export type NoteBacklinksConnection = Connection & {
  __typename: "NoteBacklinksConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NoteBacklinksInfo = {
  __typename: "NoteBacklinksInfo";
  count: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  oldestBacklink?: Maybe<Note>;
};

export type NoteChange = {
  __typename: "NoteChange";
  note?: Maybe<Note>;
};

export type NoteCollectionScopesUpdatedOutput = {
  __typename: "NoteCollectionScopesUpdatedOutput";
  collectionScopes: Array<CollectionScope>;
};

export enum NoteColumns {
  Multi = "multi",
  Single = "single",
}

export type NoteConnection = Connection & {
  __typename: "NoteConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export enum NoteContentWidth {
  Regular = "regular",
  Wide = "wide",
}

export enum NoteDefaultRole {
  Reader = "READER",
  Restricted = "RESTRICTED",
  Writer = "WRITER",
}

export type NoteDisplayOptions = {
  __typename: "NoteDisplayOptions";
  columns: NoteColumns;
  contentWidth: NoteContentWidth;
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  defaultCollectionScope?: Maybe<CollectionScope>;
  directoryType?: Maybe<DirectoryType>;
  id: Scalars["ID"]["output"];
  imagePosition?: Maybe<Scalars["String"]["output"]>;
  imageTints?: Maybe<Array<Scalars["String"]["output"]>>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  layout?: Maybe<Scalars["String"]["output"]>;
  previewLightMediaId?: Maybe<Scalars["String"]["output"]>;
  selectedImageTint?: Maybe<Scalars["String"]["output"]>;
  subdocsDisplay: SubdocsDisplay;
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Cover videos are no longer used */
  videoTimeStamps?: Maybe<Scalars["JSON"]["output"]>;
  /** @deprecated Cover videos are no longer used */
  videoUrl?: Maybe<Scalars["String"]["output"]>;
};

export type NoteDisplayOptionsUpdatedSubscriptionOutput = {
  __typename: "NoteDisplayOptionsUpdatedSubscriptionOutput";
  noteDisplayOptions?: Maybe<NoteDisplayOptions>;
};

export enum NoteDocType {
  Database = "Database",
  RichText = "RichText",
}

export type NoteEdge = Edge & {
  __typename: "NoteEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Note;
};

export type NoteEditsConnection = Connection & {
  __typename: "NoteEditsConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NoteEmailRole = Node & {
  __typename: "NoteEmailRole";
  email: Scalars["EmailAddress"]["output"];
  id: Scalars["ID"]["output"];
  note: Note;
  role: NoteUserRole;
};

export type NoteEmailRoleConnection = Connection & {
  __typename: "NoteEmailRoleConnection";
  edges: Array<NoteEmailRoleEdge>;
  nodes: Array<NoteEmailRole>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NoteEmailRoleEdge = Edge & {
  __typename: "NoteEmailRoleEdge";
  cursor: Scalars["Cursor"]["output"];
  node: NoteEmailRole;
};

export type NoteEmailRoleInput = {
  email: Scalars["EmailAddress"]["input"];
  role?: NoteUserRole;
};

export type NoteExternalSource = {
  __typename: "NoteExternalSource";
  id: Scalars["ID"]["output"];
  type: ExternalSourceType;
  url: Scalars["String"]["output"];
};

export type NoteHistory = Node & {
  __typename: "NoteHistory";
  createdAt: Scalars["Date"]["output"];
  from: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  noteId: Scalars["ID"]["output"];
  op: Scalars["JSON"]["output"];
  snapshot: Scalars["JSON"]["output"];
  to: Scalars["Int"]["output"];
  users: Array<Maybe<User>>;
};

export type NoteHistoryConnection = Connection & {
  __typename: "NoteHistoryConnection";
  edges: Array<NoteHistoryEdge>;
  nodes: Array<NoteHistory>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NoteHistoryEdge = Edge & {
  __typename: "NoteHistoryEdge";
  cursor: Scalars["Cursor"]["output"];
  node: NoteHistory;
};

export type NoteHistoryOps = {
  __typename: "NoteHistoryOps";
  ops?: Maybe<Array<Scalars["JSON"]["output"]>>;
};

export type NoteIconInput = {
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  iconShape?: InputMaybe<Scalars["String"]["input"]>;
};

export enum NoteIconVariant {
  Personal = "personal",
  Private = "private",
}

export type NoteImportingUpdatedSubscriptionOutput = {
  __typename: "NoteImportingUpdatedSubscriptionOutput";
  isImporting: Scalars["Boolean"]["output"];
};

export type NoteMediaAttachInput = {
  id: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
};

export type NoteMediaCreationInput = {
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  name: Scalars["String"]["input"];
  noteId: Scalars["ID"]["input"];
  url: Scalars["String"]["input"];
};

export type NoteMembership = Node & {
  __typename: "NoteMembership";
  cascading: Scalars["Boolean"]["output"];
  enableAsk?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  isIndexeableForSearchEngines?: Maybe<Scalars["Boolean"]["output"]>;
  membershipRole: NoteMembershipRole;
  roleHolder?: Maybe<NoteMembershipRoleHolder>;
  sharedAt: Scalars["Date"]["output"];
  showDuplicateIncentive?: Maybe<Scalars["Boolean"]["output"]>;
  subject: NoteMembershipSubject;
};

export type NoteMembershipChannelRole = Node & {
  __typename: "NoteMembershipChannelRole";
  id: Scalars["ID"]["output"];
  role: ChannelMemberRole;
};

export type NoteMembershipConnection = Connection & {
  __typename: "NoteMembershipConnection";
  edges: Array<NoteMembershipEdge>;
  nodes: Array<NoteMembership>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NoteMembershipEdge = Edge & {
  __typename: "NoteMembershipEdge";
  cursor: Scalars["Cursor"]["output"];
  node: NoteMembership;
};

export type NoteMembershipEmailSearchResult = Node & {
  __typename: "NoteMembershipEmailSearchResult";
  email: Scalars["EmailAddress"]["output"];
  existingMemberships: Array<NoteMembership>;
  id: Scalars["ID"]["output"];
};

export type NoteMembershipNoteRole = Node & {
  __typename: "NoteMembershipNoteRole";
  id: Scalars["ID"]["output"];
  role: NoteUserRole;
};

export type NoteMembershipRole =
  | NoteMembershipChannelRole
  | NoteMembershipNoteRole;

export type NoteMembershipRoleHolder = Channel | Note;

export type NoteMembershipSearchResult =
  | NoteMembershipEmailSearchResult
  | NoteMembershipUserGroupSearchResult
  | NoteMembershipUserSearchResult;

export type NoteMembershipSubject =
  | DefaultRole
  | EmailUser
  | PublicRole
  | User
  | UserGroup;

export type NoteMembershipUserGroupSearchResult = Node & {
  __typename: "NoteMembershipUserGroupSearchResult";
  /**
   * Although we can't override a group's role through another group,
   * we could still have a "Everyone" role set that overrides it.
   */
  existingMemberships: Array<NoteMembership>;
  id: Scalars["ID"]["output"];
  userGroup: UserGroup;
};

export type NoteMembershipUserSearchResult = Node & {
  __typename: "NoteMembershipUserSearchResult";
  /**
   * Optionally resolve a membership if any exists for that user already.
   * This will be the a default role, a group membership or a (self) user role.
   */
  existingMemberships: Array<NoteMembership>;
  id: Scalars["ID"]["output"];
  user: User;
};

export type NoteOrder = {
  direction?: InputMaybe<OrderDirection>;
  field?: InputMaybe<NoteOrderField>;
};

export enum NoteOrderField {
  ArchivedAt = "archivedAt",
  CreatedAt = "createdAt",
  LastActivityAt = "lastActivityAt",
  ListPosition = "listPosition",
  Title = "title",
}

export enum NoteOtType {
  Json1 = "JSON1",
  RichText = "RichText",
}

export type NotePermissions = Permissions & {
  __typename: "NotePermissions";
  delete: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  manage: Scalars["Boolean"]["output"];
  read: Scalars["Boolean"]["output"];
  share: Scalars["Boolean"]["output"];
  sharePublicly: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export enum NotePublicRole {
  None = "none",
  Reader = "reader",
  Restricted = "restricted",
  Writer = "writer",
}

export type NoteReaction = {
  __typename: "NoteReaction";
  count: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  type: Scalars["String"]["output"];
  users: Array<User>;
};

export type NoteReactionsUpdatedOutput = {
  __typename: "NoteReactionsUpdatedOutput";
  noteReactions: Array<NoteReaction>;
};

export type NoteReviewCurrentState =
  | NoteReviewStateFinal
  | NoteReviewStateTransient;

/** Closed list of possible review states */
export enum NoteReviewState {
  /**
   * Final, the document is considered ready.
   * This state can be associated to a state review expiration period.
   */
  Final = "final",
  /** No review state */
  None = "none",
  /**
   * The document has been declared out of date manually.
   * It'll stay in that state unless it is changed manually by someone.
   */
  OutOfDate = "out_of_date",
  /**
   * Waiting for someone from the team to review.
   *
   * This state cannot be set manually.
   */
  PendingReview = "pending_review",
  /**
   * Someone requested a review of the document.
   * It'll stay in that state unless it is changed manually by someone.
   */
  VerificationRequested = "verification_requested",
}

/**
 * The final review state can expire after a while.
 * This enum states what units can be used alongside an expiration unit to define this.
 */
export enum NoteReviewStateExpirationPeriod {
  Day = "day",
  Minute = "minute",
  Month = "month",
  Week = "week",
  Year = "year",
}

export type NoteReviewStateFinal = INoteReviewState & {
  __typename: "NoteReviewStateFinal";
  changedAt?: Maybe<Scalars["Date"]["output"]>;
  changedBy?: Maybe<User>;
  currentState: NoteReviewState;
  id: Scalars["ID"]["output"];
  /** @deprecated Use ownedBy instead */
  managedBy: User;
  ownedBy: UserOrUserGroup;
  reviewWillStallAt?: Maybe<Scalars["Date"]["output"]>;
};

export type NoteReviewStateTransient = INoteReviewState & {
  __typename: "NoteReviewStateTransient";
  changedAt?: Maybe<Scalars["Date"]["output"]>;
  changedBy?: Maybe<User>;
  currentState: NoteReviewState;
  id: Scalars["ID"]["output"];
  /** @deprecated Use ownedBy instead */
  managedBy: User;
  message?: Maybe<Scalars["String"]["output"]>;
  ownedBy: UserOrUserGroup;
};

export type NoteReviewWillStallAfterInput = {
  period: NoteReviewStateExpirationPeriod;
  unit: Scalars["Int"]["input"];
};

export type NoteSharedWithUser = Node & {
  __typename: "NoteSharedWithUser";
  cascading: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  note: Note;
  role: Scalars["String"]["output"];
  sharedAt: Scalars["Date"]["output"];
  /** @deprecated Use sharedByUser instead */
  sharedBy?: Maybe<Scalars["ID"]["output"]>;
  sharedByUser?: Maybe<User>;
  sharedVia: NoteSharedWithVia;
};

export type NoteSharedWithUserEdge = Edge & {
  __typename: "NoteSharedWithUserEdge";
  cursor: Scalars["Cursor"]["output"];
  node: NoteSharedWithUser;
};

export enum NoteSharedWithVia {
  NoteUserGroupRole = "NoteUserGroupRole",
  NoteUserRole = "NoteUserRole",
  OrganizationRole = "OrganizationRole",
}

export type NoteSharingTargetIntegrationsInput = {
  organizationId: Scalars["ID"]["input"];
  pagination: PaginationInput;
};

export type NoteStatsEvent = {
  __typename: "NoteStatsEvent";
  date: Scalars["Date"]["output"];
  totalCount: Scalars["Int"]["output"];
  uniqueCount: Scalars["Int"]["output"];
};

export type NoteThreadInfo = {
  __typename: "NoteThreadInfo";
  globalThreadsInfo: Array<ThreadInfo>;
  id: Scalars["ID"]["output"];
  inlineThreadsInfo: Array<ThreadInfo>;
};

export type NoteThreadInfoInlineThreadsInfoArgs = {
  resolvedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum NoteType {
  Collection = "Collection",
  /** @deprecated Discussions have been removed */
  Discussion = "Discussion",
  Doc = "Doc",
}

export type NoteUserGroupRole = Node & {
  __typename: "NoteUserGroupRole";
  id: Scalars["ID"]["output"];
  note: Note;
  role: NoteUserRole;
  userGroup: UserGroup;
};

export type NoteUserGroupRoleEdge = Edge & {
  __typename: "NoteUserGroupRoleEdge";
  cursor: Scalars["Cursor"]["output"];
  node: NoteUserGroupRole;
};

export type NoteUserGroupRolesConnection = Connection & {
  __typename: "NoteUserGroupRolesConnection";
  edges: Array<NoteUserGroupRoleEdge>;
  nodes: Array<NoteUserGroupRole>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export enum NoteUserRole {
  None = "none",
  Reader = "reader",
  Restricted = "restricted",
  Writer = "writer",
}

export type NoteVideo = {
  __typename: "NoteVideo";
  id: Scalars["ID"]["output"];
  note: Note;
  url: Scalars["String"]["output"];
};

export type NoteVideoUpdatedSubscriptionOutput = {
  __typename: "NoteVideoUpdatedSubscriptionOutput";
  noteVideo?: Maybe<NoteVideo>;
};

export type NoteViewer = Node & {
  __typename: "NoteViewer";
  firstViewedAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  lastViewedAt: Scalars["Date"]["output"];
  user: User;
};

export type NoteViewerEdge = Edge & {
  __typename: "NoteViewerEdge";
  cursor: Scalars["Cursor"]["output"];
  node: NoteViewer;
};

export type NoteViewersConnection = Connection & {
  __typename: "NoteViewersConnection";
  edges: Array<NoteViewerEdge>;
  nodes: Array<NoteViewer>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NoteVisitsConnection = Connection & {
  __typename: "NoteVisitsConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NotesArchivedOutput = {
  __typename: "NotesArchivedOutput";
  ids: Array<Scalars["ID"]["output"]>;
};

export type NotesDeletedOutput = {
  __typename: "NotesDeletedOutput";
  ids: Array<Scalars["ID"]["output"]>;
};

export type NotesMovedOutput = {
  __typename: "NotesMovedOutput";
  channelId: Scalars["ID"]["output"];
  ids: Array<Scalars["ID"]["output"]>;
  parentNoteId?: Maybe<Scalars["ID"]["output"]>;
};

export type NotesSharedWithMeInput = {
  pagination: PaginationInput;
};

export type NotesSharedWithUserConnection = Connection & {
  __typename: "NotesSharedWithUserConnection";
  edges: Array<NoteSharedWithUserEdge>;
  nodes: Array<NoteSharedWithUser>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NotesUnarchivedOutput = {
  __typename: "NotesUnarchivedOutput";
  ids: Array<Scalars["ID"]["output"]>;
};

/** Wink wink */
export type NotesUpdatedOutput = {
  __typename: "NotesUpdatedOutput";
  notes: Array<Note>;
};

export type Notification = Node & {
  __typename: "Notification";
  aknowledgedAt?: Maybe<Scalars["Date"]["output"]>;
  author?: Maybe<User>;
  createdAt: Scalars["Date"]["output"];
  data?: Maybe<NotificationData>;
  displayedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  reminderAt?: Maybe<Scalars["Date"]["output"]>;
  type: NotificationType;
  updatedAt: Scalars["Date"]["output"];
  user: User;
};

export type NotificationAddThreadToNoteData = {
  __typename: "NotificationAddThreadToNoteData";
  firstComment: Comment;
  note: Note;
  thread: Thread;
};

export type NotificationAddUserToChannelData = {
  __typename: "NotificationAddUserToChannelData";
  addedBy: User;
  channel: Channel;
};

export type NotificationAskReportedQuestionAssignedData = {
  __typename: "NotificationAskReportedQuestionAssignedData";
  askReportedQuestion: AskReportedQuestion;
};

export type NotificationAskReportedQuestionSolvedData = {
  __typename: "NotificationAskReportedQuestionSolvedData";
  askReportedQuestion: AskReportedQuestion;
};

export type NotificationAskReportedQuestionUnassignedData = {
  __typename: "NotificationAskReportedQuestionUnassignedData";
  askReportedQuestion: AskReportedQuestion;
};

export type NotificationChange = {
  __typename: "NotificationChange";
  notification: Notification;
};

export type NotificationConnection = Connection & {
  __typename: "NotificationConnection";
  edges: Array<NotificationEdge>;
  nodes: Array<Notification>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type NotificationCountByPriority = {
  __typename: "NotificationCountByPriority";
  high: Scalars["Int"]["output"];
  low: Scalars["Int"]["output"];
};

export type NotificationCreationInput = {
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  type: NotificationType;
  userId: Scalars["ID"]["input"];
};

export type NotificationData =
  | NotificationAddThreadToNoteData
  | NotificationAddUserToChannelData
  | NotificationAskReportedQuestionAssignedData
  | NotificationAskReportedQuestionSolvedData
  | NotificationAskReportedQuestionUnassignedData
  | NotificationMadeDecisionInThreadData
  | NotificationMentionInCommentData
  | NotificationMentionInNoteData
  | NotificationNoteAddReactionData
  | NotificationNoteAutomaticallyCreatedData
  | NotificationNoteDateTimeReminderData
  | NotificationNoteEditedData
  | NotificationNoteFirstTimeViewData
  | NotificationNoteImportCompletedData
  | NotificationNoteImportFailedData
  | NotificationNoteReviewBecameOutOfDateData
  | NotificationNoteReviewBecameOutOfDateWithMessageData
  | NotificationNoteReviewBecamePendingReviewData
  | NotificationNoteReviewBecameVerificationRequestedData
  | NotificationNoteReviewWillExpireData
  | NotificationNoteSharedData
  | NotificationNudgeAboutNoteData
  | NotificationReplyToCommentData
  | NotificationRequestChannelAccessData
  | NotificationRequestNoteAccessData
  | NotificationUpdateUserRolesOnChannelData
  | NotificationUserGroupMentionedInCommentData
  | NotificationUserGroupMentionedInNoteData;

export type NotificationEdge = Edge & {
  __typename: "NotificationEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Notification;
};

export type NotificationMadeDecisionInThreadData = {
  __typename: "NotificationMadeDecisionInThreadData";
  author: User;
  comment: Comment;
  content: Scalars["String"]["output"];
  excerpt: Scalars["String"]["output"];
  note: Note;
};

export type NotificationMentionInCommentData = {
  __typename: "NotificationMentionInCommentData";
  comment: Comment;
  content: Scalars["String"]["output"];
  excerpt: Scalars["String"]["output"];
  mentionedBy: User;
  note: Note;
};

export type NotificationMentionInNoteData = {
  __typename: "NotificationMentionInNoteData";
  blockId?: Maybe<Scalars["String"]["output"]>;
  editors: Array<User>;
  mentionedBy?: Maybe<User>;
  note: Note;
};

export type NotificationNoteAddReactionData = {
  __typename: "NotificationNoteAddReactionData";
  author: User;
  note: Note;
  reactionType: Scalars["String"]["output"];
};

export type NotificationNoteAutomaticallyCreatedData = {
  __typename: "NotificationNoteAutomaticallyCreatedData";
  message?: Maybe<Scalars["String"]["output"]>;
  note: Note;
};

export type NotificationNoteDateTimeReminderData = {
  __typename: "NotificationNoteDateTimeReminderData";
  author: User;
  entityId?: Maybe<Scalars["String"]["output"]>;
  note: Note;
};

export type NotificationNoteEditedData = {
  __typename: "NotificationNoteEditedData";
  editedBy: User;
  editors: Array<User>;
  note: Note;
};

export type NotificationNoteFirstTimeViewData = {
  __typename: "NotificationNoteFirstTimeViewData";
  note: Note;
};

export type NotificationNoteImportCompletedData = {
  __typename: "NotificationNoteImportCompletedData";
  importType: Scalars["String"]["output"];
  targetNote: Note;
};

export type NotificationNoteImportFailedData = {
  __typename: "NotificationNoteImportFailedData";
  importType: Scalars["String"]["output"];
  targetNote: Note;
};

export type NotificationNoteReviewBecameOutOfDateData = {
  __typename: "NotificationNoteReviewBecameOutOfDateData";
  note: Note;
};

export type NotificationNoteReviewBecameOutOfDateWithMessageData = {
  __typename: "NotificationNoteReviewBecameOutOfDateWithMessageData";
  note: Note;
};

export type NotificationNoteReviewBecamePendingReviewData = {
  __typename: "NotificationNoteReviewBecamePendingReviewData";
  note: Note;
};

export type NotificationNoteReviewBecameVerificationRequestedData = {
  __typename: "NotificationNoteReviewBecameVerificationRequestedData";
  note: Note;
};

export type NotificationNoteReviewWillExpireData = {
  __typename: "NotificationNoteReviewWillExpireData";
  note: Note;
};

export type NotificationNoteSharedData = {
  __typename: "NotificationNoteSharedData";
  note: Note;
  sharedBy: User;
};

export type NotificationNudgeAboutNoteData = {
  __typename: "NotificationNudgeAboutNoteData";
  note: Note;
  nudgeMessage?: Maybe<Scalars["String"]["output"]>;
  nudgedBy: User;
};

export enum NotificationPriority {
  High = "HIGH",
  Low = "LOW",
}

export enum NotificationPriorityInput {
  All = "ALL",
  High = "HIGH",
  Low = "LOW",
}

export type NotificationReplyToCommentData = {
  __typename: "NotificationReplyToCommentData";
  author: User;
  comment: Comment;
  content: Scalars["String"]["output"];
  excerpt: Scalars["String"]["output"];
  note: Note;
};

export type NotificationRequestChannelAccessData = {
  __typename: "NotificationRequestChannelAccessData";
  channel: Channel;
  requestedBy: User;
};

export type NotificationRequestNoteAccessData = {
  __typename: "NotificationRequestNoteAccessData";
  note: Note;
  requestedBy: User;
};

export enum NotificationType {
  /** @deprecated Discussions have been removed */
  AddedToDiscussion = "ADDED_TO_DISCUSSION",
  AddThreadToNote = "ADD_THREAD_TO_NOTE",
  AddUserToChannel = "ADD_USER_TO_CHANNEL",
  AskReportedQuestionAssigned = "ASK_REPORTED_QUESTION_ASSIGNED",
  AskReportedQuestionSolved = "ASK_REPORTED_QUESTION_SOLVED",
  AskReportedQuestionUnassigned = "ASK_REPORTED_QUESTION_UNASSIGNED",
  /** @deprecated Discussions have been removed */
  ClosedDiscussion = "CLOSED_DISCUSSION",
  /** @deprecated Discussions have been removed */
  DiscussionAddParticipantsNudge = "DISCUSSION_ADD_PARTICIPANTS_NUDGE",
  /** @deprecated Discussions have been removed */
  DiscussionAddReplyReaction = "DISCUSSION_ADD_REPLY_REACTION",
  /** @deprecated Discussions have been removed */
  DiscussionDueDateThreeDays = "DISCUSSION_DUE_DATE_THREE_DAYS",
  /** @deprecated Discussions have been removed */
  DiscussionDueDateToday = "DISCUSSION_DUE_DATE_TODAY",
  /** @deprecated Discussions have been removed */
  DiscussionDueDateTomorrow = "DISCUSSION_DUE_DATE_TOMORROW",
  /** @deprecated Discussions have been removed */
  DiscussionHighlighted = "DISCUSSION_HIGHLIGHTED",
  /** @deprecated Discussions have been removed */
  DiscussionMyReplyHighlighted = "DISCUSSION_MY_REPLY_HIGHLIGHTED",
  /** @deprecated Discussions have been removed */
  DiscussionShared = "DISCUSSION_SHARED",
  /** @deprecated Discussions have been removed */
  MadeDecisionInDiscussion = "MADE_DECISION_IN_DISCUSSION",
  MadeDecisionInThread = "MADE_DECISION_IN_THREAD",
  /** @deprecated Discussions have been removed */
  MentionedInDiscussion = "MENTIONED_IN_DISCUSSION",
  MentionInComment = "MENTION_IN_COMMENT",
  MentionInNote = "MENTION_IN_NOTE",
  NoteAddReaction = "NOTE_ADD_REACTION",
  NoteAutomaticallyCreated = "NOTE_AUTOMATICALLY_CREATED",
  NoteDateTimeReminder = "NOTE_DATE_TIME_REMINDER",
  NoteEdited = "NOTE_EDITED",
  NoteFirstTimeView = "NOTE_FIRST_TIME_VIEW",
  NoteImportCompleted = "NOTE_IMPORT_COMPLETED",
  NoteImportFailed = "NOTE_IMPORT_FAILED",
  NoteReviewBecameOutOfDate = "NOTE_REVIEW_BECAME_OUT_OF_DATE",
  NoteReviewBecameOutOfDateWithMessage = "NOTE_REVIEW_BECAME_OUT_OF_DATE_WITH_MESSAGE",
  NoteReviewBecamePendingReview = "NOTE_REVIEW_BECAME_PENDING_REVIEW",
  NoteReviewBecameVerificationRequested = "NOTE_REVIEW_BECAME_VERIFICATION_REQUESTED",
  NoteReviewWillExpire = "NOTE_REVIEW_WILL_EXPIRE",
  NoteShared = "NOTE_SHARED",
  NudgeAboutNote = "NUDGE_ABOUT_NOTE",
  /** @deprecated Discussions have been removed */
  RepliedToDiscussion = "REPLIED_TO_DISCUSSION",
  ReplyToComment = "REPLY_TO_COMMENT",
  RequestChannelAccess = "REQUEST_CHANNEL_ACCESS",
  RequestNoteAccess = "REQUEST_NOTE_ACCESS",
  ResolvedThreadWithoutDecision = "RESOLVED_THREAD_WITHOUT_DECISION",
  ResolvedThreadWithDecision = "RESOLVED_THREAD_WITH_DECISION",
  UpdateUserRolesOnChannel = "UPDATE_USER_ROLES_ON_CHANNEL",
  /** @deprecated Discussions have been removed */
  UserGroupAddedToDiscussion = "USER_GROUP_ADDED_TO_DISCUSSION",
  UserGroupMentionedInComment = "USER_GROUP_MENTIONED_IN_COMMENT",
  /** @deprecated Discussions have been removed */
  UserGroupMentionedInDiscussion = "USER_GROUP_MENTIONED_IN_DISCUSSION",
  UserGroupMentionedInNote = "USER_GROUP_MENTIONED_IN_NOTE",
}

export type NotificationUpdateUserRolesOnChannelData = {
  __typename: "NotificationUpdateUserRolesOnChannelData";
  channel: Channel;
  role: ChannelMemberRole;
  updatedBy: User;
};

export type NotificationUserGroupMentionedInCommentData = {
  __typename: "NotificationUserGroupMentionedInCommentData";
  comment: Comment;
  content: Scalars["String"]["output"];
  excerpt: Scalars["String"]["output"];
  mentionedBy: User;
  note: Note;
  userGroup: UserGroup;
};

export type NotificationUserGroupMentionedInNoteData = {
  __typename: "NotificationUserGroupMentionedInNoteData";
  blockId?: Maybe<Scalars["String"]["output"]>;
  editors: Array<User>;
  mentionedBy?: Maybe<User>;
  note: Note;
  userGroup: UserGroup;
};

export type NotificationsCreation = {
  __typename: "NotificationsCreation";
  createdNotifications: Array<NotificationChange>;
  id: Scalars["ID"]["output"];
  usersNotifications: UserNotifications;
};

export enum NotificationsDigestFrequency {
  Daily = "daily",
  Hourly = "hourly",
  Immediately = "immediately",
  Never = "never",
  Weekly = "weekly",
}

export type NotificationsUnreadCountUpdated = {
  __typename: "NotificationsUnreadCountUpdated";
  id: Scalars["ID"]["output"];
  unreadNotificationGroupsByPriorityCount: NotificationCountByPriority;
  /** @deprecated Use unreadNotificationGroupsByPriorityCount instead */
  unreadNotificationGroupsCount: Scalars["Int"]["output"];
};

export type NotificationsUpdate = {
  __typename: "NotificationsUpdate";
  id: Scalars["ID"]["output"];
  updatedNotifications: Array<NotificationChange>;
  usersNotifications: UserNotifications;
};

export type NotionChildren = {
  __typename: "NotionChildren";
  id: Scalars["ID"]["output"];
  lastEditedAt: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
  type: NotionChildrenType;
  url: Scalars["String"]["output"];
};

export enum NotionChildrenType {
  Database = "DATABASE",
  Page = "PAGE",
}

export type NudgeUserGroupInput = {
  message?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["ID"]["input"];
  userGroupId: Scalars["ID"]["input"];
};

export type OAuthAccessTokenInput = {
  accessToken: Scalars["String"]["input"];
  provider: OAuthProvider;
};

export enum OAuthProvider {
  Apple = "apple",
  Google = "google",
  OpenId = "openId",
  Slack = "slack",
}

export type OauthSlackTeam = {
  __typename: "OauthSlackTeam";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type OnboardingChecklist = {
  __typename: "OnboardingChecklist";
  id: Scalars["ID"]["output"];
  /** @deprecated Rely on the individual steps status instead. */
  isCompleted: Scalars["Boolean"]["output"];
  isDismissed: Scalars["Boolean"]["output"];
  steps: Array<OnboardingChecklistStep>;
};

export type OnboardingChecklistStep = {
  __typename: "OnboardingChecklistStep";
  id: Scalars["ID"]["output"];
  isCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  type: OnboardingChecklistStepType;
};

export enum OnboardingChecklistStepType {
  Ask = "ask",
  BookADemo = "bookADemo",
  ConnectExternalSource = "connectExternalSource",
  CreateChannel = "createChannel",
  CreateWorkspace = "createWorkspace",
  EnableNotifications = "enableNotifications",
  ImportDoc = "importDoc",
  ImproveWithAi = "improveWithAI",
  Invite = "invite",
}

export enum OnboardingStep {
  Done = "DONE",
  InviteByEmails = "INVITE_BY_EMAILS",
  OrganizationInformations = "ORGANIZATION_INFORMATIONS",
}

export type OnboardingTemplate = {
  __typename: "OnboardingTemplate";
  channelName: Scalars["String"]["output"];
  description: Scalars["String"]["output"];
  /** @deprecated Use iconShape instead */
  emoji: Scalars["String"]["output"];
  hasAutomation?: Maybe<Scalars["Boolean"]["output"]>;
  iconShape: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isDocChannel?: Maybe<Scalars["Boolean"]["output"]>;
  isPrivateChannel: Scalars["Boolean"]["output"];
  organizationId: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export enum OrderDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export type Organization = WithPermissions & {
  __typename: "Organization";
  activeUsersCount: Scalars["Int"]["output"];
  /** @deprecated This has its own paginated query showAllChannels */
  adminChannels?: Maybe<Array<Maybe<Channel>>>;
  asanaIntegration?: Maybe<AsanaIntegration>;
  askQuestionsRegisteringEnabledAt?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Use superEnabled instead */
  askStandaloneEnabled: Scalars["Boolean"]["output"];
  attachmentSizeLimit: Scalars["Float"]["output"];
  attioTeams: Array<AttioTeam>;
  authDomains?: Maybe<Scalars["String"]["output"]>;
  authMethod: AuthMethod;
  authProvider?: Maybe<AuthProvider>;
  automatedBackupSchedule?: Maybe<AutomatedBackupSchedule>;
  automaticallyAssignSuperSeats: Scalars["Boolean"]["output"];
  billingMethod: BillingMethods;
  confluenceTeams: Array<ConfluenceTeam>;
  /** @deprecated Use the getContacts query instead */
  contacts?: Maybe<Array<ContactUser>>;
  createdAt: Scalars["Date"]["output"];
  customEmojis: Array<CustomEmojis>;
  customPublicDomain?: Maybe<Scalars["String"]["output"]>;
  disableAsk: Scalars["Boolean"]["output"];
  disableIconSuggestionAt?: Maybe<Scalars["Date"]["output"]>;
  displayTeamBrandingOnPublicNotes: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  /** @deprecated Removed */
  enableGPT4?: Maybe<Scalars["Boolean"]["output"]>;
  featureFlags?: Maybe<Scalars["String"]["output"]>;
  features: OrganizationFeatures;
  githubTeams: Array<GithubTeam>;
  gitlabTeams: Array<OrganizationGitlabTeam>;
  goal?: Maybe<Scalars["String"]["output"]>;
  googleTeams: Array<OrganizationGoogleTeam>;
  hasCustomOpenAIKey: Scalars["Boolean"]["output"];
  hasOnboardingChecklist: Scalars["Boolean"]["output"];
  homePageNote?: Maybe<Note>;
  howDidYouHearAboutSlite?: Maybe<Scalars["String"]["output"]>;
  hubspotTeams: Array<HubspotTeam>;
  id: Scalars["ID"]["output"];
  interactionsCount: Array<InteractionsCount>;
  /** @deprecated Use joinToken instead */
  inviteToken?: Maybe<Scalars["String"]["output"]>;
  isCompany?: Maybe<Scalars["Boolean"]["output"]>;
  isInTrial: Scalars["Boolean"]["output"];
  jiraTeams: Array<JiraTeam>;
  joinToken?: Maybe<JoinToken>;
  latestBackupDoneAt?: Maybe<Scalars["Date"]["output"]>;
  linearIntegration?: Maybe<LinearIntegration>;
  /** This retrieves the users of this organization in a paginated manner */
  members?: Maybe<OrganizationUsersConnection>;
  membersCanAutoJoinByDomain: Scalars["Boolean"]["output"];
  membersCanAutoJoinByOauthProvider: Scalars["Boolean"]["output"];
  membersCanCreateChannel: Scalars["Boolean"]["output"];
  membersCanCreateUserGroup: Scalars["Boolean"]["output"];
  membersCanInvite: Scalars["Boolean"]["output"];
  membersCanListPubliclySharedNotes: Scalars["Boolean"]["output"];
  membersCanManageSuperSources: Scalars["Boolean"]["output"];
  membersCanReadAskQuestions: Scalars["Boolean"]["output"];
  microsoftTeams: Array<OrganizationMicrosoftTeam>;
  name: Scalars["String"]["output"];
  /** @deprecated Notes are not automatically set to stale anymore */
  notesBecomeStaleStaleAfter?: Maybe<ExpirationPeriodTuple>;
  notesCount: Scalars["Int"]["output"];
  notesLimit: Scalars["Int"]["output"];
  owner: User;
  paymentInfos: PaymentInfos;
  permissions: OrganizationPermissions;
  photoURL?: Maybe<Scalars["String"]["output"]>;
  previousKnowledgeBase?: Maybe<Scalars["String"]["output"]>;
  product: Product;
  requestedManualBackupAt?: Maybe<Scalars["Date"]["output"]>;
  requestedManualBackupBy?: Maybe<Scalars["String"]["output"]>;
  requestedManualBackupByUser?: Maybe<User>;
  requiredRoleForPublicSharing: RequiredRoleForPublicSharing;
  resourcesUsage: OrganizationResourcesUsage;
  rootPublicNote?: Maybe<PublicNote>;
  rootPublicUrl: Scalars["String"]["output"];
  showPaywall: Scalars["Boolean"]["output"];
  showViewersList: Scalars["Boolean"]["output"];
  size?: Maybe<Scalars["Int"]["output"]>;
  slackTeams: Array<SlackTeam>;
  sliteEnabled: Scalars["Boolean"]["output"];
  superEnabled: Scalars["Boolean"]["output"];
  superGeneralContext: Scalars["String"]["output"];
  superSlackTeams: Array<SlackTeam>;
  superSubscriptionStatus?: Maybe<SubscriptionStatus>;
  superTrialEndsAt?: Maybe<Scalars["Date"]["output"]>;
  templatesChannelId?: Maybe<Scalars["String"]["output"]>;
  trelloIntegration?: Maybe<TrelloIntegration>;
  /** @deprecated Use trialStepEndsAt instead */
  trialEndsAt?: Maybe<Scalars["Date"]["output"]>;
  trialMode?: Maybe<TrialMode>;
  trialProduct: Product;
  trialStep?: Maybe<TrialStep>;
  trialStepEndsAt?: Maybe<Scalars["Date"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  usersCount: Scalars["Int"]["output"];
  welcomeNote?: Maybe<Note>;
};

export type OrganizationContactsArgs = {
  byDisplayName?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationInteractionsCountArgs = {
  input: InteractionsCountInput;
};

export type OrganizationMembersArgs = {
  input: OrganizationUsersInput;
};

export type OrganizationAnalyticsPopularNote = {
  __typename: "OrganizationAnalyticsPopularNote";
  count: Scalars["Int"]["output"];
  lastEditedAt: Scalars["Date"]["output"];
  note: Note;
};

export type OrganizationAnalyticsPopularPublicNote = {
  __typename: "OrganizationAnalyticsPopularPublicNote";
  count: Scalars["Int"]["output"];
  note: Note;
};

export type OrganizationAnalyticsSearchTearm = {
  __typename: "OrganizationAnalyticsSearchTearm";
  count: Scalars["Int"]["output"];
  /** @deprecated Not using it anymore */
  popularMatchingNote?: Maybe<Note>;
  search: Scalars["String"]["output"];
};

export type OrganizationAnalyticsSearchTearmPopularMatchingNoteArgs = {
  period: AnalyticsPeriod;
};

export type OrganizationAnalyticsTopReader = {
  __typename: "OrganizationAnalyticsTopReader";
  count: Scalars["Int"]["output"];
  user: User;
};

export type OrganizationAnalyticsTopWriter = {
  __typename: "OrganizationAnalyticsTopWriter";
  count: Scalars["Int"]["output"];
  user: User;
};

export type OrganizationAndUrl = {
  __typename: "OrganizationAndUrl";
  organization: OrganizationPublic;
  url: Scalars["String"]["output"];
};

export type OrganizationData = {
  domain: Scalars["String"]["input"];
  goal: Scalars["String"]["input"];
  membersCanAutoJoinByDomain: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  photoURL?: InputMaybe<Scalars["String"]["input"]>;
  size: Scalars["String"]["input"];
};

export type OrganizationFeatures = {
  __typename: "OrganizationFeatures";
  automatedBackups: Scalars["Boolean"]["output"];
  /** Whether roles can be applied in a cascading manner. */
  canApplyCascadingRolesOnDocs: Scalars["Boolean"]["output"];
  /** @deprecated Discussions have been removed */
  canCreateDiscussions: Scalars["Boolean"]["output"];
  /** Allow admins to disable channel creation for members */
  canDisableMemberChannelCreation: Scalars["Boolean"]["output"];
  /** Allow admins to disable personal notes automatic backup when users are deleted */
  canDisablePersonalNotesBackup: Scalars["Boolean"]["output"];
  /** This features allows team to toggle on/off team branding appearing on their public docs */
  canDisplayTeamBrandingOnPublicPage: Scalars["Boolean"]["output"];
  canHaveReadOnlyUsers: Scalars["Boolean"]["output"];
  /** Allow admins to list publicly shared docs */
  canListPubliclySharedNotes: Scalars["Boolean"]["output"];
  /** Allow to set a public note a referenceable by search engines */
  canMakeNoteIndexeableForSearchEngines: Scalars["Boolean"]["output"];
  /**
   * Retiring discussions
   * @deprecated Discussions have been removed
   */
  canSeeDiscussions: Scalars["Boolean"]["output"];
  canSeeExternalSources: Scalars["Boolean"]["output"];
  /** This feature allows team to use a custom domain (like help.acme.com) to access their public docs */
  canSetCustomPublicDomain: Scalars["Boolean"]["output"];
  /** This feature allows team to use specify which doc is displayed when reaching their public domain root (like acme.slite.page/) */
  canSetRootPublicNote: Scalars["Boolean"]["output"];
  /**
   * Whether docs can be shared to email addresses
   * @deprecated This is always on now
   */
  canShareDocsToEmail: Scalars["Boolean"]["output"];
  /** This feature allows users to grant READ only roles on docs or channels. */
  canUseReaderRole: Scalars["Boolean"]["output"];
  /** This feature allows users to use RESTRICTED only roles on docs */
  canUseRestrictedRole: Scalars["Boolean"]["output"];
  /**
   * Whether roles can be set on private channels.
   * This only dictates if it is possible given the current plan, but does not make any asumption on the user role.
   */
  changeDocRoleOnPrivateChannel: Scalars["Boolean"]["output"];
  /**
   * Whether roles can be set on public channels.
   * This only dictates if it is possible given the current plan, but does not make any asumption on the user role.
   */
  changeDocRoleOnPublicChannel: Scalars["Boolean"]["output"];
  /** Allow setting a custom OpenAI key */
  customOpenAIKey: Scalars["Boolean"]["output"];
  /** Should display or not the try slite button on public notes */
  displayTrySliteOnPublicNotes: Scalars["Boolean"]["output"];
  editProtection: Scalars["Boolean"]["output"];
  /**
   * Use elasticsearch search engine
   * @deprecated This is not used anymore
   */
  elasticsearch: Scalars["Boolean"]["output"];
  /** Hide contact support in intercom */
  emailSupportOnly: Scalars["Boolean"]["output"];
  enforcedOAuth: Scalars["Boolean"]["output"];
  externalSources: Scalars["Boolean"]["output"];
  /** Allow to use gpt related features */
  gpt: Scalars["Boolean"]["output"];
  groupProvisioning: Scalars["Boolean"]["output"];
  /** High quota of monthly Ask credits (VS low quota for free teams) */
  highAskQuota: Scalars["Boolean"]["output"];
  /** High quota of monthly AI Assistant credits (VS low quota for free teams) */
  highAssistantQuota: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  integrations: Scalars["Boolean"]["output"];
  managePublicSharingNeededRole: Scalars["Boolean"]["output"];
  /** Protect organization settings like org name or domain behind admin (and owner) user roles */
  onlyAdminCanUpdateOrganization: Scalars["Boolean"]["output"];
  /** Protect organization billing settings behind billing admin (and above) roles */
  onlyBillingAdminCanManageBilling: Scalars["Boolean"]["output"];
  openId: Scalars["Boolean"]["output"];
  publicApi: Scalars["Boolean"]["output"];
  /** @deprecated This is not used anymore */
  publishedDocCopyButton: Scalars["Boolean"]["output"];
  /** @deprecated This is not used anymore */
  publishedDocFooter: Scalars["Boolean"]["output"];
  /**
   * Tier 1 orgs requires white glove onboarding before being able to do anything
   * This should be used to lock usage of the app
   */
  requiresWhiteGloveOnboarding: Scalars["Boolean"]["output"];
  restrictInviteFromMembers: Scalars["Boolean"]["output"];
  /** Allow semantic search */
  semanticSearch: Scalars["Boolean"]["output"];
  /** @deprecated This is not used anymore and was very costly to maintain */
  showKnowledgePanelSecondaryActions: Scalars["Boolean"]["output"];
  /** Show the list of viewers in doc insights */
  showViewersList: Scalars["Boolean"]["output"];
  teamInsights: Scalars["Boolean"]["output"];
  /** "Unlimited" quota of monthly Ask credits, limited only by fair use (premium & enterprise) */
  unlimitedAskQuota: Scalars["Boolean"]["output"];
  /** "Unlimited" quota of monthly AI Assistant credits, limited only by fair use (premium & enterprise) */
  unlimitedAssistantQuota: Scalars["Boolean"]["output"];
  /** Whether the max doc limit is applied */
  unlimitedDocs: Scalars["Boolean"]["output"];
  unlimitedHistory: Scalars["Boolean"]["output"];
  unlimitedUsers: Scalars["Boolean"]["output"];
  upgradeIncentives: Scalars["Boolean"]["output"];
  userGroups: Scalars["Boolean"]["output"];
  /** Do exported docs show a Slite branding */
  watermarkFreeExports: Scalars["Boolean"]["output"];
};

export type OrganizationGitlabTeam = {
  __typename: "OrganizationGitlabTeam";
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationGlobalActivity = {
  __typename: "OrganizationGlobalActivity";
  date: Scalars["String"]["output"];
  viewersCount: Scalars["Int"]["output"];
  writersCount: Scalars["Int"]["output"];
};

export type OrganizationGoogleTeam = {
  __typename: "OrganizationGoogleTeam";
  adminEmail: Scalars["String"]["output"];
  domain: Scalars["String"]["output"];
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type OrganizationManualBackupInput = {
  format: Scalars["String"]["input"];
};

export type OrganizationMicrosoftTeam = {
  __typename: "OrganizationMicrosoftTeam";
  clientId: Scalars["String"]["output"];
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  tenantId: Scalars["String"]["output"];
};

export type OrganizationPermissions = Permissions & {
  __typename: "OrganizationPermissions";
  createChannel: Scalars["Boolean"]["output"];
  createUserGroup: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  import: Scalars["Boolean"]["output"];
  invalidateVerificationStatus: Scalars["Boolean"]["output"];
  invite: Scalars["Boolean"]["output"];
  manage: Scalars["Boolean"]["output"];
  manageBilling: Scalars["Boolean"]["output"];
  manageChannels: Scalars["Boolean"]["output"];
  manageIntegrations: Scalars["Boolean"]["output"];
  manageSuperSources: Scalars["Boolean"]["output"];
  manageUserGroups: Scalars["Boolean"]["output"];
  manageUsers: Scalars["Boolean"]["output"];
  read: Scalars["Boolean"]["output"];
  readAskQuestions: Scalars["Boolean"]["output"];
  seeOrganizationAnalytics: Scalars["Boolean"]["output"];
  useKnowledgeManagementPanel: Scalars["Boolean"]["output"];
  useTemplates: Scalars["Boolean"]["output"];
  verifyReadableDocs: Scalars["Boolean"]["output"];
  verifyWriteableDocs: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type OrganizationPublic = {
  __typename: "OrganizationPublic";
  authDomains?: Maybe<Scalars["String"]["output"]>;
  authMethod: AuthMethod;
  authProvider?: Maybe<AuthProviderPublic>;
  customEmojis: Array<CustomEmojis>;
  customPublicDomain?: Maybe<Scalars["String"]["output"]>;
  displayTeamBrandingOnPublicNotes: Scalars["Boolean"]["output"];
  domain: Scalars["String"]["output"];
  featureFlags?: Maybe<Scalars["String"]["output"]>;
  features: OrganizationFeatures;
  hasCustomOpenAIKey: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** @deprecated Renamed to membersCanAutoJoinByDomain to introduce membersCanAutoJoinByOauthProvider */
  membersCanAutoJoin: Scalars["Boolean"]["output"];
  membersCanAutoJoinByDomain: Scalars["Boolean"]["output"];
  membersCanAutoJoinByOauthProvider: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  photoURL?: Maybe<Scalars["String"]["output"]>;
  product: Product;
  rootPublicNote?: Maybe<PublicNote>;
  rootPublicUrl: Scalars["String"]["output"];
  sliteEnabled: Scalars["Boolean"]["output"];
  superEnabled: Scalars["Boolean"]["output"];
};

export type OrganizationResourceUsageExternalSources = {
  __typename: "OrganizationResourceUsageExternalSources";
  current: Scalars["Int"]["output"];
  limit?: Maybe<Scalars["Int"]["output"]>;
};

export type OrganizationResourceUsageNote = {
  __typename: "OrganizationResourceUsageNote";
  current: Scalars["Int"]["output"];
  limit?: Maybe<Scalars["Int"]["output"]>;
};

export type OrganizationResourceUsagePeriod = {
  __typename: "OrganizationResourceUsagePeriod";
  end: Scalars["Date"]["output"];
  start: Scalars["Date"]["output"];
};

export type OrganizationResourceUsageStorage = {
  __typename: "OrganizationResourceUsageStorage";
  current: Scalars["Float"]["output"];
  limit?: Maybe<Scalars["Float"]["output"]>;
};

export type OrganizationResourcesUsage = {
  __typename: "OrganizationResourcesUsage";
  externalSources: OrganizationResourceUsageExternalSources;
  id: Scalars["ID"]["output"];
  notes: OrganizationResourceUsageNote;
  period: OrganizationResourceUsagePeriod;
  storage: OrganizationResourceUsageStorage;
};

export enum OrganizationRole {
  Admin = "admin",
  BillingAdmin = "billingAdmin",
  Guest = "guest",
  Member = "member",
  Owner = "owner",
  Reader = "reader",
}

export type OrganizationTopSearchHit = {
  __typename: "OrganizationTopSearchHit";
  count: Scalars["Int"]["output"];
  note: Note;
};

export type OrganizationUpdateInput = {
  askEnabledAt?: InputMaybe<Scalars["Date"]["input"]>;
  askQuestionsRegisteringEnabledAt?: InputMaybe<Scalars["Date"]["input"]>;
  authDomains?: InputMaybe<Scalars["String"]["input"]>;
  automatedBackupSchedule?: InputMaybe<AutomatedBackupSchedule>;
  customOpenAIKey?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Renamed to askEnabledAt */
  disableAsk?: InputMaybe<Scalars["Boolean"]["input"]>;
  disableIconSuggestionAt?: InputMaybe<Scalars["Date"]["input"]>;
  /** @deprecated Removed */
  enableGPT4?: InputMaybe<Scalars["Boolean"]["input"]>;
  featureFlags?: InputMaybe<Scalars["String"]["input"]>;
  goal?: InputMaybe<Scalars["String"]["input"]>;
  howDidYouHearAboutSlite?: InputMaybe<Scalars["String"]["input"]>;
  isCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanAutoJoin?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanAutoJoinByDomain?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanAutoJoinByOauthProvider?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanCreateChannel?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanCreateUserGroup?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanInvite?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanListPubliclySharedNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanManageSuperSources?: InputMaybe<Scalars["Boolean"]["input"]>;
  membersCanReadAskQuestions?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Removed */
  onboardingStep?: InputMaybe<OnboardingStep>;
  photoURL?: InputMaybe<Scalars["String"]["input"]>;
  previousKnowledgeBase?: InputMaybe<Scalars["String"]["input"]>;
  remoteStance?: InputMaybe<Scalars["String"]["input"]>;
  requiredRoleForPublicSharing?: InputMaybe<RequiredRoleForPublicSharing>;
  showViewersList?: InputMaybe<Scalars["Boolean"]["input"]>;
  size?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum OrganizationUserMembershipStatus {
  Contact = "contact",
  Invitee = "invitee",
  Joinable = "joinable",
  Member = "member",
}

export type OrganizationUsersConnection = Connection & {
  __typename: "OrganizationUsersConnection";
  edges: Array<UserEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type OrganizationUsersInput = {
  guestFilter?: InputMaybe<UserGuestFilter>;
  includeArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  inviteFilter?: InputMaybe<UserInviteFilter>;
  onlyInvited?: InputMaybe<Scalars["Boolean"]["input"]>;
  order?: InputMaybe<UserOrder>;
  pagination: PaginationInput;
  queryFilter?: InputMaybe<Scalars["String"]["input"]>;
};

export type PageInfo = {
  __typename: "PageInfo";
  endCursor?: Maybe<Scalars["Cursor"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor?: Maybe<Scalars["Cursor"]["output"]>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  includeCursor?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ParentFilter = {
  __typename: "ParentFilter";
  iconColor?: Maybe<Scalars["String"]["output"]>;
  iconShape?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  notionIcon?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type PaymentAuthorizationInfos = {
  __typename: "PaymentAuthorizationInfos";
  clientSecret: Scalars["String"]["output"];
};

export type PaymentInfos = {
  __typename: "PaymentInfos";
  addressCity?: Maybe<Scalars["String"]["output"]>;
  addressCountry?: Maybe<Scalars["String"]["output"]>;
  addressLine1?: Maybe<Scalars["String"]["output"]>;
  addressLine2?: Maybe<Scalars["String"]["output"]>;
  addressName?: Maybe<Scalars["String"]["output"]>;
  addressPostalCode?: Maybe<Scalars["String"]["output"]>;
  addressState?: Maybe<Scalars["String"]["output"]>;
  billingEmail?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `paymentMethod.card.brand` instead. */
  cardBrand?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `paymentMethod.card.expMonth` instead. */
  cardExpMonth?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use `paymentMethod.card.expYear` instead. */
  cardExpYear?: Maybe<Scalars["Int"]["output"]>;
  coupon?: Maybe<Coupon>;
  credit?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  /** @deprecated Use `paymentMethod.card.last4` instead. */
  last4?: Maybe<Scalars["String"]["output"]>;
  organization: Organization;
  paymentMethod?: Maybe<PaymentMethod>;
  plan?: Maybe<Plan>;
  plans: Array<Plan>;
  subscription?: Maybe<PlanSubscription>;
  subscriptionEndedAt?: Maybe<Scalars["Date"]["output"]>;
  vatId?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentMethod = {
  __typename: "PaymentMethod";
  card?: Maybe<CardPaymentMethod>;
  id: Scalars["ID"]["output"];
  type: PaymentMethodType;
};

export enum PaymentMethodType {
  Card = "card",
}

export type Permissions = {
  id: Scalars["ID"]["output"];
  manage: Scalars["Boolean"]["output"];
  read: Scalars["Boolean"]["output"];
  write: Scalars["Boolean"]["output"];
};

export type Plan = {
  __typename: "Plan";
  amount: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  interval: PlanInterval;
  isFree: Scalars["Boolean"]["output"];
  monthlyPricePerUser: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  product: Product;
};

export enum PlanInterval {
  Month = "month",
  Year = "year",
}

export type PlanSubscription = {
  __typename: "PlanSubscription";
  canceledAt?: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  createdById: Scalars["ID"]["output"];
  currentPeriodEnd: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  status: SubscriptionStatus;
  totalPerInterval?: Maybe<Scalars["Int"]["output"]>;
  trialEndAt?: Maybe<Scalars["Date"]["output"]>;
};

export type PlanSubscriptionInput = {
  addressCity: Scalars["String"]["input"];
  addressCountry: Scalars["String"]["input"];
  addressLine1: Scalars["String"]["input"];
  addressLine2?: InputMaybe<Scalars["String"]["input"]>;
  addressName: Scalars["String"]["input"];
  addressPostalCode: Scalars["String"]["input"];
  addressState?: InputMaybe<Scalars["String"]["input"]>;
  email: Scalars["String"]["input"];
  isCompany: Scalars["Boolean"]["input"];
  planId: Scalars["ID"]["input"];
  /** @deprecated Not used anymore. */
  token?: InputMaybe<Scalars["String"]["input"]>;
  trial?: InputMaybe<Scalars["Boolean"]["input"]>;
  vatId?: InputMaybe<Scalars["String"]["input"]>;
  vatType?: InputMaybe<StripeVatType>;
};

export type PlanSwitchInput = {
  planId: Scalars["ID"]["input"];
};

export type PopularNote = {
  __typename: "PopularNote";
  note: Note;
  popularity: Scalars["Float"]["output"];
  userGroup?: Maybe<UserGroup>;
};

export type PopularNoteOrder = {
  direction: OrderDirection;
  field: PopularNoteOrderField;
};

export enum PopularNoteOrderField {
  LastActivityAt = "lastActivityAt",
  ViewCount = "viewCount",
}

export type PopularNotesConnection = Connection & {
  __typename: "PopularNotesConnection";
  edges: Array<NoteEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type PreferredLanguageInput = {
  preferredLanguage: Scalars["String"]["input"];
};

export type PreferredLanguageOutput = {
  __typename: "PreferredLanguageOutput";
  userPreferences: UserPreferences;
};

export type PreferredTimezoneInput = {
  preferredTimezone: Scalars["String"]["input"];
};

export type PreferredTimezoneOutput = {
  __typename: "PreferredTimezoneOutput";
  userPreferences: UserPreferences;
};

export enum Product {
  Enterprise = "enterprise",
  Free = "free",
  Premium = "premium",
  Solo = "solo",
  Standard = "standard",
  Student = "student",
  Trial = "trial",
}

export type PublicChannel = {
  __typename: "PublicChannel";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  notes: PublicNoteConnection;
  organizationId: Scalars["ID"]["output"];
  /** The channel's doc public role */
  publicRole?: Maybe<NotePublicRole>;
  publicShareToken?: Maybe<Scalars["String"]["output"]>;
};

export type PublicChannelNotesArgs = {
  order?: InputMaybe<NoteOrder>;
  pagination?: InputMaybe<PaginationInput>;
};

export type PublicExtensionAssistantPreset = Node & {
  __typename: "PublicExtensionAssistantPreset";
  contextPrompt?: Maybe<Scalars["String"]["output"]>;
  customPrompt?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  disabled: Scalars["Boolean"]["output"];
  iconColor?: Maybe<Scalars["String"]["output"]>;
  iconShape?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  listPosition: Scalars["Int"]["output"];
  presetFor: Array<Scalars["String"]["output"]>;
  sourceTypeList: Array<ExternalSourceType>;
  suggestedQueries: Array<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAfter?: Maybe<Scalars["String"]["output"]>;
  updatedBefore?: Maybe<Scalars["String"]["output"]>;
};

export type PublicNote = Node & {
  __typename: "PublicNote";
  /** The notes ancestors, from top level to parent. */
  ancestors: Array<PublicNote>;
  archivedAt?: Maybe<Scalars["Date"]["output"]>;
  author?: Maybe<User>;
  channel?: Maybe<PublicChannel>;
  /** @deprecated Use channel field instead */
  channelId: Scalars["ID"]["output"];
  collectionScopes: Array<CollectionScope>;
  contentAsJSON: Scalars["JSON"]["output"];
  contentAsMarkdown: Scalars["String"]["output"];
  contentAsText: Scalars["String"]["output"];
  /** @deprecated No longer used, use displayOptions instead */
  coverImageUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  /** @deprecated Use author instead */
  createdBy?: Maybe<Scalars["ID"]["output"]>;
  displayOptions?: Maybe<NoteDisplayOptions>;
  enableAsk?: Maybe<Scalars["Boolean"]["output"]>;
  hasChildren: Scalars["Boolean"]["output"];
  iconColor?: Maybe<Scalars["String"]["output"]>;
  iconShape?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isCollection?: Maybe<Scalars["Boolean"]["output"]>;
  lastActivityAt?: Maybe<Scalars["Date"]["output"]>;
  lastActivityBy?: Maybe<Scalars["ID"]["output"]>;
  listPosition: Scalars["Float"]["output"];
  /** @deprecated Use note.publicRole */
  madePubliclyEditableAt?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Use note.publicRole */
  madePubliclyEditableBy?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<PublicNoteConnection>;
  organizationId: Scalars["ID"]["output"];
  otType: NoteOtType;
  parentNote?: Maybe<PublicNote>;
  publicAskUrl: Scalars["String"]["output"];
  publicRole?: Maybe<NotePublicRole>;
  publicSearchCredentials?: Maybe<SearchCredentials>;
  /** @deprecated Use note.publicRole instead, or memberships */
  publicShareToken?: Maybe<Scalars["String"]["output"]>;
  publicUrl: Scalars["String"]["output"];
  /** @deprecated Use note.publicRole */
  publiclySharedAt?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Use note.publicRole */
  publiclySharedBy?: Maybe<Scalars["String"]["output"]>;
  showDuplicateIncentive?: Maybe<Scalars["Boolean"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type PublicNoteNotesArgs = {
  order?: InputMaybe<NoteOrder>;
  pagination?: InputMaybe<PaginationInput>;
  restrictToDirectSubnotes?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PublicNoteConnection = Connection & {
  __typename: "PublicNoteConnection";
  edges: Array<PublicNoteEdge>;
  nodes: Array<PublicNote>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type PublicNoteEdge = Edge & {
  __typename: "PublicNoteEdge";
  cursor: Scalars["Cursor"]["output"];
  node: PublicNote;
};

export type PublicRole = Node & {
  __typename: "PublicRole";
  id: Scalars["ID"]["output"];
};

export type Query = {
  __typename: "Query";
  checkExternalSourceWebsite: ExternalSourceWebsiteCheck;
  countColdNotes: Scalars["Int"]["output"];
  countEmptyNotes: Scalars["Int"]["output"];
  countInactiveNotes: Scalars["Int"]["output"];
  countMessyNotes: Scalars["Int"]["output"];
  fetchConfiguration: Configuration;
  fetchGoogleDriveFileMetadata?: Maybe<GoogleDriveFileMetadata>;
  fetchGoogleDriveSharedDrives?: Maybe<FetchGoogleDriveSharedOutput>;
  generateWebAuthNChallengeForLogin: GenerateWebAuthNChallengeForLoginOutput;
  generateWebAuthNChallengeForRegistration: GenerateWebAuthNChallengeForRegistrationOutput;
  getApplication?: Maybe<Application>;
  getApplicationByEmbedType?: Maybe<Application>;
  getApplicationNoteHandling: GetApplicationNoteHandlingOutput;
  getApplicationShareSettings?: Maybe<ApplicationShareSettings>;
  getApplications: ApplicationConnection;
  getAsanaProjects: GetAsanaProjectsOutput;
  /** @deprecated Use getAttioListsAndObjects instead */
  getAttioLists: GetAttioListsOutput;
  getAttioListsAndObjects: GetAttioListsAndObjectsOutput;
  getAuthInformation: AuthInformation;
  getAvailableSourceTypes: GetAvailableSourceTypeOutput;
  getCheckoutUrl: Scalars["String"]["output"];
  /** @deprecated Not used anymore */
  getConfluenceClouds: Array<ConfluenceCloud>;
  getConfluenceSpaces: GetConfluenceSpacesOutput;
  getContacts?: Maybe<GetContactsOutput>;
  getCustomerPortalUrl: Scalars["String"]["output"];
  getEmailHandler: EmailHandlerOutput;
  getExternalSources: Array<ExternalSource>;
  /** @deprecated Use getFileUploadUrl mutation instead */
  getFileUploadUrl: GetFileUploadUrlOutput;
  getGithubRepositories: GetGithubRepositoriesOutput;
  getGitlabProjects: GetGitlabProjectsOutput;
  getGlobalActivities: Array<OrganizationGlobalActivity>;
  getGlobalActivitiesForRange: Array<OrganizationGlobalActivity>;
  getGoogleDriveChildren?: Maybe<GetGoogleDriveChildrenOutput>;
  getJiraProjects: GetJiraProjectsOutput;
  getLinearTeams: GetLinearTeamsOutput;
  /** @deprecated Retired feature */
  getMuxVideoPlaybackUrl: GetMuxVideoPlaybackUrlOutput;
  /** @deprecated Retired feature */
  getMuxVideoUploadUrl: GetMuxVideoUploadUrlOutput;
  /** @deprecated Not using it anymore */
  getMyPopularNotes: Array<OrganizationAnalyticsPopularNote>;
  getNoteAnalytics: NoteAnalytics;
  getNoteCountAndPercentageByReviewState: GetNoteCountAndPercentageByReviewStateOutput;
  getNoteHistoryOps?: Maybe<NoteHistoryOps>;
  getNoteUserGroupRoles: NoteUserGroupRolesConnection;
  /** @deprecated Use getSourceChildren instead */
  getNotionChildren?: Maybe<GetNotionChildrenOutput>;
  getOnboardingChecklist?: Maybe<OnboardingChecklist>;
  getOnboardingChecklistStep?: Maybe<OnboardingChecklistStep>;
  getOnboardingTemplates: GetOnboardingTemplatesOutput;
  /** @deprecated Not using it anymore */
  getPopularNotes: Array<OrganizationAnalyticsPopularNote>;
  /** @deprecated Not using it anymore */
  getPopularPublicNotes: Array<OrganizationAnalyticsPopularPublicNote>;
  /** @deprecated Not using it anymore */
  getPopularSearches: Array<OrganizationAnalyticsSearchTearm>;
  /** @deprecated Not using it anymore */
  getPopularSearchesWithoutResults: Array<OrganizationAnalyticsSearchTearm>;
  getPublicExtensionAssistantPreset?: Maybe<PublicExtensionAssistantPreset>;
  getPublicExtensionAssistantPresets: Array<PublicExtensionAssistantPreset>;
  getPublicPagesABFlags: Array<Scalars["String"]["output"]>;
  getSharepointSites: GetSharepointSitesOutput;
  getSlackConversations?: Maybe<GetSlackConversationsOutput>;
  getSlackJoinedChannels?: Maybe<GetSlackJoinedChannelsOutput>;
  /** @deprecated Use getSlackJoinedChannels instead */
  getSlackJoinedPublicChannels?: Maybe<GetSlackJoinedPublicChannelsOutput>;
  /** @deprecated Use getSlackJoinedChannels instead */
  getSlackPublicChannelsForBot?: Maybe<GetSlackPublicChannelsForBotOutput>;
  getSliteLinkToken?: Maybe<Scalars["String"]["output"]>;
  getSuperExtensionButtons: Array<SuperExtensionButton>;
  getTopReaders: Array<OrganizationAnalyticsTopReader>;
  getTopReadersForRange: Array<OrganizationAnalyticsTopReader>;
  getTopWriters: Array<OrganizationAnalyticsTopWriter>;
  getTopWritersForRange: Array<OrganizationAnalyticsTopWriter>;
  getUsersNotifications?: Maybe<UserNotifications>;
  getWikiChildren?: Maybe<GetWikiChildrenOutput>;
  isEmailVerificationCodeVerified: Scalars["Boolean"]["output"];
  listArchivedNotes: NoteConnection;
  listAskHistories: ListAskHistoriesOutput;
  listAvailablePlans: Array<Plan>;
  listChannelsSharedWithGuest: Array<ChannelWithRoleInfo>;
  listColdNotes: ColdNotesConnection;
  listCurrentUserThreadActivityAknowledgments: Array<ThreadActivityAknowledgment>;
  listEmptyNotes: EmptyNotesConnection;
  listHighlightNotes: NoteConnection;
  listInactiveNotes: InactiveNotesConnection;
  listInvoices: Array<Invoice>;
  listJoinTokens: JoinTokenConnection;
  listMessyNotes: MessyNotesConnection;
  listNonHighlightNotes: NoteConnection;
  listNoteBacklinks: NoteBacklinksConnection;
  /** List all the emails accesses to a given note. */
  listNoteEmailRolesForNote: NoteEmailRoleConnection;
  listNoteHistories: NoteHistoryConnection;
  listNoteLinks: NoteBacklinksConnection;
  listNoteReactions: Array<NoteReaction>;
  /**
   * Get info (comments count) about all threads in a specific note
   * @deprecated Use threadInfo field of Note type instead
   */
  listNoteThreadInfo?: Maybe<NoteThreadInfo>;
  listNoteThreads: Array<Thread>;
  /** Return a paginated list of notes to the current users' email */
  listNotesSharedWithMyEmail: NoteConnection;
  listOngoingImports: Array<ImportStatus>;
  listPopularNotes: PopularNotesConnection;
  listPublicChannelNotes: PublicNoteConnection;
  listPublicNotes: PopularNotesConnection;
  listSharedWithGuestNotes: NotesSharedWithUserConnection;
  listSharedWithMeNotes: NotesSharedWithUserConnection;
  listSuggestedTemplates: Array<SuggestedTemplatesCategory>;
  listSuperSourcesMeta: Array<SuperSourceMeta>;
  listUserGroups: UserGroupConnection;
  me?: Maybe<User>;
  ping?: Maybe<Scalars["String"]["output"]>;
  /** Search users/groups within your team with their membership information in relation to a specific note. */
  searchForNoteMemberships: SearchForNoteMembershipsOutput;
  searchNotes?: Maybe<Array<Note>>;
  searchUnsplashPhotos?: Maybe<Array<UnsplashPhoto>>;
  shouldUserConnectToConfluence: Scalars["Boolean"]["output"];
  /** Retrieve a paginated list of channels accessible to the authenticated user */
  showAccessibleChannels: ChannelConnection;
  showAllArchivedNotes: NoteConnection;
  showAllBookmarkedNotes: Array<Note>;
  showAllChannelsForAdmin: ChannelConnection;
  showAllMissedPopularNotes: Array<PopularNote>;
  showAllPubliclySharedNotes: NoteConnection;
  showAllTemplateNotes: NoteConnection;
  showAskHistory: ShowAskHistoryOutput;
  showAskReportedQuestion?: Maybe<AskReportedQuestion>;
  showAskReportedQuestions: AskReportedQuestionsConnection;
  showChannel?: Maybe<Channel>;
  showChannels: Array<Channel>;
  /** Retrieve a list of users containing the number of interactions with each one of those. */
  showCollaborationUserList?: Maybe<Array<UserCollaborator>>;
  /** Find a comment by its id */
  showComment: ShowCommentOutput;
  showFavoriteAccessibleChannels: ChannelConnection;
  /** @deprecated Use showPublicOrganizationByHostname instead */
  showJoinableOrganizations: Array<OrganizationAndUrl>;
  showJoinedOrganizations: Array<OrganizationPublic>;
  showLastEditedNotesPaginated: NoteEditsConnection;
  showLastVisitedChannels: Array<Channel>;
  showLastVisitedNotesPaginated: NoteVisitsConnection;
  /** @deprecated Use showAllMissedPopularNotes instead. */
  showMissedPopularNotes: Array<Note>;
  showMyOrganizationUsers: OrganizationUsersConnection;
  showNote?: Maybe<Note>;
  showNoteByToken?: Maybe<Note>;
  showNotes: Array<Maybe<Note>>;
  showOrganization?: Maybe<Organization>;
  showOrganizationInviteLink?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated use public notes queries only */
  showPublicChannel?: Maybe<PublicChannel>;
  showPublicNote?: Maybe<PublicNote>;
  showPublicNoteById?: Maybe<PublicNote>;
  showPublicOrganization?: Maybe<OrganizationPublic>;
  /** @deprecated Use showPublicOrganizationByHostname instead */
  showPublicOrganizationByDomain: ShowPublicOrganizationByDomainOutput;
  showPublicOrganizationByHostname: ShowPublicOrganizationByHostnameOutput;
  showPublicOrganizations: Array<Maybe<OrganizationPublic>>;
  showSharedNoteByToken: SharedNote;
  showSuggestedNoteDestinations: Array<Note>;
  showSuperAssistant: ShowSuperAssistantOutput;
  /** Lists all current organization's super assistants. */
  showSuperAssistants: SuperAssistantsConnection;
  showSuperAutomation: SuperAutomationOutput;
  showSuperAutomations: ShowSuperAutomationsOutput;
  showTemplateNote?: Maybe<Template>;
  /** Show details about a specific thread by its id */
  showThread?: Maybe<Thread>;
  showThreadList: Array<Thread>;
  showTranslatedNoteAsHtml: ShowTranslatedNoteAsHtmlOutput;
  showUnpopularNotes: Array<Note>;
  showUser?: Maybe<User>;
  showUserGroup?: Maybe<UserGroup>;
  showUserGroups: Array<Maybe<UserGroup>>;
  /**
   * Retrieve a list of users from your organization from a list of user ids.
   *
   * ⚠️ This will accept no more than 50 ids at a time
   */
  showUserList: Array<User>;
  showUserPreferences: UserPreferences;
};

export type QueryCheckExternalSourceWebsiteArgs = {
  input: CheckExternalSourceWebsiteInput;
};

export type QueryCountColdNotesArgs = {
  input: CountColdNotesInput;
};

export type QueryCountEmptyNotesArgs = {
  input: CountEmptyNotesInput;
};

export type QueryCountInactiveNotesArgs = {
  input: CountInactiveNotesInput;
};

export type QueryCountMessyNotesArgs = {
  input: CountMessyNotesInput;
};

export type QueryFetchGoogleDriveFileMetadataArgs = {
  input: FetchGoogleDriveFileMetadataInput;
};

export type QueryGenerateWebAuthNChallengeForLoginArgs = {
  input: GenerateWebAuthNChallengeForLoginInput;
};

export type QueryGetApplicationArgs = {
  clientId: Scalars["ID"]["input"];
};

export type QueryGetApplicationByEmbedTypeArgs = {
  embedType: EmbedType;
};

export type QueryGetApplicationNoteHandlingArgs = {
  input: GetApplicationNoteHandlingInput;
};

export type QueryGetApplicationShareSettingsArgs = {
  clientId: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
  selectedText?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetApplicationsArgs = {
  input: GetApplicationsInput;
};

export type QueryGetCheckoutUrlArgs = {
  input: GetCheckoutUrlInput;
};

export type QueryGetContactsArgs = {
  input: GetContactsInput;
};

export type QueryGetEmailHandlerArgs = {
  email: Scalars["String"]["input"];
};

export type QueryGetExternalSourcesArgs = {
  input?: InputMaybe<GetExternalSourcesInput>;
};

export type QueryGetFileUploadUrlArgs = {
  input: GetFileUploadUrlInput;
};

export type QueryGetGlobalActivitiesArgs = {
  period: AnalyticsPeriod;
};

export type QueryGetGlobalActivitiesForRangeArgs = {
  input: AnalyticsForRangeInput;
};

export type QueryGetGoogleDriveChildrenArgs = {
  input: GetGoogleDriveChildrenInput;
};

export type QueryGetLinearTeamsArgs = {
  input?: InputMaybe<GetLinearTeamsInput>;
};

export type QueryGetMuxVideoPlaybackUrlArgs = {
  input: GetMuxVideoPlaybackUrlInput;
};

export type QueryGetMuxVideoUploadUrlArgs = {
  input: GetMuxVideoUploadUrlInput;
};

export type QueryGetMyPopularNotesArgs = {
  period: AnalyticsPeriod;
};

export type QueryGetNoteAnalyticsArgs = {
  excludeAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
  noteId: Scalars["ID"]["input"];
};

export type QueryGetNoteCountAndPercentageByReviewStateArgs = {
  input: GetNoteCountAndPercentageByReviewStateInput;
};

export type QueryGetNoteHistoryOpsArgs = {
  from: Scalars["Int"]["input"];
  noteId: Scalars["ID"]["input"];
  to: Scalars["Int"]["input"];
};

export type QueryGetNoteUserGroupRolesArgs = {
  noteId: Scalars["String"]["input"];
  pagination: PaginationInput;
};

export type QueryGetNotionChildrenArgs = {
  input: GetNotionChildrenInput;
};

export type QueryGetOnboardingChecklistStepArgs = {
  stepType?: InputMaybe<OnboardingChecklistStepType>;
};

export type QueryGetPopularNotesArgs = {
  period: AnalyticsPeriod;
};

export type QueryGetPopularPublicNotesArgs = {
  period: AnalyticsPeriod;
};

export type QueryGetPopularSearchesArgs = {
  period: AnalyticsPeriod;
};

export type QueryGetPopularSearchesWithoutResultsArgs = {
  period: AnalyticsPeriod;
};

export type QueryGetPublicExtensionAssistantPresetArgs = {
  input: GetPublicExtensionAssistantPresetInput;
};

export type QueryGetPublicExtensionAssistantPresetsArgs = {
  input: GetPublicExtensionAssistantPresetsInput;
};

export type QueryGetSharepointSitesArgs = {
  input?: InputMaybe<GetSharepointSitesInput>;
};

export type QueryGetSlackJoinedChannelsArgs = {
  type?: InputMaybe<SlackAppType>;
};

export type QueryGetSuperExtensionButtonsArgs = {
  input: GetSuperExtensionButtonsInput;
};

export type QueryGetTopReadersArgs = {
  period: AnalyticsPeriod;
};

export type QueryGetTopReadersForRangeArgs = {
  input: AnalyticsForRangeInput;
};

export type QueryGetTopWritersArgs = {
  period: AnalyticsPeriod;
};

export type QueryGetTopWritersForRangeArgs = {
  input: AnalyticsForRangeInput;
};

export type QueryGetWikiChildrenArgs = {
  input: GetWikiChildrenInput;
};

export type QueryIsEmailVerificationCodeVerifiedArgs = {
  email: Scalars["String"]["input"];
  emailVerificationCode: Scalars["String"]["input"];
};

export type QueryListArchivedNotesArgs = {
  order?: InputMaybe<NoteOrder>;
  pagination: PaginationInput;
  parentNoteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryListAvailablePlansArgs = {
  currency?: InputMaybe<Currency>;
};

export type QueryListChannelsSharedWithGuestArgs = {
  input: ListChannelsSharedWithGuestInput;
};

export type QueryListColdNotesArgs = {
  input: ListColdNotesInput;
};

export type QueryListCurrentUserThreadActivityAknowledgmentsArgs = {
  noteId: Scalars["ID"]["input"];
};

export type QueryListEmptyNotesArgs = {
  input: ListEmptyNotesInput;
};

export type QueryListHighlightNotesArgs = {
  pagination: PaginationInput;
};

export type QueryListInactiveNotesArgs = {
  input: ListInactiveNotesInput;
};

export type QueryListJoinTokensArgs = {
  pagination: PaginationInput;
};

export type QueryListMessyNotesArgs = {
  input: ListMessyNotesInput;
};

export type QueryListNonHighlightNotesArgs = {
  pagination: PaginationInput;
};

export type QueryListNoteBacklinksArgs = {
  input: ListNoteBacklinksInput;
};

export type QueryListNoteEmailRolesForNoteArgs = {
  noteId: Scalars["ID"]["input"];
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryListNoteHistoriesArgs = {
  noteId: Scalars["ID"]["input"];
  pagination: PaginationInput;
};

export type QueryListNoteLinksArgs = {
  input: ListNoteBacklinksInput;
};

export type QueryListNoteReactionsArgs = {
  noteId: Scalars["ID"]["input"];
};

export type QueryListNoteThreadInfoArgs = {
  noteId: Scalars["ID"]["input"];
};

export type QueryListNoteThreadsArgs = {
  noteId: Scalars["ID"]["input"];
};

export type QueryListNotesSharedWithMyEmailArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryListPopularNotesArgs = {
  input: ListPopularNotesInput;
};

export type QueryListPublicChannelNotesArgs = {
  orderBy?: InputMaybe<NoteOrder>;
  pagination?: InputMaybe<PaginationInput>;
  parentNoteId?: InputMaybe<Scalars["ID"]["input"]>;
  publicShareToken: Scalars["ID"]["input"];
};

export type QueryListPublicNotesArgs = {
  input: ListPublicNotesInput;
};

export type QueryListSharedWithGuestNotesArgs = {
  guestId: Scalars["ID"]["input"];
  includeChildren?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination: PaginationInput;
};

export type QueryListSharedWithMeNotesArgs = {
  pagination: PaginationInput;
};

export type QueryListSuggestedTemplatesArgs = {
  input: ListSuggestedTemplatesInput;
};

export type QueryListSuperSourcesMetaArgs = {
  input?: InputMaybe<ListSuperSourcesMetaInput>;
};

export type QueryListUserGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  queryFilter?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySearchForNoteMembershipsArgs = {
  input: SearchForNoteMembershipsInput;
};

export type QuerySearchNotesArgs = {
  query: Scalars["String"]["input"];
};

export type QuerySearchUnsplashPhotosArgs = {
  input: SearchUnsplashPhotosInput;
};

export type QueryShowAccessibleChannelsArgs = {
  input: UserAccessibleChannelsInput;
};

export type QueryShowAllArchivedNotesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryShowAllChannelsForAdminArgs = {
  input?: InputMaybe<ShowAllChannelsForAdminInput>;
};

export type QueryShowAllMissedPopularNotesArgs = {
  input?: InputMaybe<ShowAllMissedPopularNotesInput>;
};

export type QueryShowAllPubliclySharedNotesArgs = {
  input?: InputMaybe<ShowAllPubliclySharedNotesInput>;
};

export type QueryShowAllTemplateNotesArgs = {
  excludeCollectionNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
  order?: InputMaybe<NoteOrder>;
  pagination?: InputMaybe<PaginationInput>;
  parentNoteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryShowAskHistoryArgs = {
  input: ShowAskHistoryInput;
};

export type QueryShowAskReportedQuestionArgs = {
  input: ShowAskReportedQuestionInput;
};

export type QueryShowAskReportedQuestionsArgs = {
  input: ShowAskReportedQuestionsInput;
};

export type QueryShowChannelArgs = {
  channelId: Scalars["ID"]["input"];
  track?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryShowChannelsArgs = {
  channelsIds: Array<Scalars["ID"]["input"]>;
};

export type QueryShowCommentArgs = {
  input: ShowCommentInput;
};

export type QueryShowFavoriteAccessibleChannelsArgs = {
  input: UserFavoriteAccessibleChannelsInput;
};

export type QueryShowLastEditedNotesPaginatedArgs = {
  input?: InputMaybe<ShowLastEditedNotesPaginatedInput>;
};

export type QueryShowLastVisitedNotesPaginatedArgs = {
  input?: InputMaybe<ShowLastVisitedNotesPaginatedInput>;
};

export type QueryShowMissedPopularNotesArgs = {
  input?: InputMaybe<ShowMissedPopularNotesInput>;
};

export type QueryShowMyOrganizationUsersArgs = {
  input: OrganizationUsersInput;
};

export type QueryShowNoteArgs = {
  noteId: Scalars["ID"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
  track?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryShowNoteByTokenArgs = {
  token: Scalars["ID"]["input"];
};

export type QueryShowNotesArgs = {
  notesIds: Array<Scalars["ID"]["input"]>;
};

export type QueryShowOrganizationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryShowPublicChannelArgs = {
  publicShareToken: Scalars["ID"]["input"];
};

export type QueryShowPublicNoteArgs = {
  token: Scalars["ID"]["input"];
};

export type QueryShowPublicNoteByIdArgs = {
  hostname?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["ID"]["input"];
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  track?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryShowPublicOrganizationArgs = {
  domain: Scalars["String"]["input"];
};

export type QueryShowPublicOrganizationByDomainArgs = {
  input: ShowPublicOrganizationByDomainInput;
};

export type QueryShowPublicOrganizationByHostnameArgs = {
  input: ShowPublicOrganizationByHostnameInput;
};

export type QueryShowPublicOrganizationsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type QueryShowSharedNoteByTokenArgs = {
  token: Scalars["ID"]["input"];
};

export type QueryShowSuggestedNoteDestinationsArgs = {
  input: ShowSuggestedNoteDestinationsInput;
};

export type QueryShowSuperAssistantArgs = {
  input: ShowSuperAssistantInput;
};

export type QueryShowSuperAssistantsArgs = {
  input: ShowSuperAssistantsInput;
};

export type QueryShowSuperAutomationArgs = {
  input: ShowSuperAutomationInput;
};

export type QueryShowTemplateNoteArgs = {
  noteId: Scalars["ID"]["input"];
};

export type QueryShowThreadArgs = {
  threadId: Scalars["ID"]["input"];
};

export type QueryShowThreadListArgs = {
  noteId: Scalars["ID"]["input"];
};

export type QueryShowTranslatedNoteAsHtmlArgs = {
  input: ShowTranslatedNoteAsHtmlInput;
};

export type QueryShowUnpopularNotesArgs = {
  input?: InputMaybe<ShowUnpopularNotesInput>;
};

export type QueryShowUserArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryShowUserGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryShowUserGroupsArgs = {
  idList: Array<Scalars["ID"]["input"]>;
};

export type QueryShowUserListArgs = {
  userIdList: Array<Scalars["ID"]["input"]>;
};

export type RateAskReportedQuestionInput = {
  id: Scalars["ID"]["input"];
  rating: AskReportedQuestionUserRating;
};

export type RatePublicAskReportedQuestionInput = {
  id: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
  rating: AskReportedQuestionUserRating;
};

export type ReIdentifyUserPropertiesInput = {
  properties: Array<Scalars["UserPropertyName"]["input"]>;
};

export type ReIdentifyUserPropertiesOutput = {
  __typename: "ReIdentifyUserPropertiesOutput";
  success: Scalars["Boolean"]["output"];
};

export type RefreshOauthOutput = {
  __typename: "RefreshOauthOutput";
  user: User;
};

export type RegisterWebAuthNPublicKeyInput = {
  attestationObject: Scalars["String"]["input"];
  clientDataJSON: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  encryptedChallenge: Scalars["String"]["input"];
  rawId: Scalars["String"]["input"];
};

export type RemoveAllDatabaseLinksInput = {
  databaseId: Scalars["ID"]["input"];
};

export type RemoveCommentReactionInput = {
  commentId: Scalars["ID"]["input"];
  type: Scalars["String"]["input"];
};

export type RemoveCommentReactionOutput = {
  __typename: "RemoveCommentReactionOutput";
  comment: Comment;
};

export type RemoveDatabaseLinkInput = {
  databaseId: Scalars["ID"]["input"];
  noteId: Scalars["ID"]["input"];
  recordKey: Scalars["ID"]["input"];
};

export type RemoveFromJoinedOrganizationsInput = {
  organizationId: Scalars["ID"]["input"];
};

export type RemoveMembersFromUserGroupInput = {
  userGroupId: Scalars["ID"]["input"];
  usersToRemove: Array<Scalars["ID"]["input"]>;
};

export type RemoveMembersFromUserGroupOutput = {
  __typename: "RemoveMembersFromUserGroupOutput";
  userGroup: UserGroup;
};

export type RemoveNoteReactionInput = {
  id: Scalars["ID"]["input"];
  type: Scalars["String"]["input"];
};

export type RemoveNoteReactionOutput = {
  __typename: "RemoveNoteReactionOutput";
  note: Note;
  /** @deprecated Use note.noteReactions instead */
  noteReactions: Array<NoteReaction>;
};

export type RemoveThreadDecisionInput = {
  threadId: Scalars["ID"]["input"];
};

export type RemoveThreadDecisionOutput = {
  __typename: "RemoveThreadDecisionOutput";
  thread: Thread;
  updatedComment: Comment;
};

export type RemoveUserRoleForNoteInput = {
  noteId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type RemoveUserRoleForNoteOutput = {
  __typename: "RemoveUserRoleForNoteOutput";
  noteId: Scalars["ID"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type ReportAskQuestionInput = {
  answer?: InputMaybe<Scalars["String"]["input"]>;
  fromSuperAssistantId?: InputMaybe<Scalars["ID"]["input"]>;
  issueDetected?: InputMaybe<AskReportedQuestionIssueDetected>;
  question: Scalars["String"]["input"];
  userComment?: InputMaybe<Scalars["String"]["input"]>;
  userRating?: InputMaybe<AskReportedQuestionUserRating>;
};

export type ReportPublicAskQuestionInput = {
  answer?: InputMaybe<Scalars["String"]["input"]>;
  issueDetected?: InputMaybe<AskReportedQuestionIssueDetected>;
  noteId: Scalars["ID"]["input"];
  question: Scalars["String"]["input"];
};

export type RequestPasswordResetInput = {
  email: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
};

export type RequestPasswordResetOutput = {
  __typename: "RequestPasswordResetOutput";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum RequiredRoleForPublicSharing {
  ChannelAdmin = "channelAdmin",
  ChannelWriter = "channelWriter",
  Member = "member",
  TeamAdminOrOwner = "teamAdminOrOwner",
}

export type ResendInviteInput = {
  inviteeId: Scalars["ID"]["input"];
};

export type ResendInviteOutput = {
  __typename: "ResendInviteOutput";
  invitee: User;
};

export type ResetChildNoteAutomationInput = {
  noteId: Scalars["ID"]["input"];
};

export type ResetChildNoteAutomationOutput = {
  __typename: "ResetChildNoteAutomationOutput";
  childNoteAutomation: ChildNoteAutomation;
  note: Note;
};

export type ResetPasswordInput = {
  password: Scalars["String"]["input"];
};

export type ResetPasswordOutput = {
  __typename: "ResetPasswordOutput";
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RevertCollectionToNoteInput = {
  noteId: Scalars["ID"]["input"];
};

export type RevertCollectionToNoteOutput = {
  __typename: "RevertCollectionToNoteOutput";
  note: Note;
};

export type RevertNoteToVersionInput = {
  noteId: Scalars["ID"]["input"];
  to: Scalars["Int"]["input"];
};

export type RevertNoteToVersionOutput = {
  __typename: "RevertNoteToVersionOutput";
  note: Note;
};

export type ReviewAskReportedQuestionAnswerInput = {
  answer: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type RevokeGithubTeamInput = {
  githubTeamId: Scalars["ID"]["input"];
};

export type RevokeHubspotTeam = {
  hubspotTeamId: Scalars["ID"]["input"];
};

export type RevokeSlackTeamInput = {
  slackTeamId: Scalars["ID"]["input"];
  type?: InputMaybe<SlackAppType>;
};

export type RoleInfo = {
  __typename: "RoleInfo";
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  role: ChannelMemberRole;
};

export type SavePublicNoteAsTemplateInput = {
  includeChildren?: InputMaybe<Scalars["Boolean"]["input"]>;
  sourceNoteId: Scalars["ID"]["input"];
};

export type SavePublicNoteAsTemplateOutput = {
  __typename: "SavePublicNoteAsTemplateOutput";
  note: Note;
};

export type ScaffoldChannelInput = {
  name: Scalars["String"]["input"];
  publicNotes?: InputMaybe<Array<ScaffoldChannelPublicNotesInput>>;
  type: ChannelType;
  /** Give a template to use for channel doc */
  useSuggestedTemplatePublicShareToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type ScaffoldChannelPublicNotesInput = {
  hasAutomation?: InputMaybe<Scalars["Boolean"]["input"]>;
  publicShareToken: Scalars["ID"]["input"];
};

export type ScaffoldChannelPublicNotesWithIdInput = {
  from?: InputMaybe<Scalars["String"]["input"]>;
  hasAutomation?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type ScaffoldChannelWithIdInput = {
  name: Scalars["String"]["input"];
  publicNotes?: InputMaybe<Array<ScaffoldChannelPublicNotesWithIdInput>>;
  type: ChannelType;
  /** Give a template to use for channel doc */
  useSuggestedTemplateId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ScaffoldStructureFromIdsInput = {
  channels: Array<ScaffoldChannelWithIdInput>;
};

export type ScaffoldStructureFromIdsOutput = {
  __typename: "ScaffoldStructureFromIdsOutput";
  createdChannels: Array<Channel>;
};

export type ScaffoldStructureInput = {
  channels: Array<ScaffoldChannelInput>;
};

export type ScaffoldStructureOutput = {
  __typename: "ScaffoldStructureOutput";
  createdChannels: Array<Channel>;
};

export type ScaffoldWikiGeneratorStructureInput = {
  parentNoteId: Scalars["ID"]["input"];
  structureCacheKey: Scalars["String"]["input"];
};

export type SearchCredentials = {
  __typename: "SearchCredentials";
  /** @deprecated Algolia is not used anymore */
  searchApplicationId: Scalars["ID"]["output"];
  /** @deprecated Use generateSearchToken mutation instead */
  searchServiceToken?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Algolia is not used anymore */
  searchToken: Scalars["String"]["output"];
};

export type SearchForNoteMembershipsInput = {
  /** What note should be used as a context for the membership search. */
  noteId: Scalars["String"]["input"];
  searchTerm: Scalars["String"]["input"];
};

export type SearchForNoteMembershipsOutput = {
  __typename: "SearchForNoteMembershipsOutput";
  isGuestLimitReached?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * The list of matching results for a membership search.
   * This is purposely not a connection as we will search for a finite amount
   * of matches when querying Algolia
   *
   * Note: This might become a connection later on, but we're taking a simpler route for now.
   */
  results: Array<NoteMembershipSearchResult>;
};

export type SearchUnsplashPhotosInput = {
  query: Scalars["String"]["input"];
};

export type SendMagicLinkInput = {
  email: Scalars["String"]["input"];
  isAskXDesktop?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDesktop?: InputMaybe<Scalars["Boolean"]["input"]>;
  isMobile?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationId: Scalars["ID"]["input"];
  returnTo?: InputMaybe<Scalars["String"]["input"]>;
};

export type SetChildNoteAutomationInput = {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["ID"]["input"];
  notify?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  schedule: Scalars["String"]["input"];
};

export type SetChildNoteAutomationOutput = {
  __typename: "SetChildNoteAutomationOutput";
  childNoteAutomation: ChildNoteAutomation;
  note: Note;
};

export type SetCouponInput = {
  couponId: Scalars["String"]["input"];
};

export type SetEnabledNotificationsInSlackInput = {
  enabledNotificationsInSlack: Scalars["Boolean"]["input"];
};

export type SetEnabledNotificationsInSlackOutput = {
  __typename: "SetEnabledNotificationsInSlackOutput";
  userPreferences: UserPreferences;
};

export type SetNoteDefaultCollectionScopeInput = {
  collectionScopeId?: InputMaybe<Scalars["ID"]["input"]>;
  noteId: Scalars["ID"]["input"];
};

export type SetNoteDefaultCollectionScopeOutput = {
  __typename: "SetNoteDefaultCollectionScopeOutput";
  note: Note;
};

/**
 * Until https://github.com/graphql/graphql-spec/pull/825 is implemented in graphql-js
 * The simplest route is to have one input and validate in our code.
 */
export type SetNoteReviewStateInput = {
  newReviewState?: InputMaybe<NoteReviewState>;
  noteId: Scalars["ID"]["input"];
  /**
   * An optional message to go with the out of date review state.
   * Using this parameter with a review state that is not out of date will result in an error.
   * @deprecated Use reviewStateMessage instead
   */
  outOfDateReviewStateMessage?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * The ID of the user that will be responsible for managing this review state.
   * If not provided, we'll fallback to the note's creator.
   */
  reviewStateManagedBy?: InputMaybe<Scalars["ID"]["input"]>;
  reviewStateManagedByUserGroup?: InputMaybe<Scalars["ID"]["input"]>;
  reviewStateMessage?: InputMaybe<Scalars["String"]["input"]>;
  reviewStateStalledAt?: InputMaybe<Scalars["Date"]["input"]>;
  /**
   * This input is nullable because all states can accept a null value.
   * In transient states this will be discarded.
   * In final state, `null` means the document never stalls.
   * @deprecated Use reviewStateStalledAt instead
   */
  reviewStateWillStallAfter?: InputMaybe<NoteReviewWillStallAfterInput>;
};

export type SetNoteReviewStateOutput = {
  __typename: "SetNoteReviewStateOutput";
  note: Note;
};

export type SetNotesReviewStateInput = {
  newReviewState?: InputMaybe<NoteReviewState>;
  noteIdList: Array<Scalars["ID"]["input"]>;
  reviewStateManagedBy?: InputMaybe<Scalars["ID"]["input"]>;
  reviewStateManagedByUserGroup?: InputMaybe<Scalars["ID"]["input"]>;
  reviewStateMessage?: InputMaybe<Scalars["String"]["input"]>;
  reviewStateStalledAt?: InputMaybe<Scalars["Date"]["input"]>;
};

export type SetNotesReviewStateOutput = {
  __typename: "SetNotesReviewStateOutput";
  notes: Array<Note>;
};

export type SetNotificationsReminderInput = {
  notificationIds: Array<Scalars["ID"]["input"]>;
  reminderAt: Scalars["Date"]["input"];
};

export type SetOauthGroupNamesMappingInput = {
  oauthGroupNamesMapping: Scalars["String"]["input"];
  userGroupId: Scalars["ID"]["input"];
};

export type SetOauthGroupNamesMappingOutput = {
  __typename: "SetOauthGroupNamesMappingOutput";
  success: Scalars["Boolean"]["output"];
  userGroup: UserGroup;
};

export type SetOnboardingFlowStepInput = {
  flow: Scalars["String"]["input"];
  steps?: InputMaybe<Scalars["String"]["input"]>;
};

export type SetOnboardingFlowStepOutput = {
  __typename: "SetOnboardingFlowStepOutput";
  userPreferences: UserPreferences;
};

export type SetOrganizationAuthProviderInput = {
  clientId: Scalars["String"]["input"];
  /**
   * This field is optional for update purposes.
   * When a user is updating this value we allow the secret from the existing entry to be reused should they want to.
   */
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type SetOrganizationAuthProviderOutput = {
  __typename: "SetOrganizationAuthProviderOutput";
  success: Scalars["Boolean"]["output"];
};

export type SetOrganizationCustomPublicDomainInput = {
  customPublicDomain?: InputMaybe<Scalars["String"]["input"]>;
};

export type SetOrganizationCustomPublicDomainOutput = {
  __typename: "SetOrganizationCustomPublicDomainOutput";
  organization: Organization;
};

export type SetOrganizationDisplayTeamBrandingOnPublicNotesInput = {
  displayTeamBrandingOnPublicNotes: Scalars["Boolean"]["input"];
};

export type SetOrganizationDisplayTeamBrandingOnPublicNotesOutput = {
  __typename: "SetOrganizationDisplayTeamBrandingOnPublicNotesOutput";
  organization: Organization;
};

export type SetOrganizationJoinTokenOrganizationRoleInput = {
  organizationRole: OrganizationRole;
};

export type SetOrganizationJoinTokenOrganizationRoleOutput = {
  __typename: "SetOrganizationJoinTokenOrganizationRoleOutput";
  joinToken: JoinToken;
};

export type SetOrganizationRootPublicNoteInput = {
  rootPublicNoteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SetOrganizationRootPublicNoteOutput = {
  __typename: "SetOrganizationRootPublicNoteOutput";
  organization: Organization;
};

export type SetSuperAutomationInput = {
  destinationType?: InputMaybe<SuperAutomationDestinationType>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  excludedRecipientIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  schedule: Scalars["String"]["input"];
  subscribedUserGroupIds: Array<Scalars["ID"]["input"]>;
  subscribedUserIds: Array<Scalars["ID"]["input"]>;
  superAssistant: UpsertSuperAssistantInput;
  superAutomationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SetSuperAutomationOutput = {
  __typename: "SetSuperAutomationOutput";
  superAutomation: SuperAutomation;
};

export type SetSuperExtensionButtonInput = {
  buttonSelectorType: SuperExtensionButtonSelectorType;
  buttonSelectorValue: Scalars["String"]["input"];
  contextSelectorType: SuperExtensionButtonSelectorType;
  contextSelectorValue: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  integrationType: SuperExtensionButtonIntegrationType;
  superAssistant: UpsertSuperAssistantInput;
  templateContext?: InputMaybe<Scalars["String"]["input"]>;
  templateQuestion?: InputMaybe<Scalars["String"]["input"]>;
  urlPattern?: InputMaybe<Scalars["String"]["input"]>;
};

export type SetSuperExtensionButtonOutput = {
  __typename: "SetSuperExtensionButtonOutput";
  superExtensionButton: SuperExtensionButton;
};

export type SetUserAsOwnerOutput = {
  __typename: "SetUserAsOwnerOutput";
  success: Scalars["Boolean"]["output"];
};

export type ShareNoteToEmailInput = {
  emails: Array<Scalars["String"]["input"]>;
  message: Scalars["String"]["input"];
  noteId: Scalars["ID"]["input"];
};

export type ShareNoteToEmailOutput = {
  __typename: "ShareNoteToEmailOutput";
  success: Scalars["Boolean"]["output"];
};

export type ShareTarget = ApplicationTarget & {
  __typename: "ShareTarget";
  autofocus?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  initialValue?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  options?: Maybe<Array<ShareValueOption>>;
  required?: Maybe<Scalars["Boolean"]["output"]>;
  subLabel?: Maybe<Scalars["String"]["output"]>;
  type: ShareTargetType;
};

export enum ShareTargetType {
  Checkbox = "checkbox",
  Hidden = "hidden",
  Select = "select",
  Text = "text",
  Textarea = "textarea",
  Tile = "tile",
}

export type ShareToResult = {
  __typename: "ShareToResult";
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ShareToSlackInput = {
  attachNote: Scalars["Boolean"]["input"];
  channel: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  noteId: Scalars["ID"]["input"];
};

export type ShareValueOption = {
  __typename: "ShareValueOption";
  children?: Maybe<Array<ShareTarget>>;
  label: Scalars["String"]["output"];
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  subLabel?: Maybe<Scalars["String"]["output"]>;
  value: Scalars["String"]["output"];
};

export type SharedDrive = {
  __typename: "SharedDrive";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type SharedNote = Node & {
  __typename: "SharedNote";
  createdAt: Scalars["Date"]["output"];
  displayOptions?: Maybe<NoteDisplayOptions>;
  iconColor?: Maybe<Scalars["String"]["output"]>;
  iconShape?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastActivityAt?: Maybe<Scalars["Date"]["output"]>;
  lastActivityBy?: Maybe<Scalars["ID"]["output"]>;
  otType: NoteOtType;
  permissions: NotePermissions;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type SharepointSite = {
  __typename: "SharepointSite";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type ShowAllChannelsForAdminInput = {
  order?: InputMaybe<ChannelOrder>;
  pagination: PaginationInput;
  queryFilter?: InputMaybe<Scalars["String"]["input"]>;
};

export type ShowAllMissedPopularNotesInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  popularityFactor?: InputMaybe<Scalars["Float"]["input"]>;
  popularityPeriod?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ShowAskHistoryInput = {
  askHistoryId: Scalars["ID"]["input"];
};

export type ShowAskHistoryOutput = {
  __typename: "ShowAskHistoryOutput";
  askHistory: AskHistory;
};

export type ShowAskReportedQuestionInput = {
  id: Scalars["ID"]["input"];
};

export type ShowAskReportedQuestionsInput = {
  issueDetected?: InputMaybe<AskReportedQuestionIssueDetected>;
  onlyRated?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination: PaginationInput;
  source?: InputMaybe<AskReportedQuestionSource>;
  status?: InputMaybe<AskReportedQuestionStatus>;
};

export type ShowCommentInput = {
  commentId: Scalars["ID"]["input"];
};

export type ShowCommentOutput = {
  __typename: "ShowCommentOutput";
  comment: Comment;
};

export type ShowMissedPopularNotesInput = {
  inFavorite?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  popularityFactor?: InputMaybe<Scalars["Float"]["input"]>;
  popularityPeriod?: InputMaybe<Scalars["Int"]["input"]>;
  userGroupId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ShowPublicOrganizationByDomainInput = {
  domain: Scalars["String"]["input"];
};

export type ShowPublicOrganizationByDomainOutput = {
  __typename: "ShowPublicOrganizationByDomainOutput";
  organization?: Maybe<OrganizationPublic>;
};

export type ShowPublicOrganizationByHostnameInput = {
  hostname: Scalars["String"]["input"];
};

export type ShowPublicOrganizationByHostnameOutput = {
  __typename: "ShowPublicOrganizationByHostnameOutput";
  organization?: Maybe<OrganizationPublic>;
};

export type ShowSuggestedNoteDestinationsInput = {
  noteId: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
};

export type ShowSuperAssistantInput = {
  id: Scalars["ID"]["input"];
};

export type ShowSuperAssistantOutput = {
  __typename: "ShowSuperAssistantOutput";
  superAssistant?: Maybe<SuperAssistant>;
};

export type ShowSuperAssistantsInput = {
  pagination: PaginationInput;
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type ShowSuperAutomationInput = {
  superAutomationId: Scalars["ID"]["input"];
};

export type ShowSuperAutomationsOutput = {
  __typename: "ShowSuperAutomationsOutput";
  superAutomations: Array<SuperAutomation>;
};

export type ShowTranslatedNoteAsHtmlInput = {
  language: Scalars["String"]["input"];
  noteId: Scalars["ID"]["input"];
};

export type ShowTranslatedNoteAsHtmlOutput = {
  __typename: "ShowTranslatedNoteAsHtmlOutput";
  html: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type ShowUnpopularNotesInput = {
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SignInWithCredentialsInput = {
  email: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  password: Scalars["String"]["input"];
};

export type SignInWithCredentialsOutput = {
  __typename: "SignInWithCredentialsOutput";
  apiToken: Scalars["String"]["output"];
};

export type SignInWithWebAuthNPublicKeyInput = {
  authenticatorData: Scalars["String"]["input"];
  clientDataJSON: Scalars["String"]["input"];
  encryptedChallenge: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
  rawId: Scalars["String"]["input"];
  signature: Scalars["String"]["input"];
};

export type SignInWithWebAuthNPublicKeyOutput = {
  __typename: "SignInWithWebAuthNPublicKeyOutput";
  apiToken: Scalars["String"]["output"];
};

export enum SlackAppType {
  Slite = "slite",
  Super = "super",
}

export type SlackConversations = {
  __typename: "SlackConversations";
  color?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type SlackTeam = {
  __typename: "SlackTeam";
  appId: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  setupBy: User;
  teamId: Scalars["String"]["output"];
  teamName: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type SlackTeamForUser = {
  __typename: "SlackTeamForUser";
  appId: Scalars["String"]["output"];
  createdAt: Scalars["Date"]["output"];
  id: Scalars["ID"]["output"];
  teamId: Scalars["String"]["output"];
  teamName: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type SnoozeOutput = {
  __typename: "SnoozeOutput";
  userPreferences: UserPreferences;
};

export type StartedAbExperiment = {
  __typename: "StartedABExperiment";
  abFlagId: Scalars["String"]["output"];
  variant: AbExperimentVariant;
};

export type StartsAbExperimentOutput = {
  __typename: "StartsABExperimentOutput";
  startedABExperiments: Array<StartedAbExperiment>;
};

export type StartsAnonymousAbExperimentOutput = {
  __typename: "StartsAnonymousABExperimentOutput";
  anonymousId: Scalars["String"]["output"];
  startedABExperiments: Array<StartedAbExperiment>;
};

export enum StripeVatType {
  AeTrn = "ae_trn",
  AuAbn = "au_abn",
  AuArn = "au_arn",
  BrCnpj = "br_cnpj",
  BrCpf = "br_cpf",
  CaBn = "ca_bn",
  CaGstHst = "ca_gst_hst",
  CaPstBc = "ca_pst_bc",
  CaPstMb = "ca_pst_mb",
  CaPstSk = "ca_pst_sk",
  CaQst = "ca_qst",
  ChVat = "ch_vat",
  ClTin = "cl_tin",
  EsCif = "es_cif",
  EuVat = "eu_vat",
  GbVat = "gb_vat",
  GeVat = "ge_vat",
  HkBr = "hk_br",
  IdNpwp = "id_npwp",
  IlVat = "il_vat",
  InGst = "in_gst",
  JpCn = "jp_cn",
  JpRn = "jp_rn",
  KrBrn = "kr_brn",
  LiUid = "li_uid",
  MxRfc = "mx_rfc",
  MyFrp = "my_frp",
  MyItn = "my_itn",
  MySst = "my_sst",
  NoVat = "no_vat",
  NzGst = "nz_gst",
  RuInn = "ru_inn",
  RuKpp = "ru_kpp",
  SaVat = "sa_vat",
  SgGst = "sg_gst",
  SgUen = "sg_uen",
  ThVat = "th_vat",
  TwVat = "tw_vat",
  UaVat = "ua_vat",
  UsEin = "us_ein",
  ZaVat = "za_vat",
}

export enum SubdocsDisplay {
  Hidden = "hidden",
  Simple = "simple",
}

export type Subscription = {
  __typename: "Subscription";
  UserGroupChanged: UserGroup;
  UsersAddedToUserGroup: UserGroup;
  UsersRemovedUserGroup: UserGroup;
  allApplicationsRevoked?: Maybe<Scalars["Boolean"]["output"]>;
  applicationInstalled: Application;
  applicationRevoked: Application;
  askHistoryCreated: AskHistory;
  askHistoryDeleted: DeleteAskHistoryOutput;
  askHistoryMessagesAdded: AskHistory;
  askQuestionReported: AskReportedQuestion;
  askQuestionUpdated: AskReportedQuestion;
  channelActivityAknowledged: ChannelActivityAknowledgment;
  channelActivityUpdated: Channel;
  channelCreated: Channel;
  channelDeleted: Channel;
  channelMemberCreated: ChannelMember;
  channelMemberDeleted: ChannelMember;
  channelMemberUpdated: ChannelMember;
  channelUpdated: Channel;
  commentAdded: Comment;
  commentArchived: CommentArchivedSubscriptionOutput;
  commentUpdated: CommentEditedSubscriptionOutput;
  currentUserAddedToChannel: ChannelMember;
  currentUserChannelRoleChanged: ChannelRoleChange;
  currentUserRemovedFromChannel: ChannelMember;
  currentUserUserGroupChannelRoleChanged: ChannelRoleChange;
  externalSourceUpdated: ExternalSource;
  externalSourcesResourcesUsageUpdated: OrganizationResourceUsageExternalSources;
  fileImportFailed: FileImportFailedOutput;
  fileImportFinished: FileImportFinishedOutput;
  fileImportProgress: FileImportProgressOutput;
  inviteesCreated: Array<User>;
  noteActivityAknowledged: NoteActivityAknowledgment;
  noteActivityUpdated: Note;
  noteBacklinksUpdated: NoteBacklinksInfo;
  noteCollectionScopesUpdated: NoteCollectionScopesUpdatedOutput;
  noteCreated: Note;
  noteDisplayOptionsUpdated: NoteDisplayOptionsUpdatedSubscriptionOutput;
  noteImportingUpdated: NoteImportingUpdatedSubscriptionOutput;
  noteReactionsUpdated: NoteReactionsUpdatedOutput;
  noteResourcesUsageUpdated: OrganizationResourceUsageNote;
  /**
   * This subscription will be triggered when your permissions
   * on a note have possibly changed. We trigger this event only
   * for the top most note of a subtree, even in the case of cascading.
   * It is the responsibility of the clients to implement the proper logic
   * to reload subdocs if required.
   */
  noteRoleChanged: Note;
  noteTemplateCreated: Note;
  noteTemplateDeleted: Note;
  /** @deprecated Use notesUpdated instead */
  noteUpdated: Note;
  noteVideoUpdated: NoteVideoUpdatedSubscriptionOutput;
  notesArchived: NotesArchivedOutput;
  notesDeleted: NotesDeletedOutput;
  notesMoved: NotesMovedOutput;
  notesUnarchived: NotesUnarchivedOutput;
  notesUpdated: NotesUpdatedOutput;
  notificationsCreated: NotificationsCreation;
  notificationsUnreadCountUpdated: NotificationsUnreadCountUpdated;
  notificationsUpdated: NotificationsUpdate;
  onSignOut: SignOutOutput;
  onboardingChecklistStepUpdated: OnboardingChecklistStep;
  onboardingChecklistUpdated: OnboardingChecklist;
  organizationUpdated?: Maybe<Organization>;
  ping?: Maybe<Scalars["String"]["output"]>;
  signOut?: Maybe<Scalars["Boolean"]["output"]>;
  storageResourcesUsageUpdated: OrganizationResourceUsageStorage;
  superAssistantCreated: SuperAssistant;
  superAssistantDeleted: DeleteSuperAssistantOutput;
  superAssistantUpdated: SuperAssistant;
  superAutomationCreated: SuperAutomation;
  superAutomationDeleted: DeleteSuperAutomationOutput;
  superAutomationUpdated: SuperAutomation;
  threadActivitiesAknowledged: Array<ThreadActivityAknowledgment>;
  threadArchived: ThreadArchivedSubscriptionOutput;
  threadCreated: Thread;
  threadFollowsUpdated: ThreadFollowsUpdatedSubscriptionOutput;
  threadUpdated: Thread;
  userCreated?: Maybe<User>;
  userPreferencesUpdated?: Maybe<UserPreferences>;
  userPresenceOnNoteUpdated: User;
  userPresenceUpdated: UserPresence;
  userUpdated?: Maybe<User>;
};

export type SubscriptionUserGroupChangedArgs = {
  onlyMe?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SubscriptionUsersAddedToUserGroupArgs = {
  onlyMe?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SubscriptionUsersRemovedUserGroupArgs = {
  onlyMe?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SubscriptionAllApplicationsRevokedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionApplicationInstalledArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionApplicationRevokedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionAskHistoryCreatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionAskHistoryDeletedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionAskHistoryMessagesAddedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionAskQuestionReportedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionAskQuestionUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionChannelActivityUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionChannelCreatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionChannelDeletedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionChannelMemberCreatedArgs = {
  channelId: Scalars["ID"]["input"];
};

export type SubscriptionChannelMemberDeletedArgs = {
  channelId: Scalars["ID"]["input"];
};

export type SubscriptionChannelMemberUpdatedArgs = {
  channelId: Scalars["ID"]["input"];
};

export type SubscriptionChannelUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionCommentAddedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionCommentArchivedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionCommentUpdatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionExternalSourceUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionFileImportFailedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionFileImportFinishedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionFileImportProgressArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionInviteesCreatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNoteActivityUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNoteBacklinksUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNoteCollectionScopesUpdatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionNoteCreatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNoteDisplayOptionsUpdatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionNoteImportingUpdatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionNoteReactionsUpdatedArgs = {
  noteId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SubscriptionNoteRoleChangedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNoteTemplateCreatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNoteTemplateDeletedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNoteUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNoteVideoUpdatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionNotesArchivedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNotesDeletedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNotesMovedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNotesUnarchivedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionNotesUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionOnSignOutArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionOrganizationUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionSignOutArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionSuperAssistantCreatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionSuperAssistantDeletedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionSuperAssistantUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionSuperAutomationCreatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionSuperAutomationDeletedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionSuperAutomationUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionThreadArchivedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionThreadCreatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionThreadFollowsUpdatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionThreadUpdatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionUserCreatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionUserPreferencesUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionUserPresenceOnNoteUpdatedArgs = {
  noteId: Scalars["ID"]["input"];
};

export type SubscriptionUserPresenceUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export type SubscriptionUserUpdatedArgs = {
  organizationId: Scalars["ID"]["input"];
};

export enum SubscriptionStatus {
  Active = "active",
  Canceled = "canceled",
  Incomplete = "incomplete",
  IncompleteExpired = "incomplete_expired",
  PastDue = "past_due",
  Paused = "paused",
  Trialing = "trialing",
  Unpaid = "unpaid",
}

export type SuggestedTemplate = {
  __typename: "SuggestedTemplate";
  iconShape: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  organizationId: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type SuggestedTemplatesCategory = {
  __typename: "SuggestedTemplatesCategory";
  name: Scalars["String"]["output"];
  templates: Array<SuggestedTemplate>;
};

export type SuperAssistant = Node & {
  __typename: "SuperAssistant";
  automation?: Maybe<SuperAutomation>;
  contextPrompt?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["Date"]["output"];
  createdBy?: Maybe<User>;
  customPrompt?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  iconColor?: Maybe<Scalars["String"]["output"]>;
  iconShape?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  listPosition: Scalars["Int"]["output"];
  parentList: Array<ParentFilter>;
  presetId?: Maybe<Scalars["ID"]["output"]>;
  slackChannelBindings: Array<SuperAssistantSlackChannelBinding>;
  sourceTypeList: Array<ExternalSourceType>;
  suggestedQueries: Array<Scalars["String"]["output"]>;
  superExtensionButton?: Maybe<SuperExtensionButton>;
  title: Scalars["String"]["output"];
  type: SuperAssistantType;
  updatedAfter?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Date"]["output"];
  updatedBefore?: Maybe<Scalars["String"]["output"]>;
};

export type SuperAssistantEdge = Edge & {
  __typename: "SuperAssistantEdge";
  cursor: Scalars["Cursor"]["output"];
  node: SuperAssistant;
};

export type SuperAssistantSlackChannelBinding = Node & {
  __typename: "SuperAssistantSlackChannelBinding";
  createdAt: Scalars["Date"]["output"];
  createdBy: User;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  superAssistant: SuperAssistant;
  updatedAt: Scalars["Date"]["output"];
};

export enum SuperAssistantType {
  Automation = "AUTOMATION",
  Button = "BUTTON",
  Regular = "REGULAR",
}

export type SuperAssistantsConnection = Connection & {
  __typename: "SuperAssistantsConnection";
  edges: Array<SuperAssistantEdge>;
  nodes: Array<SuperAssistant>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type SuperAutomation = {
  __typename: "SuperAutomation";
  createdAt: Scalars["Date"]["output"];
  createdBy: User;
  destinationType: SuperAutomationDestinationType;
  enabled: Scalars["Boolean"]["output"];
  excludedRecipients: Array<User>;
  id: Scalars["ID"]["output"];
  lastCompletedAt?: Maybe<Scalars["Date"]["output"]>;
  organizationId: Scalars["ID"]["output"];
  schedule: Scalars["String"]["output"];
  subscribedUserGroups: Array<UserGroup>;
  subscribedUsers: Array<User>;
  superAssistant: SuperAssistant;
  updatedAt: Scalars["Date"]["output"];
};

export enum SuperAutomationDestinationType {
  Email = "EMAIL",
  Slack = "SLACK",
}

export type SuperAutomationOutput = {
  __typename: "SuperAutomationOutput";
  superAutomation: SuperAutomation;
};

export type SuperExtensionButton = Node & {
  __typename: "SuperExtensionButton";
  assistant: SuperAssistant;
  description?: Maybe<Scalars["String"]["output"]>;
  iconColor?: Maybe<Scalars["String"]["output"]>;
  iconShape?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  injectionType: Scalars["String"]["output"];
  integrationType: SuperExtensionButtonIntegrationType;
  listPosition: Scalars["Int"]["output"];
  organizationId: Scalars["String"]["output"];
  selectors: SuperExtensionButtonSelectors;
  templates: SuperExtensionButtonTemplates;
  title?: Maybe<Scalars["String"]["output"]>;
  urlPattern?: Maybe<Scalars["String"]["output"]>;
};

export enum SuperExtensionButtonIntegrationType {
  Bluesky = "BLUESKY",
  Custom = "CUSTOM",
  Gmail = "GMAIL",
  Intercom = "INTERCOM",
  Linkedin = "LINKEDIN",
  Twitter = "TWITTER",
  Zendesk = "ZENDESK",
}

export type SuperExtensionButtonSelector =
  | CssButtonSelector
  | XpathButtonSelector;

export enum SuperExtensionButtonSelectorType {
  Css = "CSS",
  Xpath = "XPATH",
}

export type SuperExtensionButtonSelectors = {
  __typename: "SuperExtensionButtonSelectors";
  button: SuperExtensionButtonSelector;
  context: SuperExtensionButtonSelector;
};

export type SuperExtensionButtonTemplates = {
  __typename: "SuperExtensionButtonTemplates";
  context?: Maybe<Scalars["String"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
};

export type SuperSourceMeta = {
  __typename: "SuperSourceMeta";
  description: Scalars["String"]["output"];
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  stage: SuperSourceStage;
};

export enum SuperSourceStage {
  Beta = "beta",
  Dev = "dev",
  Stable = "stable",
}

export type Template = Note | PublicNote;

export type TemplateCategory = {
  __typename: "TemplateCategory";
  colorClassName: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  templates: Array<Templates>;
};

export type Templates = {
  __typename: "Templates";
  doNotManagePeople: Array<OnboardingTemplate>;
  generic: Array<OnboardingTemplate>;
  managePeople: Array<OnboardingTemplate>;
  userPosition: UserPosition;
};

export type Thread = Node & {
  __typename: "Thread";
  activityCount: Scalars["Int"]["output"];
  archivedAt?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated Use commentsPaginated instead */
  comments: Array<Comment>;
  commentsPaginated: ThreadCommentConnection;
  createdAt: Scalars["Date"]["output"];
  createdBy: Scalars["ID"]["output"];
  creator: User;
  currentUserThreadStatus?: Maybe<UserThreadStatus>;
  firstComment?: Maybe<Comment>;
  followers: Array<User>;
  highlight?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastActivityAt: Scalars["Date"]["output"];
  lastActivityBy: Scalars["String"]["output"];
  lastComment?: Maybe<Comment>;
  note: Note;
  noteId: Scalars["ID"]["output"];
  resolvedAt?: Maybe<Scalars["Date"]["output"]>;
  threadInfo: ThreadInfo;
  updatedAt: Scalars["Date"]["output"];
};

export type ThreadCommentsPaginatedArgs = {
  includeActivity?: InputMaybe<Scalars["Boolean"]["input"]>;
  pagination: PaginationInput;
};

export type ThreadActivityAknowledgment = ActivityAknowledgment & {
  __typename: "ThreadActivityAknowledgment";
  acknowledgedAt: Scalars["Date"]["output"];
  /** @deprecated Use acknowledgedAt instead, this one is a typo. */
  aknowledgedAt: Scalars["Date"]["output"];
  entityId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  noteId: Scalars["ID"]["output"];
  userId: Scalars["ID"]["output"];
};

export type ThreadArchivedSubscriptionOutput = {
  __typename: "ThreadArchivedSubscriptionOutput";
  threadId: Scalars["ID"]["output"];
};

export type ThreadCommentConnection = {
  __typename: "ThreadCommentConnection";
  edges: Array<ThreadCommentEdge>;
  nodes: Array<Comment>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ThreadCommentEdge = Edge & {
  __typename: "ThreadCommentEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Comment;
};

export type ThreadCreationInput = {
  content: Scalars["String"]["input"];
  dataKey?: InputMaybe<Scalars["String"]["input"]>;
  entities?: InputMaybe<Scalars["JSON"]["input"]>;
  highlight?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["ID"]["input"];
  range?: InputMaybe<Scalars["JSON"]["input"]>;
  threadId?: InputMaybe<Scalars["ID"]["input"]>;
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ThreadFollowsUpdatedSubscriptionOutput = {
  __typename: "ThreadFollowsUpdatedSubscriptionOutput";
  thread?: Maybe<Thread>;
};

export type ThreadInfo = {
  __typename: "ThreadInfo";
  commentsCount: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  unreadCount: Scalars["Int"]["output"];
};

export enum ThreadResolutionType {
  All = "all",
  Resolved = "resolved",
  Unresolved = "unresolved",
}

export enum TokenScope {
  ApiWss = "api_wss",
  Collab = "collab",
}

export type Tokens = {
  __typename: "Tokens";
  apiToken: Scalars["String"]["output"];
  renewalToken: Scalars["String"]["output"];
};

export type TrackInteractionsInput = {
  type: TrackableInteractionsType;
};

export type TrackInteractionsOuput = {
  __typename: "TrackInteractionsOuput";
  success: Scalars["Boolean"]["output"];
};

export enum TrackableInteractionsType {
  Ask = "ASK",
  DroppedFromSearchResults = "DROPPED_FROM_SEARCH_RESULTS",
  NavigateFromSearchResults = "NAVIGATE_FROM_SEARCH_RESULTS",
  SuperQuery = "SUPER_QUERY",
}

export type TrashNotesInput = {
  /** @deprecated deletion should always be explicit */
  deleteIfUntouched?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids: Array<Scalars["ID"]["input"]>;
};

export type TrashNotesOutput = {
  __typename: "TrashNotesOutput";
  archivedNotes?: Maybe<Array<Note>>;
  deletedNotes?: Maybe<Array<Note>>;
};

export type TrelloIntegration = {
  __typename: "TrelloIntegration";
  id: Scalars["ID"]["output"];
  setupAt: Scalars["Date"]["output"];
  setupBy: User;
};

export enum TrialMode {
  Reverse = "reverse",
  Strict = "strict",
}

export enum TrialStep {
  Extension = "extension",
  ExtensionEnded = "extensionEnded",
  Initial = "initial",
  InitialEnded = "initialEnded",
}

export type UnSetNotificationsReminderInput = {
  notificationIds: Array<Scalars["ID"]["input"]>;
};

export type UnassignAskReportedQuestionsInput = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type UnbindSuperAssistantToSlackChannelInput = {
  slackChannelId: Scalars["ID"]["input"];
};

export type UnbookmarkNoteInput = {
  noteId: Scalars["ID"]["input"];
};

export type UnbookmarkNoteOutput = {
  __typename: "UnbookmarkNoteOutput";
  userPreferences: UserPreferences;
};

export type UnfavoriteChannelInput = {
  channelId: Scalars["ID"]["input"];
};

export type UnfavoriteChannelOutput = {
  __typename: "UnfavoriteChannelOutput";
  userPreferences: UserPreferences;
};

export type UnfavoriteSuperAssistantInput = {
  superAssistantId: Scalars["ID"]["input"];
};

export type UnfavoriteSuperAssistantOutput = {
  __typename: "UnfavoriteSuperAssistantOutput";
  userPreferences: UserPreferences;
};

export type UnfollowThreadInput = {
  id: Scalars["ID"]["input"];
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnfollowThreadOutput = {
  __typename: "UnfollowThreadOutput";
  thread: Thread;
};

export type UnlinkSlackChannelInput = {
  noteId: Scalars["ID"]["input"];
};

export type UnlinkSlackUserInput = {
  userId: Scalars["ID"]["input"];
};

export type UnsplashPhoto = {
  __typename: "UnsplashPhoto";
  alt?: Maybe<Scalars["String"]["output"]>;
  authorLink: Scalars["String"]["output"];
  authorName: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type UpdateAskHistoryInput = {
  askHistoryId: Scalars["ID"]["input"];
  rawState: Scalars["JSON"]["input"];
};

export type UpdateCollectionScopeInput = {
  /** @deprecated Cleaned collection from api */
  collectionSchemaId?: InputMaybe<Scalars["ID"]["input"]>;
  filters?: InputMaybe<Scalars["JSON"]["input"]>;
  hiddenColumnKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  hiddenSelectOptionKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  id: Scalars["ID"]["input"];
  layoutColumnKey?: InputMaybe<Scalars["String"]["input"]>;
  layoutType?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  noteId?: InputMaybe<Scalars["ID"]["input"]>;
  position?: InputMaybe<Scalars["Float"]["input"]>;
  sorts?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type UpdateCollectionScopeOutput = {
  __typename: "UpdateCollectionScopeOutput";
  collectionScope: CollectionScope;
};

export type UpdateExternalSourceMappingKeyInput = {
  disabled: Scalars["Boolean"]["input"];
  externalSourceId: Scalars["ID"]["input"];
  mappingKey: Scalars["String"]["input"];
};

export type UpdateGitlabTeamInput = {
  accessToken: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type UpdateGoogleTeamInput = {
  adminEmail: Scalars["String"]["input"];
  domain: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type UpdateMicrosoftTeamInput = {
  clientId: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  secret?: InputMaybe<Scalars["String"]["input"]>;
  tenantId: Scalars["String"]["input"];
};

export type UpdateNoteDisplayOptionsInput = {
  columns?: InputMaybe<NoteColumns>;
  contentWidth?: InputMaybe<NoteContentWidth>;
  directoryType?: InputMaybe<DirectoryType>;
  imagePosition?: InputMaybe<Scalars["String"]["input"]>;
  imageTints?: InputMaybe<Array<Scalars["String"]["input"]>>;
  imageUrl?: InputMaybe<Scalars["String"]["input"]>;
  layout?: InputMaybe<Scalars["String"]["input"]>;
  noteId: Scalars["ID"]["input"];
  selectedImageTint?: InputMaybe<Scalars["String"]["input"]>;
  subdocsDisplay?: InputMaybe<SubdocsDisplay>;
  /** @deprecated Cover videos are no longer used */
  videoTimeStamps?: InputMaybe<Scalars["JSON"]["input"]>;
  /** @deprecated Cover videos are no longer used */
  videoUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateNoteEmailRolesForNoteInput = {
  noteId: Scalars["ID"]["input"];
  recipients: Array<NoteEmailRoleInput>;
};

export type UpdateNoteEmailRolesForNoteOutput = {
  __typename: "UpdateNoteEmailRolesForNoteOutput";
  note: Note;
  noteEmailRoles: Array<NoteEmailRole>;
  success: Scalars["Boolean"]["output"];
};

export type UpdateNotePublicShareSettingsInput = {
  cascading?: InputMaybe<Scalars["Boolean"]["input"]>;
  enableAsk?: InputMaybe<Scalars["Boolean"]["input"]>;
  isIndexeableForSearchEngines?: InputMaybe<Scalars["Boolean"]["input"]>;
  noteId: Scalars["ID"]["input"];
  role: NotePublicRole;
  showDuplicateIncentive?: InputMaybe<Scalars["Boolean"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateNotePublicShareSettingsOutput = {
  __typename: "UpdateNotePublicShareSettingsOutput";
  note: Note;
};

export type UpdateOrganizationOutput = {
  __typename: "UpdateOrganizationOutput";
  success: Scalars["Boolean"]["output"];
};

export type UpdateOrganizationSuperGeneralContextInput = {
  superGeneralContext: Scalars["String"]["input"];
};

export type UpdateOrganizationSuperGeneralContextOutput = {
  __typename: "UpdateOrganizationSuperGeneralContextOutput";
  organization: Organization;
};

export type UpdatePublicNoteTitleInput = {
  noteId: Scalars["ID"]["input"];
  title: Scalars["String"]["input"];
};

export type UpdatePublicNoteTitleOutput = {
  __typename: "UpdatePublicNoteTitleOutput";
  publicNote: PublicNote;
};

export type UpdateSuperAssistantIconInput = {
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  iconShape?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type UpdateSuperAssistantIconOutput = {
  __typename: "UpdateSuperAssistantIconOutput";
  superAssistant: SuperAssistant;
};

export type UpdateThreadFollowersInput = {
  followerIds: Array<Scalars["ID"]["input"]>;
  threadId: Scalars["ID"]["input"];
};

export type UpdateThreadFollowersOutput = {
  __typename: "UpdateThreadFollowersOutput";
  thread?: Maybe<Thread>;
};

export type UpdateUserOrganizationRoleOutput = {
  __typename: "UpdateUserOrganizationRoleOutput";
  success: Scalars["Boolean"]["output"];
  user: User;
};

export type UpdateUserRoleForNoteInput = {
  /**
   * Wether this value should cascade down the subtree of docs
   * When false, the role will be set on the given doc only
   */
  cascading: Scalars["Boolean"]["input"];
  noteId: Scalars["ID"]["input"];
  role: NoteUserRole;
  userId: Scalars["ID"]["input"];
};

export type UpdateUserRoleForNoteOutput = {
  __typename: "UpdateUserRoleForNoteOutput";
  note: Note;
};

export enum UploadBucket {
  Private = "PRIVATE",
  Public = "PUBLIC",
  Temporary = "TEMPORARY",
}

export enum UploadDestinationFolder {
  AskTestCases = "ASK_TEST_CASES",
  Avatars = "AVATARS",
  Covers = "COVERS",
  Files = "FILES",
}

export type UpsertSuperAssistantInput = {
  contextPrompt?: InputMaybe<Scalars["String"]["input"]>;
  customPrompt?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  iconColor?: InputMaybe<Scalars["String"]["input"]>;
  iconShape?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  listPosition?: InputMaybe<Scalars["Int"]["input"]>;
  parentIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  presetId?: InputMaybe<Scalars["ID"]["input"]>;
  sourceTypeList?: InputMaybe<Array<ExternalSourceType>>;
  suggestedQueries?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<SuperAssistantType>;
  updatedAfter?: InputMaybe<Scalars["String"]["input"]>;
  updatedBefore?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpsertSuperAssistantOutput = {
  __typename: "UpsertSuperAssistantOutput";
  superAssistant: SuperAssistant;
};

export type User = IUser &
  Node & {
    __typename: "User";
    abFlags: Array<Scalars["String"]["output"]>;
    accessibleChannels?: Maybe<ChannelConnection>;
    apiKeys: Array<ApiKey>;
    archivedAt?: Maybe<Scalars["Date"]["output"]>;
    audience: Array<Audience>;
    celloToken?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use `accessibleChannels` property instead. */
    channels?: Maybe<Array<Maybe<Channel>>>;
    contacts?: Maybe<Array<ContactUser>>;
    createdAt: Scalars["Date"]["output"];
    description?: Maybe<Scalars["String"]["output"]>;
    displayName: Scalars["String"]["output"];
    email: Scalars["EmailAddress"]["output"];
    favouriteNote?: Maybe<Note>;
    groups?: Maybe<Array<UserGroup>>;
    hasOauth: Scalars["Boolean"]["output"];
    hasSuperSeat?: Maybe<Scalars["Boolean"]["output"]>;
    id: Scalars["ID"]["output"];
    intercomIdentifierHash?: Maybe<Scalars["String"]["output"]>;
    inviteAcceptedAt?: Maybe<Scalars["Date"]["output"]>;
    inviteCreatedAt?: Maybe<Scalars["Date"]["output"]>;
    invitePending?: Maybe<Scalars["Boolean"]["output"]>;
    inviterId?: Maybe<Scalars["ID"]["output"]>;
    lastActivityAt?: Maybe<Scalars["Date"]["output"]>;
    level?: Maybe<Scalars["String"]["output"]>;
    location?: Maybe<Scalars["String"]["output"]>;
    longLivedSearchToken?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use the listSharedWithMeNotes query instead */
    notesSharedWithMe?: Maybe<NoteConnection>;
    oauthProvider?: Maybe<OAuthProvider>;
    oauthProviderGroups?: Maybe<Array<Scalars["String"]["output"]>>;
    organization: Organization;
    organizationRole: OrganizationRole;
    personalChannel?: Maybe<Channel>;
    photoURL?: Maybe<Scalars["String"]["output"]>;
    position?: Maybe<Scalars["String"]["output"]>;
    presence?: Maybe<UserPresence>;
    referralURL?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use generateSearchToken mutation instead */
    searchCredentials?: Maybe<SearchCredentials>;
    slackTeam?: Maybe<SlackTeamForUser>;
    ssoEnabledAt?: Maybe<Scalars["Date"]["output"]>;
    sub?: Maybe<Scalars["String"]["output"]>;
    superSlackTeam?: Maybe<SlackTeamForUser>;
    updatedAt: Scalars["Date"]["output"];
    username: Scalars["String"]["output"];
  };

export type UserAccessibleChannelsArgs = {
  input: UserAccessibleChannelsInput;
};

export type UserNotesSharedWithMeArgs = {
  input: NotesSharedWithMeInput;
};

export type UserAccessibleChannelsInput = {
  order?: InputMaybe<ChannelOrder>;
  pagination: PaginationInput;
};

export type UserAssociation = {
  __typename: "UserAssociation";
  redirectUrl: Scalars["String"]["output"];
};

export type UserCollaborator = {
  __typename: "UserCollaborator";
  id: Scalars["ID"]["output"];
  numberOfInteractions: Scalars["Int"]["output"];
};

export type UserConnection = Connection & {
  __typename: "UserConnection";
  edges: Array<UserEdge>;
  id: Scalars["ID"]["output"];
  nodes: Array<User>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type UserData = {
  displayName: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  emailVerificationCode: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type UserDiscussionStatus = {
  __typename: "UserDiscussionStatus";
  acknowledgedAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  /** @deprecated Use isParticipating instead */
  isFollowing: Scalars["Boolean"]["output"];
  isParticipating: Scalars["Boolean"]["output"];
  lastAcknowledgedReply?: Maybe<DiscussionReply>;
};

export type UserEdge = Edge & {
  __typename: "UserEdge";
  cursor: Scalars["Cursor"]["output"];
  node: User;
};

export type UserFavoriteAccessibleChannelsInput = {
  order?: InputMaybe<ChannelOrder>;
  pagination: PaginationInput;
};

export type UserGroup = Node & {
  __typename: "UserGroup";
  createdAt: Scalars["Date"]["output"];
  createdBy?: Maybe<User>;
  description: Scalars["String"]["output"];
  enabledGroupProvisioningAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["ID"]["output"];
  members: UserConnection;
  name: Scalars["String"]["output"];
  oauthGroupNamesMapping?: Maybe<Scalars["String"]["output"]>;
  permissions: UserGroupPermissions;
  updatedAt: Scalars["Date"]["output"];
};

export type UserGroupMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type UserGroupConnection = Connection & {
  __typename: "UserGroupConnection";
  edges: Array<UserGroupEdge>;
  id: Scalars["ID"]["output"];
  nodes: Array<UserGroup>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type UserGroupEdge = Edge & {
  __typename: "UserGroupEdge";
  cursor: Scalars["Cursor"]["output"];
  node: UserGroup;
};

export type UserGroupInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  userIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupPermissions = {
  __typename: "UserGroupPermissions";
  delete: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  manage: Scalars["Boolean"]["output"];
};

export enum UserGuestFilter {
  ExcludeGuests = "EXCLUDE_GUESTS",
  IncludeGuests = "INCLUDE_GUESTS",
  OnlyGuests = "ONLY_GUESTS",
}

export enum UserInviteFilter {
  ExcludePendingInvites = "EXCLUDE_PENDING_INVITES",
  IncludePendingInvites = "INCLUDE_PENDING_INVITES",
  OnlyPendingInvites = "ONLY_PENDING_INVITES",
}

export enum UserLevel {
  DepartmentLead = "DepartmentLead",
  Executive = "Executive",
  Freelancer = "Freelancer",
  Other = "Other",
  Perso = "Perso",
  TeamManager = "TeamManager",
  TeamMember = "TeamMember",
}

export type UserNoteStatus = Node & {
  __typename: "UserNoteStatus";
  id: Scalars["ID"]["output"];
  isFollowing: Scalars["Boolean"]["output"];
};

export type UserNotifications = {
  __typename: "UserNotifications";
  id: Scalars["ID"]["output"];
  notifications: NotificationConnection;
  unreadNotificationGroupsByPriorityCount: NotificationCountByPriority;
  /** @deprecated Use unreadNotificationGroupsByPriorityCount instead */
  unreadNotificationGroupsCount: Scalars["Int"]["output"];
  unreadNotifications: NotificationConnection;
};

export type UserNotificationsNotificationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  priority?: InputMaybe<NotificationPriorityInput>;
  readDaysPassedLimit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UserNotificationsUnreadNotificationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  priority?: InputMaybe<NotificationPriorityInput>;
};

export type UserOrUserGroup = User | UserGroup;

export type UserOrder = {
  direction?: InputMaybe<OrderDirection>;
  field?: InputMaybe<UserOrderField>;
};

export enum UserOrderField {
  ArchivedAt = "archivedAt",
  CreatedAt = "createdAt",
  DisplayName = "displayName",
  Email = "email",
  LastActivityAt = "lastActivityAt",
  OrganizationRole = "organizationRole",
  Username = "username",
}

export enum UserPosition {
  Ceo = "CEO",
  CustomerSupport = "CustomerSupport",
  Design = "Design",
  Engineering = "Engineering",
  Finance = "Finance",
  HumanResources = "HumanResources",
  ItAndEngineering = "ITAndEngineering",
  InternalCommunication = "InternalCommunication",
  KnowledgeManagement = "KnowledgeManagement",
  Marketing = "Marketing",
  Operations = "Operations",
  Other = "Other",
  Product = "Product",
  ProjectManagement = "ProjectManagement",
  Sales = "Sales",
  Student = "Student",
}

export type UserPreferences = {
  __typename: "UserPreferences";
  acceptedPrivacyPolicyAt?: Maybe<Scalars["Date"]["output"]>;
  bookmarkedNoteIds: Array<Maybe<Scalars["String"]["output"]>>;
  calendarType: Scalars["String"]["output"];
  changelogSeenAt?: Maybe<Scalars["Date"]["output"]>;
  closedImportContentCallToActionAt?: Maybe<Scalars["Date"]["output"]>;
  closedInviteTeammatesCallToActionAt?: Maybe<Scalars["Date"]["output"]>;
  colorMode: ColorModePreference;
  confluenceApiAuthentication?: Maybe<Scalars["JSON"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  disabledSlackAutoAsk: Scalars["Boolean"]["output"];
  dismissedContextualTips: Array<Scalars["String"]["output"]>;
  dismissedNotificationsBannerAt?: Maybe<Scalars["Date"]["output"]>;
  displayArchivedNotes: Scalars["Boolean"]["output"];
  displayColdNotes: Scalars["Boolean"]["output"];
  doNotDisturbUntil?: Maybe<Scalars["Date"]["output"]>;
  enabledNotificationsInSlack: Scalars["Boolean"]["output"];
  /** @deprecated Use favoriteSuperAssistantIds instead */
  favoriteAskContextIds: Array<Maybe<Scalars["String"]["output"]>>;
  favoriteChannelIds: Array<Maybe<Scalars["String"]["output"]>>;
  favoriteCollectionScopeIds: Array<Maybe<Scalars["String"]["output"]>>;
  favoriteSuperAssistantIds: Array<Maybe<Scalars["String"]["output"]>>;
  favouriteNoteId?: Maybe<Scalars["String"]["output"]>;
  featureFlags: Scalars["String"]["output"];
  googleDriveAccessToken?: Maybe<Scalars["String"]["output"]>;
  grantedSlackShareToPermissions?: Maybe<OauthSlackTeam>;
  hasDismissedBrowserNotificationsHint: Scalars["Boolean"]["output"];
  hasDismissedEducationCenterSidebarHint: Scalars["Boolean"]["output"];
  hasDismissedHighlightedUpdatesHint: Scalars["Boolean"]["output"];
  hasDismissedNotificationsBanner: Scalars["Boolean"]["output"];
  hasDismissedSidebarInviteLink: Scalars["Boolean"]["output"];
  hasDismissedSlackInstallHintAt: Scalars["Boolean"]["output"];
  hasGrantedOAuthContactPermissions: Scalars["Boolean"]["output"];
  hasGrantedSlackShareToPermissions: Scalars["Boolean"]["output"];
  hideInViewersList: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  isAskXDesktopUser?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Removed */
  isChannelOnboardingDone?: Maybe<Scalars["Boolean"]["output"]>;
  isDesktopUser?: Maybe<Scalars["Boolean"]["output"]>;
  lang?: Maybe<Scalars["String"]["output"]>;
  lastActivityFeedViewedAt?: Maybe<Scalars["Date"]["output"]>;
  lastSearchedTerms: Array<Scalars["String"]["output"]>;
  lastVisitedChannelIds: Array<Maybe<Scalars["String"]["output"]>>;
  lastVisitedNoteIds: Array<Maybe<Scalars["String"]["output"]>>;
  location?: Maybe<Scalars["String"]["output"]>;
  mutedChannelIds: Array<Maybe<Scalars["String"]["output"]>>;
  notificationOnEditNote: Scalars["Boolean"]["output"];
  notificationOnFirstNoteView?: Maybe<Scalars["Boolean"]["output"]>;
  notificationsDigestFrequency: NotificationsDigestFrequency;
  notionApiAuthentication?: Maybe<Scalars["JSON"]["output"]>;
  /** @deprecated Removed */
  onboardingChannelId?: Maybe<Scalars["String"]["output"]>;
  onboardingFlows: Scalars["JSON"]["output"];
  /** @deprecated Use onboardingFLows.signUp instead */
  onboardingStep?: Maybe<Scalars["String"]["output"]>;
  seenBannerDownloadDesktopApp: Scalars["Boolean"]["output"];
  seenNearNoteLimitIncentiveAt?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated SlackTeam is Attached to the user now */
  slackTeamId?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated SlackTeam is Attached to the user now */
  slackUserId?: Maybe<Scalars["String"]["output"]>;
  subscribedToOYOT: Scalars["Boolean"]["output"];
  subscribedToProductUpdates: Scalars["Boolean"]["output"];
  superChangelogSeenAt?: Maybe<Scalars["Date"]["output"]>;
  suppressedConnectApp?: Maybe<Array<Scalars["ID"]["output"]>>;
  suppressedEnableApp?: Maybe<Array<Scalars["ID"]["output"]>>;
  timezone?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<User>;
  userId: Scalars["ID"]["output"];
  webAuthNPublicKeyList: Array<WebAuthNPublicKey>;
};

export type UserPreferencesHasGrantedOAuthContactPermissionsArgs = {
  provider: OAuthProvider;
};

export type UserPresence = {
  __typename: "UserPresence";
  blockId?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  isWriting?: Maybe<Scalars["Boolean"]["output"]>;
  noteId?: Maybe<Scalars["ID"]["output"]>;
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
  wroteAt?: Maybe<Scalars["Date"]["output"]>;
};

export type UserThreadStatus = {
  __typename: "UserThreadStatus";
  id: Scalars["ID"]["output"];
  isFollowing: Scalars["Boolean"]["output"];
};

export enum UserType {
  All = "ALL",
  Contact = "CONTACT",
  User = "USER",
}

export type Utms = {
  campaign?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  medium?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  term?: InputMaybe<Scalars["String"]["input"]>;
};

export type WebAuthNAllowCredential = {
  __typename: "WebAuthNAllowCredential";
  id: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export enum WebAuthNAttestation {
  None = "none",
}

export type WebAuthNAuthenticatorSelection = {
  __typename: "WebAuthNAuthenticatorSelection";
  authenticatorAttachment: Scalars["String"]["output"];
  requireResidentKey: Scalars["Boolean"]["output"];
  userVerification: WebAuthNUserVerification;
};

export type WebAuthNChallengeRp = {
  __typename: "WebAuthNChallengeRp";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type WebAuthNPubKeyParam = {
  __typename: "WebAuthNPubKeyParam";
  alg: Scalars["Int"]["output"];
  type: Scalars["String"]["output"];
};

export type WebAuthNPublicKey = {
  __typename: "WebAuthNPublicKey";
  createdAt: Scalars["Date"]["output"];
  description: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

export type WebAuthNUser = {
  __typename: "WebAuthNUser";
  displayName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export enum WebAuthNUserVerification {
  Required = "required",
}

export type WikiChildren = {
  __typename: "WikiChildren";
  id: Scalars["ID"]["output"];
  lastEditedAt: Scalars["Date"]["output"];
  sourceType: WikiSourceType;
  title: Scalars["String"]["output"];
  type?: Maybe<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

export enum WikiSourceType {
  Confluence = "CONFLUENCE",
  Custom = "Custom",
  Notion = "NOTION",
  Website = "WEBSITE",
}

export type WithPermissions = {
  permissions: Permissions;
};

export type XpathButtonSelector = {
  __typename: "XpathButtonSelector";
  xpath: Scalars["String"]["output"];
};

export type ApplyPublicNoteOnNoteInput = {
  destinationNoteId: Scalars["ID"]["input"];
  sourceNoteId: Scalars["ID"]["input"];
};

export type ApplyPublicNoteOnNoteOutput = {
  __typename: "applyPublicNoteOnNoteOutput";
  note: Note;
};

export type CountColdNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  coldNoteThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CountEmptyNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CountInactiveNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CountMessyNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GenerateReferralUrlOutput = {
  __typename: "generateReferralURLOutput";
  user: User;
};

export type InviteBannerAcknowledgementStateInput = {
  acknowledgedAt: Scalars["Date"]["input"];
  timesClosed: Scalars["Int"]["input"];
};

export type ListColdNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  coldNoteThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pagination: PaginationInput;
};

export type ListEmptyNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pagination: PaginationInput;
};

export type ListInactiveNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pagination: PaginationInput;
};

export type ListMessyNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  noteReviewStateList?: InputMaybe<Array<NoteReviewState>>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pagination: PaginationInput;
};

export type ListNoteBacklinksInput = {
  noteId: Scalars["ID"]["input"];
  pagination: PaginationInput;
};

export type ListPopularNotesInput = {
  /** @deprecated Use `channelIdList` instead. */
  channelId?: InputMaybe<Scalars["String"]["input"]>;
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** @deprecated Use `noteReviewStateList` instead. */
  noteReviewState?: InputMaybe<NoteReviewState>;
  noteReviewStateList?: InputMaybe<Array<NoteReviewState>>;
  order?: InputMaybe<PopularNoteOrder>;
  /** @deprecated Use `ownerIdList` instead. */
  ownerId?: InputMaybe<Scalars["String"]["input"]>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pagination: PaginationInput;
  sinceDaysAgo?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ListPublicNotesInput = {
  channelIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  noteReviewStateList?: InputMaybe<Array<NoteReviewState>>;
  order?: InputMaybe<PopularNoteOrder>;
  ownerIdList?: InputMaybe<Array<Scalars["String"]["input"]>>;
  pagination: PaginationInput;
  sinceDaysAgo?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ListSuggestedTemplatesInput = {
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type RemoveNoteUserGroupRoleInput = {
  noteId: Scalars["ID"]["input"];
  userGroupId: Scalars["ID"]["input"];
};

export type RemoveNoteUserGroupRoleOutput = {
  __typename: "removeNoteUserGroupRoleOutput";
  note?: Maybe<Note>;
  success: Scalars["Boolean"]["output"];
};

export type SearchTermInput = {
  term: Scalars["String"]["input"];
};

export type SendMeInvitationInput = {
  inviteReminderType: InviteReminderType;
};

export type SetNoteUserGroupRoleInput = {
  /**
   * Wether this value should cascade down the subtree of docs
   * When false, the role will be set on the given doc only
   */
  cascading: Scalars["Boolean"]["input"];
  noteId: Scalars["ID"]["input"];
  role: NoteUserRole;
  userGroupId: Scalars["ID"]["input"];
};

export type SetNoteUserGroupRoleOutput = {
  __typename: "setNoteUserGroupRoleOutput";
  note?: Maybe<Note>;
  noteUserGroupRole: NoteUserGroupRole;
};

export type ShowAllPubliclySharedNotesInput = {
  order?: InputMaybe<NoteOrder>;
  pagination: PaginationInput;
  queryFilter?: InputMaybe<Scalars["String"]["input"]>;
};

export type ShowLastEditedNotesPaginatedInput = {
  noteType?: InputMaybe<NoteType>;
  pagination: PaginationInput;
};

export type ShowLastVisitedNotesPaginatedInput = {
  noteType?: InputMaybe<NoteType>;
  pagination: PaginationInput;
};

export type SignOutOutput = {
  __typename: "signOutOutput";
  removeTokens: Scalars["Boolean"]["output"];
};

export type StartsAbExperimentInput = {
  abFlagId: Scalars["String"]["input"];
};

export type StartsAbExperimentsOutput = {
  __typename: "startsABExperimentsOutput";
  success: Scalars["Boolean"]["output"];
};

export type StartsAnonymousAbExperimentInput = {
  abFlagId: Scalars["String"]["input"];
  anonymousId?: InputMaybe<Scalars["String"]["input"]>;
};

export type StartsBoardingAbExperimentsInput = {
  anonymousId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;

export type CreateOrganizationMutation = {
  __typename: "Mutation";
  createOrganization: { __typename: "CreateOrganizationOutput"; url: string };
};

export type CreateOrganizationWithOauthCacheKeyInputMutationVariables = Exact<{
  input: CreateOrganizationWithOauthCacheKeyInput;
}>;

export type CreateOrganizationWithOauthCacheKeyInputMutation = {
  __typename: "Mutation";
  createOrganizationWithOauthCacheKey: {
    __typename: "CreateOrganizationOutput";
    url: string;
  };
};

export type CreateEmailVerificationCodeMutationVariables = Exact<{
  input: CreateEmailVerificationCodeInput;
}>;

export type CreateEmailVerificationCodeMutation = {
  __typename: "Mutation";
  createEmailVerificationCode: {
    __typename: "CreateEmailVerificationCodeOutput";
    success: boolean;
    isPopularDomain: boolean;
    organizationName: string;
    displayName: string;
    domain?: string | null;
  };
};

export type VerifyEmailVerificationCodeMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  emailVerificationCode: Scalars["String"]["input"];
  fromOrganizationCreation?: InputMaybe<Scalars["Boolean"]["input"]>;
  fromSuper?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type VerifyEmailVerificationCodeMutation = {
  __typename: "Mutation";
  verifyEmailVerificationCode: boolean;
};

export type StartsBoardingAbExperimentsMutationVariables = Exact<{
  anonymousId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type StartsBoardingAbExperimentsMutation = {
  __typename: "Mutation";
  startsBoardingABExperiments: {
    __typename: "StartsAnonymousABExperimentOutput";
    anonymousId: string;
    startedABExperiments: Array<{
      __typename: "StartedABExperiment";
      abFlagId: string;
      variant: AbExperimentVariant;
    }>;
  };
};

export type ShowJoinableOrganizationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ShowJoinableOrganizationsQuery = {
  __typename: "Query";
  showJoinableOrganizations: Array<{
    __typename: "OrganizationAndUrl";
    url: string;
    organization: {
      __typename: "OrganizationPublic";
      id: string;
      name: string;
      photoURL?: string | null;
      domain: string;
    };
  }>;
};

export type ShowJoinedOrganizationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ShowJoinedOrganizationsQuery = {
  __typename: "Query";
  showJoinedOrganizations: Array<{
    __typename: "OrganizationPublic";
    id: string;
    name: string;
    photoURL?: string | null;
    domain: string;
  }>;
};

export type ShowPublicOrganizationQueryVariables = Exact<{
  domain: Scalars["String"]["input"];
}>;

export type ShowPublicOrganizationQuery = {
  __typename: "Query";
  showPublicOrganization?: {
    __typename: "OrganizationPublic";
    id: string;
    domain: string;
    name: string;
  } | null;
};

export const CreateOrganizationDocument = gql`
  mutation createOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      url
    }
  }
`;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrganizationMutation,
    CreateOrganizationMutationVariables
  >(CreateOrganizationDocument, options);
}
export type CreateOrganizationMutationHookResult = ReturnType<
  typeof useCreateOrganizationMutation
>;
export type CreateOrganizationMutationResult =
  Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>;
export const CreateOrganizationWithOauthCacheKeyInputDocument = gql`
  mutation createOrganizationWithOauthCacheKeyInput(
    $input: CreateOrganizationWithOauthCacheKeyInput!
  ) {
    createOrganizationWithOauthCacheKey(input: $input) {
      url
    }
  }
`;

/**
 * __useCreateOrganizationWithOauthCacheKeyInputMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationWithOauthCacheKeyInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationWithOauthCacheKeyInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationWithOauthCacheKeyInputMutation, { data, loading, error }] = useCreateOrganizationWithOauthCacheKeyInputMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationWithOauthCacheKeyInputMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrganizationWithOauthCacheKeyInputMutation,
    CreateOrganizationWithOauthCacheKeyInputMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrganizationWithOauthCacheKeyInputMutation,
    CreateOrganizationWithOauthCacheKeyInputMutationVariables
  >(CreateOrganizationWithOauthCacheKeyInputDocument, options);
}
export type CreateOrganizationWithOauthCacheKeyInputMutationHookResult =
  ReturnType<typeof useCreateOrganizationWithOauthCacheKeyInputMutation>;
export type CreateOrganizationWithOauthCacheKeyInputMutationResult =
  Apollo.MutationResult<CreateOrganizationWithOauthCacheKeyInputMutation>;
export type CreateOrganizationWithOauthCacheKeyInputMutationOptions =
  Apollo.BaseMutationOptions<
    CreateOrganizationWithOauthCacheKeyInputMutation,
    CreateOrganizationWithOauthCacheKeyInputMutationVariables
  >;
export const CreateEmailVerificationCodeDocument = gql`
  mutation createEmailVerificationCode(
    $input: CreateEmailVerificationCodeInput!
  ) {
    createEmailVerificationCode(input: $input) {
      success
      isPopularDomain
      organizationName
      displayName
      domain
    }
  }
`;

/**
 * __useCreateEmailVerificationCodeMutation__
 *
 * To run a mutation, you first call `useCreateEmailVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailVerificationCodeMutation, { data, loading, error }] = useCreateEmailVerificationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailVerificationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEmailVerificationCodeMutation,
    CreateEmailVerificationCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateEmailVerificationCodeMutation,
    CreateEmailVerificationCodeMutationVariables
  >(CreateEmailVerificationCodeDocument, options);
}
export type CreateEmailVerificationCodeMutationHookResult = ReturnType<
  typeof useCreateEmailVerificationCodeMutation
>;
export type CreateEmailVerificationCodeMutationResult =
  Apollo.MutationResult<CreateEmailVerificationCodeMutation>;
export type CreateEmailVerificationCodeMutationOptions =
  Apollo.BaseMutationOptions<
    CreateEmailVerificationCodeMutation,
    CreateEmailVerificationCodeMutationVariables
  >;
export const VerifyEmailVerificationCodeDocument = gql`
  mutation verifyEmailVerificationCode(
    $email: String!
    $emailVerificationCode: String!
    $fromOrganizationCreation: Boolean
    $fromSuper: Boolean
  ) {
    verifyEmailVerificationCode(
      email: $email
      emailVerificationCode: $emailVerificationCode
      fromOrganizationCreation: $fromOrganizationCreation
      fromSuper: $fromSuper
    )
  }
`;

/**
 * __useVerifyEmailVerificationCodeMutation__
 *
 * To run a mutation, you first call `useVerifyEmailVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailVerificationCodeMutation, { data, loading, error }] = useVerifyEmailVerificationCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      emailVerificationCode: // value for 'emailVerificationCode'
 *      fromOrganizationCreation: // value for 'fromOrganizationCreation'
 *      fromSuper: // value for 'fromSuper'
 *   },
 * });
 */
export function useVerifyEmailVerificationCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyEmailVerificationCodeMutation,
    VerifyEmailVerificationCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    VerifyEmailVerificationCodeMutation,
    VerifyEmailVerificationCodeMutationVariables
  >(VerifyEmailVerificationCodeDocument, options);
}
export type VerifyEmailVerificationCodeMutationHookResult = ReturnType<
  typeof useVerifyEmailVerificationCodeMutation
>;
export type VerifyEmailVerificationCodeMutationResult =
  Apollo.MutationResult<VerifyEmailVerificationCodeMutation>;
export type VerifyEmailVerificationCodeMutationOptions =
  Apollo.BaseMutationOptions<
    VerifyEmailVerificationCodeMutation,
    VerifyEmailVerificationCodeMutationVariables
  >;
export const StartsBoardingAbExperimentsDocument = gql`
  mutation startsBoardingABExperiments($anonymousId: String) {
    startsBoardingABExperiments(input: { anonymousId: $anonymousId }) {
      anonymousId
      startedABExperiments {
        abFlagId
        variant
      }
    }
  }
`;

/**
 * __useStartsBoardingAbExperimentsMutation__
 *
 * To run a mutation, you first call `useStartsBoardingAbExperimentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartsBoardingAbExperimentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startsBoardingAbExperimentsMutation, { data, loading, error }] = useStartsBoardingAbExperimentsMutation({
 *   variables: {
 *      anonymousId: // value for 'anonymousId'
 *   },
 * });
 */
export function useStartsBoardingAbExperimentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartsBoardingAbExperimentsMutation,
    StartsBoardingAbExperimentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartsBoardingAbExperimentsMutation,
    StartsBoardingAbExperimentsMutationVariables
  >(StartsBoardingAbExperimentsDocument, options);
}
export type StartsBoardingAbExperimentsMutationHookResult = ReturnType<
  typeof useStartsBoardingAbExperimentsMutation
>;
export type StartsBoardingAbExperimentsMutationResult =
  Apollo.MutationResult<StartsBoardingAbExperimentsMutation>;
export type StartsBoardingAbExperimentsMutationOptions =
  Apollo.BaseMutationOptions<
    StartsBoardingAbExperimentsMutation,
    StartsBoardingAbExperimentsMutationVariables
  >;
export const ShowJoinableOrganizationsDocument = gql`
  query showJoinableOrganizations {
    showJoinableOrganizations {
      organization {
        id
        name
        photoURL
        domain
      }
      url
    }
  }
`;

/**
 * __useShowJoinableOrganizationsQuery__
 *
 * To run a query within a React component, call `useShowJoinableOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowJoinableOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowJoinableOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowJoinableOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ShowJoinableOrganizationsQuery,
    ShowJoinableOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShowJoinableOrganizationsQuery,
    ShowJoinableOrganizationsQueryVariables
  >(ShowJoinableOrganizationsDocument, options);
}
export function useShowJoinableOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShowJoinableOrganizationsQuery,
    ShowJoinableOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShowJoinableOrganizationsQuery,
    ShowJoinableOrganizationsQueryVariables
  >(ShowJoinableOrganizationsDocument, options);
}
export function useShowJoinableOrganizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ShowJoinableOrganizationsQuery,
    ShowJoinableOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShowJoinableOrganizationsQuery,
    ShowJoinableOrganizationsQueryVariables
  >(ShowJoinableOrganizationsDocument, options);
}
export type ShowJoinableOrganizationsQueryHookResult = ReturnType<
  typeof useShowJoinableOrganizationsQuery
>;
export type ShowJoinableOrganizationsLazyQueryHookResult = ReturnType<
  typeof useShowJoinableOrganizationsLazyQuery
>;
export type ShowJoinableOrganizationsSuspenseQueryHookResult = ReturnType<
  typeof useShowJoinableOrganizationsSuspenseQuery
>;
export type ShowJoinableOrganizationsQueryResult = Apollo.QueryResult<
  ShowJoinableOrganizationsQuery,
  ShowJoinableOrganizationsQueryVariables
>;
export const ShowJoinedOrganizationsDocument = gql`
  query showJoinedOrganizations {
    showJoinedOrganizations {
      id
      name
      photoURL
      domain
    }
  }
`;

/**
 * __useShowJoinedOrganizationsQuery__
 *
 * To run a query within a React component, call `useShowJoinedOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowJoinedOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowJoinedOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowJoinedOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ShowJoinedOrganizationsQuery,
    ShowJoinedOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShowJoinedOrganizationsQuery,
    ShowJoinedOrganizationsQueryVariables
  >(ShowJoinedOrganizationsDocument, options);
}
export function useShowJoinedOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShowJoinedOrganizationsQuery,
    ShowJoinedOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShowJoinedOrganizationsQuery,
    ShowJoinedOrganizationsQueryVariables
  >(ShowJoinedOrganizationsDocument, options);
}
export function useShowJoinedOrganizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ShowJoinedOrganizationsQuery,
    ShowJoinedOrganizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShowJoinedOrganizationsQuery,
    ShowJoinedOrganizationsQueryVariables
  >(ShowJoinedOrganizationsDocument, options);
}
export type ShowJoinedOrganizationsQueryHookResult = ReturnType<
  typeof useShowJoinedOrganizationsQuery
>;
export type ShowJoinedOrganizationsLazyQueryHookResult = ReturnType<
  typeof useShowJoinedOrganizationsLazyQuery
>;
export type ShowJoinedOrganizationsSuspenseQueryHookResult = ReturnType<
  typeof useShowJoinedOrganizationsSuspenseQuery
>;
export type ShowJoinedOrganizationsQueryResult = Apollo.QueryResult<
  ShowJoinedOrganizationsQuery,
  ShowJoinedOrganizationsQueryVariables
>;
export const ShowPublicOrganizationDocument = gql`
  query showPublicOrganization($domain: String!) {
    showPublicOrganization(domain: $domain) {
      id
      domain
      name
    }
  }
`;

/**
 * __useShowPublicOrganizationQuery__
 *
 * To run a query within a React component, call `useShowPublicOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowPublicOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowPublicOrganizationQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useShowPublicOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShowPublicOrganizationQuery,
    ShowPublicOrganizationQueryVariables
  > &
    (
      | { variables: ShowPublicOrganizationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShowPublicOrganizationQuery,
    ShowPublicOrganizationQueryVariables
  >(ShowPublicOrganizationDocument, options);
}
export function useShowPublicOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShowPublicOrganizationQuery,
    ShowPublicOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShowPublicOrganizationQuery,
    ShowPublicOrganizationQueryVariables
  >(ShowPublicOrganizationDocument, options);
}
export function useShowPublicOrganizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ShowPublicOrganizationQuery,
    ShowPublicOrganizationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ShowPublicOrganizationQuery,
    ShowPublicOrganizationQueryVariables
  >(ShowPublicOrganizationDocument, options);
}
export type ShowPublicOrganizationQueryHookResult = ReturnType<
  typeof useShowPublicOrganizationQuery
>;
export type ShowPublicOrganizationLazyQueryHookResult = ReturnType<
  typeof useShowPublicOrganizationLazyQuery
>;
export type ShowPublicOrganizationSuspenseQueryHookResult = ReturnType<
  typeof useShowPublicOrganizationSuspenseQuery
>;
export type ShowPublicOrganizationQueryResult = Apollo.QueryResult<
  ShowPublicOrganizationQuery,
  ShowPublicOrganizationQueryVariables
>;
